webpackJsonp([159264293819137],{

/***/ 245:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _indexConcepts = __webpack_require__(452);
	
	var _indexConcepts2 = _interopRequireDefault(_indexConcepts);
	
	var _layoutIndexConcepts = __webpack_require__(245);
	
	var _layoutIndexConcepts2 = _interopRequireDefault(_layoutIndexConcepts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_indexConcepts2.default, _extends({}, props, _layoutIndexConcepts2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * auth0-js v9.8.2
	 * Author: Auth0
	 * Date: 2018-11-13
	 * License: MIT
	 */
	
	!function(global,factory){ true?factory(exports):"function"==typeof define&&define.amd?define(["exports"],factory):factory(global.auth0={})}(this,function(exports){"use strict";var commonjsGlobal="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function createCommonjsModule(fn,module){return fn(module={exports:{}},module.exports),module.exports}var urlJoin=createCommonjsModule(function(module){var context,definition;context=commonjsGlobal,definition=function(){return function(){return function(strArray){var resultArray=[];if(strArray[0].match(/^[^\/:]+:\/*$/)&&strArray.length>1){var first=strArray.shift();strArray[0]=first+strArray[0]}strArray[0].match(/^file:\/\/\//)?strArray[0]=strArray[0].replace(/^([^\/:]+):\/*/,"$1:///"):strArray[0]=strArray[0].replace(/^([^\/:]+):\/*/,"$1://");for(var i=0;i<strArray.length;i++){var component=strArray[i];if("string"!=typeof component)throw new TypeError("Url must be a string. Received "+component);""!==component&&(i>0&&(component=component.replace(/^[\/]+/,"")),component=i<strArray.length-1?component.replace(/[\/]+$/,""):component.replace(/[\/]+$/,"/"),resultArray.push(component))}var str=resultArray.join("/"),parts=(str=str.replace(/\/(\?|&|#[^!])/g,"$1")).split("?");return str=parts.shift()+(parts.length>0?"?":"")+parts.join("&")}("object"==typeof arguments[0]?arguments[0]:[].slice.call(arguments))}},module.exports?module.exports=definition():context.urljoin=definition()}),utils=createCommonjsModule(function(module,exports){var has=Object.prototype.hasOwnProperty,hexTable=function(){for(var array=[],i=0;i<256;++i)array.push("%"+((i<16?"0":"")+i.toString(16)).toUpperCase());return array}();exports.arrayToObject=function(source,options){for(var obj=options&&options.plainObjects?Object.create(null):{},i=0;i<source.length;++i)void 0!==source[i]&&(obj[i]=source[i]);return obj},exports.merge=function(target,source,options){if(!source)return target;if("object"!=typeof source){if(Array.isArray(target))target.push(source);else{if("object"!=typeof target)return[target,source];(options.plainObjects||options.allowPrototypes||!has.call(Object.prototype,source))&&(target[source]=!0)}return target}if("object"!=typeof target)return[target].concat(source);var mergeTarget=target;return Array.isArray(target)&&!Array.isArray(source)&&(mergeTarget=exports.arrayToObject(target,options)),Array.isArray(target)&&Array.isArray(source)?(source.forEach(function(item,i){has.call(target,i)?target[i]&&"object"==typeof target[i]?target[i]=exports.merge(target[i],item,options):target.push(item):target[i]=item}),target):Object.keys(source).reduce(function(acc,key){var value=source[key];return Object.prototype.hasOwnProperty.call(acc,key)?acc[key]=exports.merge(acc[key],value,options):acc[key]=value,acc},mergeTarget)},exports.decode=function(str){try{return decodeURIComponent(str.replace(/\+/g," "))}catch(e){return str}},exports.encode=function(str){if(0===str.length)return str;for(var string="string"==typeof str?str:String(str),out="",i=0;i<string.length;++i){var c=string.charCodeAt(i);45===c||46===c||95===c||126===c||c>=48&&c<=57||c>=65&&c<=90||c>=97&&c<=122?out+=string.charAt(i):c<128?out+=hexTable[c]:c<2048?out+=hexTable[192|c>>6]+hexTable[128|63&c]:c<55296||c>=57344?out+=hexTable[224|c>>12]+hexTable[128|c>>6&63]+hexTable[128|63&c]:(i+=1,c=65536+((1023&c)<<10|1023&string.charCodeAt(i)),out+=hexTable[240|c>>18]+hexTable[128|c>>12&63]+hexTable[128|c>>6&63]+hexTable[128|63&c])}return out},exports.compact=function(obj,references){if("object"!=typeof obj||null===obj)return obj;var refs=references||[],lookup=refs.indexOf(obj);if(-1!==lookup)return refs[lookup];if(refs.push(obj),Array.isArray(obj)){for(var compacted=[],i=0;i<obj.length;++i)obj[i]&&"object"==typeof obj[i]?compacted.push(exports.compact(obj[i],refs)):void 0!==obj[i]&&compacted.push(obj[i]);return compacted}return Object.keys(obj).forEach(function(key){obj[key]=exports.compact(obj[key],refs)}),obj},exports.isRegExp=function(obj){return"[object RegExp]"===Object.prototype.toString.call(obj)},exports.isBuffer=function(obj){return null!=obj&&!!(obj.constructor&&obj.constructor.isBuffer&&obj.constructor.isBuffer(obj))}}),replace=(utils.arrayToObject,utils.merge,utils.decode,utils.encode,utils.compact,utils.isRegExp,utils.isBuffer,String.prototype.replace),percentTwenties=/%20/g,formats={default:"RFC3986",formatters:{RFC1738:function(value){return replace.call(value,percentTwenties,"+")},RFC3986:function(value){return value}},RFC1738:"RFC1738",RFC3986:"RFC3986"},arrayPrefixGenerators={brackets:function(prefix){return prefix+"[]"},indices:function(prefix,key){return prefix+"["+key+"]"},repeat:function(prefix){return prefix}},toISO=Date.prototype.toISOString,defaults={delimiter:"&",encode:!0,encoder:utils.encode,encodeValuesOnly:!1,serializeDate:function(date){return toISO.call(date)},skipNulls:!1,strictNullHandling:!1},stringify=function stringify(object,prefix,generateArrayPrefix,strictNullHandling,skipNulls,encoder,filter,sort,allowDots,serializeDate,formatter,encodeValuesOnly){var obj=object;if("function"==typeof filter)obj=filter(prefix,obj);else if(obj instanceof Date)obj=serializeDate(obj);else if(null===obj){if(strictNullHandling)return encoder&&!encodeValuesOnly?encoder(prefix):prefix;obj=""}if("string"==typeof obj||"number"==typeof obj||"boolean"==typeof obj||utils.isBuffer(obj))return encoder?[formatter(encodeValuesOnly?prefix:encoder(prefix))+"="+formatter(encoder(obj))]:[formatter(prefix)+"="+formatter(String(obj))];var objKeys,values=[];if(void 0===obj)return values;if(Array.isArray(filter))objKeys=filter;else{var keys=Object.keys(obj);objKeys=sort?keys.sort(sort):keys}for(var i=0;i<objKeys.length;++i){var key=objKeys[i];skipNulls&&null===obj[key]||(values=Array.isArray(obj)?values.concat(stringify(obj[key],generateArrayPrefix(prefix,key),generateArrayPrefix,strictNullHandling,skipNulls,encoder,filter,sort,allowDots,serializeDate,formatter,encodeValuesOnly)):values.concat(stringify(obj[key],prefix+(allowDots?"."+key:"["+key+"]"),generateArrayPrefix,strictNullHandling,skipNulls,encoder,filter,sort,allowDots,serializeDate,formatter,encodeValuesOnly)))}return values},has=Object.prototype.hasOwnProperty,defaults$1={allowDots:!1,allowPrototypes:!1,arrayLimit:20,decoder:utils.decode,delimiter:"&",depth:5,parameterLimit:1e3,plainObjects:!1,strictNullHandling:!1},parseObject=function(chain,val,options){if(!chain.length)return val;var obj,root=chain.shift();if("[]"===root)obj=(obj=[]).concat(parseObject(chain,val,options));else{obj=options.plainObjects?Object.create(null):{};var cleanRoot="["===root.charAt(0)&&"]"===root.charAt(root.length-1)?root.slice(1,-1):root,index=parseInt(cleanRoot,10);!isNaN(index)&&root!==cleanRoot&&String(index)===cleanRoot&&index>=0&&options.parseArrays&&index<=options.arrayLimit?(obj=[])[index]=parseObject(chain,val,options):obj[cleanRoot]=parseObject(chain,val,options)}return obj},parseKeys=function(givenKey,val,options){if(givenKey){var key=options.allowDots?givenKey.replace(/\.([^.[]+)/g,"[$1]"):givenKey,child=/(\[[^[\]]*])/g,segment=/(\[[^[\]]*])/.exec(key),parent=segment?key.slice(0,segment.index):key,keys=[];if(parent){if(!options.plainObjects&&has.call(Object.prototype,parent)&&!options.allowPrototypes)return;keys.push(parent)}for(var i=0;null!==(segment=child.exec(key))&&i<options.depth;){if(i+=1,!options.plainObjects&&has.call(Object.prototype,segment[1].slice(1,-1))&&!options.allowPrototypes)return;keys.push(segment[1])}return segment&&keys.push("["+key.slice(segment.index)+"]"),parseObject(keys,val,options)}},lib_parse=function(str,opts){var options=opts||{};if(null!==options.decoder&&void 0!==options.decoder&&"function"!=typeof options.decoder)throw new TypeError("Decoder has to be a function.");if(options.delimiter="string"==typeof options.delimiter||utils.isRegExp(options.delimiter)?options.delimiter:defaults$1.delimiter,options.depth="number"==typeof options.depth?options.depth:defaults$1.depth,options.arrayLimit="number"==typeof options.arrayLimit?options.arrayLimit:defaults$1.arrayLimit,options.parseArrays=!1!==options.parseArrays,options.decoder="function"==typeof options.decoder?options.decoder:defaults$1.decoder,options.allowDots="boolean"==typeof options.allowDots?options.allowDots:defaults$1.allowDots,options.plainObjects="boolean"==typeof options.plainObjects?options.plainObjects:defaults$1.plainObjects,options.allowPrototypes="boolean"==typeof options.allowPrototypes?options.allowPrototypes:defaults$1.allowPrototypes,options.parameterLimit="number"==typeof options.parameterLimit?options.parameterLimit:defaults$1.parameterLimit,options.strictNullHandling="boolean"==typeof options.strictNullHandling?options.strictNullHandling:defaults$1.strictNullHandling,""===str||null==str)return options.plainObjects?Object.create(null):{};for(var tempObj="string"==typeof str?function(str,options){for(var obj={},parts=str.split(options.delimiter,options.parameterLimit===1/0?void 0:options.parameterLimit),i=0;i<parts.length;++i){var key,val,part=parts[i],pos=-1===part.indexOf("]=")?part.indexOf("="):part.indexOf("]=")+1;-1===pos?(key=options.decoder(part),val=options.strictNullHandling?null:""):(key=options.decoder(part.slice(0,pos)),val=options.decoder(part.slice(pos+1))),has.call(obj,key)?obj[key]=[].concat(obj[key]).concat(val):obj[key]=val}return obj}(str,options):str,obj=options.plainObjects?Object.create(null):{},keys=Object.keys(tempObj),i=0;i<keys.length;++i){var key=keys[i],newObj=parseKeys(key,tempObj[key],options);obj=utils.merge(obj,newObj,options)}return utils.compact(obj)},lib_stringify=function(object,opts){var obj=object,options=opts||{};if(null!==options.encoder&&void 0!==options.encoder&&"function"!=typeof options.encoder)throw new TypeError("Encoder has to be a function.");var delimiter=void 0===options.delimiter?defaults.delimiter:options.delimiter,strictNullHandling="boolean"==typeof options.strictNullHandling?options.strictNullHandling:defaults.strictNullHandling,skipNulls="boolean"==typeof options.skipNulls?options.skipNulls:defaults.skipNulls,encode="boolean"==typeof options.encode?options.encode:defaults.encode,encoder="function"==typeof options.encoder?options.encoder:defaults.encoder,sort="function"==typeof options.sort?options.sort:null,allowDots=void 0!==options.allowDots&&options.allowDots,serializeDate="function"==typeof options.serializeDate?options.serializeDate:defaults.serializeDate,encodeValuesOnly="boolean"==typeof options.encodeValuesOnly?options.encodeValuesOnly:defaults.encodeValuesOnly;if(void 0===options.format)options.format=formats.default;else if(!Object.prototype.hasOwnProperty.call(formats.formatters,options.format))throw new TypeError("Unknown format option provided.");var objKeys,filter,formatter=formats.formatters[options.format];"function"==typeof options.filter?obj=(filter=options.filter)("",obj):Array.isArray(options.filter)&&(objKeys=filter=options.filter);var arrayFormat,keys=[];if("object"!=typeof obj||null===obj)return"";arrayFormat=options.arrayFormat in arrayPrefixGenerators?options.arrayFormat:"indices"in options?options.indices?"indices":"repeat":"indices";var generateArrayPrefix=arrayPrefixGenerators[arrayFormat];objKeys||(objKeys=Object.keys(obj)),sort&&objKeys.sort(sort);for(var i=0;i<objKeys.length;++i){var key=objKeys[i];skipNulls&&null===obj[key]||(keys=keys.concat(stringify(obj[key],key,generateArrayPrefix,strictNullHandling,skipNulls,encode?encoder:null,filter,sort,allowDots,serializeDate,formatter,encodeValuesOnly)))}return keys.join(delimiter)},componentEmitter=createCommonjsModule(function(module){function Emitter(obj){if(obj)return function(obj){for(var key in Emitter.prototype)obj[key]=Emitter.prototype[key];return obj}(obj)}module.exports=Emitter,Emitter.prototype.on=Emitter.prototype.addEventListener=function(event,fn){return this._callbacks=this._callbacks||{},(this._callbacks["$"+event]=this._callbacks["$"+event]||[]).push(fn),this},Emitter.prototype.once=function(event,fn){function on(){this.off(event,on),fn.apply(this,arguments)}return on.fn=fn,this.on(event,on),this},Emitter.prototype.off=Emitter.prototype.removeListener=Emitter.prototype.removeAllListeners=Emitter.prototype.removeEventListener=function(event,fn){if(this._callbacks=this._callbacks||{},0==arguments.length)return this._callbacks={},this;var cb,callbacks=this._callbacks["$"+event];if(!callbacks)return this;if(1==arguments.length)return delete this._callbacks["$"+event],this;for(var i=0;i<callbacks.length;i++)if((cb=callbacks[i])===fn||cb.fn===fn){callbacks.splice(i,1);break}return this},Emitter.prototype.emit=function(event){this._callbacks=this._callbacks||{};var args=[].slice.call(arguments,1),callbacks=this._callbacks["$"+event];if(callbacks)for(var i=0,len=(callbacks=callbacks.slice(0)).length;i<len;++i)callbacks[i].apply(this,args);return this},Emitter.prototype.listeners=function(event){return this._callbacks=this._callbacks||{},this._callbacks["$"+event]||[]},Emitter.prototype.hasListeners=function(event){return!!this.listeners(event).length}});var isObject_1=function(obj){return null!==obj&&"object"==typeof obj},requestBase=RequestBase;function RequestBase(obj){if(obj)return function(obj){for(var key in RequestBase.prototype)obj[key]=RequestBase.prototype[key];return obj}(obj)}RequestBase.prototype.clearTimeout=function(){return clearTimeout(this._timer),clearTimeout(this._responseTimeoutTimer),delete this._timer,delete this._responseTimeoutTimer,this},RequestBase.prototype.parse=function(fn){return this._parser=fn,this},RequestBase.prototype.responseType=function(val){return this._responseType=val,this},RequestBase.prototype.serialize=function(fn){return this._serializer=fn,this},RequestBase.prototype.timeout=function(options){if(!options||"object"!=typeof options)return this._timeout=options,this._responseTimeout=0,this;for(var option in options)switch(option){case"deadline":this._timeout=options.deadline;break;case"response":this._responseTimeout=options.response;break;default:console.warn("Unknown timeout option",option)}return this},RequestBase.prototype.retry=function(count,fn){return 0!==arguments.length&&!0!==count||(count=1),count<=0&&(count=0),this._maxRetries=count,this._retries=0,this._retryCallback=fn,this};var ERROR_CODES=["ECONNRESET","ETIMEDOUT","EADDRINFO","ESOCKETTIMEDOUT"];RequestBase.prototype._shouldRetry=function(err,res){if(!this._maxRetries||this._retries++>=this._maxRetries)return!1;if(this._retryCallback)try{var override=this._retryCallback(err,res);if(!0===override)return!0;if(!1===override)return!1}catch(e){console.error(e)}if(res&&res.status&&res.status>=500&&501!=res.status)return!0;if(err){if(err.code&&~ERROR_CODES.indexOf(err.code))return!0;if(err.timeout&&"ECONNABORTED"==err.code)return!0;if(err.crossDomain)return!0}return!1},RequestBase.prototype._retry=function(){return this.clearTimeout(),this.req&&(this.req=null,this.req=this.request()),this._aborted=!1,this.timedout=!1,this._end()},RequestBase.prototype.then=function(resolve,reject){if(!this._fullfilledPromise){var self=this;this._endCalled&&console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"),this._fullfilledPromise=new Promise(function(innerResolve,innerReject){self.end(function(err,res){err?innerReject(err):innerResolve(res)})})}return this._fullfilledPromise.then(resolve,reject)},RequestBase.prototype.catch=function(cb){return this.then(void 0,cb)},RequestBase.prototype.use=function(fn){return fn(this),this},RequestBase.prototype.ok=function(cb){if("function"!=typeof cb)throw Error("Callback required");return this._okCallback=cb,this},RequestBase.prototype._isResponseOK=function(res){return!!res&&(this._okCallback?this._okCallback(res):res.status>=200&&res.status<300)},RequestBase.prototype.get=function(field){return this._header[field.toLowerCase()]},RequestBase.prototype.getHeader=RequestBase.prototype.get,RequestBase.prototype.set=function(field,val){if(isObject_1(field)){for(var key in field)this.set(key,field[key]);return this}return this._header[field.toLowerCase()]=val,this.header[field]=val,this},RequestBase.prototype.unset=function(field){return delete this._header[field.toLowerCase()],delete this.header[field],this},RequestBase.prototype.field=function(name,val){if(null==name)throw new Error(".field(name, val) name can not be empty");if(this._data&&console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()"),isObject_1(name)){for(var key in name)this.field(key,name[key]);return this}if(Array.isArray(val)){for(var i in val)this.field(name,val[i]);return this}if(null==val)throw new Error(".field(name, val) val can not be empty");return"boolean"==typeof val&&(val=""+val),this._getFormData().append(name,val),this},RequestBase.prototype.abort=function(){return this._aborted?this:(this._aborted=!0,this.xhr&&this.xhr.abort(),this.req&&this.req.abort(),this.clearTimeout(),this.emit("abort"),this)},RequestBase.prototype._auth=function(user,pass,options,base64Encoder){switch(options.type){case"basic":this.set("Authorization","Basic "+base64Encoder(user+":"+pass));break;case"auto":this.username=user,this.password=pass;break;case"bearer":this.set("Authorization","Bearer "+user)}return this},RequestBase.prototype.withCredentials=function(on){return null==on&&(on=!0),this._withCredentials=on,this},RequestBase.prototype.redirects=function(n){return this._maxRedirects=n,this},RequestBase.prototype.maxResponseSize=function(n){if("number"!=typeof n)throw TypeError("Invalid argument");return this._maxResponseSize=n,this},RequestBase.prototype.toJSON=function(){return{method:this.method,url:this.url,data:this._data,headers:this._header}},RequestBase.prototype.send=function(data){var isObj=isObject_1(data),type=this._header["content-type"];if(this._formData&&console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()"),isObj&&!this._data)Array.isArray(data)?this._data=[]:this._isHost(data)||(this._data={});else if(data&&this._data&&this._isHost(this._data))throw Error("Can't merge these send calls");if(isObj&&isObject_1(this._data))for(var key in data)this._data[key]=data[key];else"string"==typeof data?(type||this.type("form"),type=this._header["content-type"],this._data="application/x-www-form-urlencoded"==type?this._data?this._data+"&"+data:data:(this._data||"")+data):this._data=data;return!isObj||this._isHost(data)?this:(type||this.type("json"),this)},RequestBase.prototype.sortQuery=function(sort){return this._sort=void 0===sort||sort,this},RequestBase.prototype._finalizeQueryString=function(){var query=this._query.join("&");if(query&&(this.url+=(this.url.indexOf("?")>=0?"&":"?")+query),this._query.length=0,this._sort){var index=this.url.indexOf("?");if(index>=0){var queryArr=this.url.substring(index+1).split("&");"function"==typeof this._sort?queryArr.sort(this._sort):queryArr.sort(),this.url=this.url.substring(0,index)+"?"+queryArr.join("&")}}},RequestBase.prototype._appendQueryString=function(){console.trace("Unsupported")},RequestBase.prototype._timeoutError=function(reason,timeout,errno){if(!this._aborted){var err=new Error(reason+timeout+"ms exceeded");err.timeout=timeout,err.code="ECONNABORTED",err.errno=errno,this.timedout=!0,this.abort(),this.callback(err)}},RequestBase.prototype._setTimeouts=function(){var self=this;this._timeout&&!this._timer&&(this._timer=setTimeout(function(){self._timeoutError("Timeout of ",self._timeout,"ETIME")},this._timeout)),this._responseTimeout&&!this._responseTimeoutTimer&&(this._responseTimeoutTimer=setTimeout(function(){self._timeoutError("Response timeout of ",self._responseTimeout,"ETIMEDOUT")},this._responseTimeout))};var utils$1_type=function(str){return str.split(/ *; */).shift()},utils$1_params=function(str){return str.split(/ *; */).reduce(function(obj,str){var parts=str.split(/ *= */),key=parts.shift(),val=parts.shift();return key&&val&&(obj[key]=val),obj},{})},utils$1_parseLinks=function(str){return str.split(/ *, */).reduce(function(obj,str){var parts=str.split(/ *; */),url=parts[0].slice(1,-1);return obj[parts[1].split(/ *= */)[1].slice(1,-1)]=url,obj},{})},responseBase=ResponseBase;function ResponseBase(obj){if(obj)return function(obj){for(var key in ResponseBase.prototype)obj[key]=ResponseBase.prototype[key];return obj}(obj)}function Agent(){this._defaults=[]}ResponseBase.prototype.get=function(field){return this.header[field.toLowerCase()]},ResponseBase.prototype._setHeaderProperties=function(header){var ct=header["content-type"]||"";this.type=utils$1_type(ct);var params=utils$1_params(ct);for(var key in params)this[key]=params[key];this.links={};try{header.link&&(this.links=utils$1_parseLinks(header.link))}catch(err){}},ResponseBase.prototype._setStatusProperties=function(status){var type=status/100|0;this.status=this.statusCode=status,this.statusType=type,this.info=1==type,this.ok=2==type,this.redirect=3==type,this.clientError=4==type,this.serverError=5==type,this.error=(4==type||5==type)&&this.toError(),this.accepted=202==status,this.noContent=204==status,this.badRequest=400==status,this.unauthorized=401==status,this.notAcceptable=406==status,this.forbidden=403==status,this.notFound=404==status},["use","on","once","set","query","type","accept","auth","withCredentials","sortQuery","retry","ok","redirects","timeout","buffer","serialize","parse","ca","key","pfx","cert"].forEach(function(fn){Agent.prototype[fn]=function(){return this._defaults.push({fn:fn,arguments:arguments}),this}}),Agent.prototype._setDefaults=function(req){this._defaults.forEach(function(def){req[def.fn].apply(req,def.arguments)})};for(var agentBase=Agent,client=createCommonjsModule(function(module,exports){var root;function noop(){}"undefined"!=typeof window?root=window:"undefined"!=typeof self?root=self:(console.warn("Using browser-only version of superagent in non-browser environment"),root=commonjsGlobal);var request=exports=module.exports=function(method,url){return"function"==typeof url?new exports.Request("GET",method).end(url):1==arguments.length?new exports.Request("GET",method):new exports.Request(method,url)};exports.Request=Request,request.getXHR=function(){if(!(!root.XMLHttpRequest||root.location&&"file:"==root.location.protocol&&root.ActiveXObject))return new XMLHttpRequest;try{return new ActiveXObject("Microsoft.XMLHTTP")}catch(e){}try{return new ActiveXObject("Msxml2.XMLHTTP.6.0")}catch(e){}try{return new ActiveXObject("Msxml2.XMLHTTP.3.0")}catch(e){}try{return new ActiveXObject("Msxml2.XMLHTTP")}catch(e){}throw Error("Browser-only version of superagent could not find XHR")};var trim="".trim?function(s){return s.trim()}:function(s){return s.replace(/(^\s*|\s*$)/g,"")};function serialize(obj){if(!isObject_1(obj))return obj;var pairs=[];for(var key in obj)pushEncodedKeyValuePair(pairs,key,obj[key]);return pairs.join("&")}function pushEncodedKeyValuePair(pairs,key,val){if(null!=val)if(Array.isArray(val))val.forEach(function(v){pushEncodedKeyValuePair(pairs,key,v)});else if(isObject_1(val))for(var subkey in val)pushEncodedKeyValuePair(pairs,key+"["+subkey+"]",val[subkey]);else pairs.push(encodeURIComponent(key)+"="+encodeURIComponent(val));else null===val&&pairs.push(encodeURIComponent(key))}function parseString(str){for(var pair,pos,obj={},pairs=str.split("&"),i=0,len=pairs.length;i<len;++i)-1==(pos=(pair=pairs[i]).indexOf("="))?obj[decodeURIComponent(pair)]="":obj[decodeURIComponent(pair.slice(0,pos))]=decodeURIComponent(pair.slice(pos+1));return obj}function isJSON(mime){return/[\/+]json($|[^-\w])/.test(mime)}function Response(req){this.req=req,this.xhr=this.req.xhr,this.text="HEAD"!=this.req.method&&(""===this.xhr.responseType||"text"===this.xhr.responseType)||void 0===this.xhr.responseType?this.xhr.responseText:null,this.statusText=this.req.xhr.statusText;var status=this.xhr.status;1223===status&&(status=204),this._setStatusProperties(status),this.header=this.headers=function(str){for(var index,line,field,val,lines=str.split(/\r?\n/),fields={},i=0,len=lines.length;i<len;++i)-1!==(index=(line=lines[i]).indexOf(":"))&&(field=line.slice(0,index).toLowerCase(),val=trim(line.slice(index+1)),fields[field]=val);return fields}(this.xhr.getAllResponseHeaders()),this.header["content-type"]=this.xhr.getResponseHeader("content-type"),this._setHeaderProperties(this.header),null===this.text&&req._responseType?this.body=this.xhr.response:this.body="HEAD"!=this.req.method?this._parseBody(this.text?this.text:this.xhr.response):null}function Request(method,url){var self=this;this._query=this._query||[],this.method=method,this.url=url,this.header={},this._header={},this.on("end",function(){var new_err,err=null,res=null;try{res=new Response(self)}catch(e){return(err=new Error("Parser is unable to parse the response")).parse=!0,err.original=e,self.xhr?(err.rawResponse=void 0===self.xhr.responseType?self.xhr.responseText:self.xhr.response,err.status=self.xhr.status?self.xhr.status:null,err.statusCode=err.status):(err.rawResponse=null,err.status=null),self.callback(err)}self.emit("response",res);try{self._isResponseOK(res)||(new_err=new Error(res.statusText||"Unsuccessful HTTP response"))}catch(custom_err){new_err=custom_err}new_err?(new_err.original=err,new_err.response=res,new_err.status=res.status,self.callback(new_err,res)):self.callback(null,res)})}function del(url,data,fn){var req=request("DELETE",url);return"function"==typeof data&&(fn=data,data=null),data&&req.send(data),fn&&req.end(fn),req}request.serializeObject=serialize,request.parseString=parseString,request.types={html:"text/html",json:"application/json",xml:"text/xml",urlencoded:"application/x-www-form-urlencoded",form:"application/x-www-form-urlencoded","form-data":"application/x-www-form-urlencoded"},request.serialize={"application/x-www-form-urlencoded":serialize,"application/json":JSON.stringify},request.parse={"application/x-www-form-urlencoded":parseString,"application/json":JSON.parse},responseBase(Response.prototype),Response.prototype._parseBody=function(str){var parse=request.parse[this.type];return this.req._parser?this.req._parser(this,str):(!parse&&isJSON(this.type)&&(parse=request.parse["application/json"]),parse&&str&&(str.length||str instanceof Object)?parse(str):null)},Response.prototype.toError=function(){var req=this.req,method=req.method,url=req.url,msg="cannot "+method+" "+url+" ("+this.status+")",err=new Error(msg);return err.status=this.status,err.method=method,err.url=url,err},request.Response=Response,componentEmitter(Request.prototype),requestBase(Request.prototype),Request.prototype.type=function(type){return this.set("Content-Type",request.types[type]||type),this},Request.prototype.accept=function(type){return this.set("Accept",request.types[type]||type),this},Request.prototype.auth=function(user,pass,options){1===arguments.length&&(pass=""),"object"==typeof pass&&null!==pass&&(options=pass,pass=""),options||(options={type:"function"==typeof btoa?"basic":"auto"});return this._auth(user,pass,options,function(string){if("function"==typeof btoa)return btoa(string);throw new Error("Cannot use basic auth, btoa is not a function")})},Request.prototype.query=function(val){return"string"!=typeof val&&(val=serialize(val)),val&&this._query.push(val),this},Request.prototype.attach=function(field,file,options){if(file){if(this._data)throw Error("superagent can't mix .send() and .attach()");this._getFormData().append(field,file,options||file.name)}return this},Request.prototype._getFormData=function(){return this._formData||(this._formData=new root.FormData),this._formData},Request.prototype.callback=function(err,res){if(this._shouldRetry(err,res))return this._retry();var fn=this._callback;this.clearTimeout(),err&&(this._maxRetries&&(err.retries=this._retries-1),this.emit("error",err)),fn(err,res)},Request.prototype.crossDomainError=function(){var err=new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");err.crossDomain=!0,err.status=this.status,err.method=this.method,err.url=this.url,this.callback(err)},Request.prototype.buffer=Request.prototype.ca=Request.prototype.agent=function(){return console.warn("This is not supported in browser version of superagent"),this},Request.prototype.pipe=Request.prototype.write=function(){throw Error("Streaming is not supported in browser version of superagent")},Request.prototype._isHost=function(obj){return obj&&"object"==typeof obj&&!Array.isArray(obj)&&"[object Object]"!==Object.prototype.toString.call(obj)},Request.prototype.end=function(fn){return this._endCalled&&console.warn("Warning: .end() was called twice. This is not supported in superagent"),this._endCalled=!0,this._callback=fn||noop,this._finalizeQueryString(),this._end()},Request.prototype._end=function(){var self=this,xhr=this.xhr=request.getXHR(),data=this._formData||this._data;this._setTimeouts(),xhr.onreadystatechange=function(){var readyState=xhr.readyState;if(readyState>=2&&self._responseTimeoutTimer&&clearTimeout(self._responseTimeoutTimer),4==readyState){var status;try{status=xhr.status}catch(e){status=0}if(!status){if(self.timedout||self._aborted)return;return self.crossDomainError()}self.emit("end")}};var handleProgress=function(direction,e){e.total>0&&(e.percent=e.loaded/e.total*100),e.direction=direction,self.emit("progress",e)};if(this.hasListeners("progress"))try{xhr.onprogress=handleProgress.bind(null,"download"),xhr.upload&&(xhr.upload.onprogress=handleProgress.bind(null,"upload"))}catch(e){}try{this.username&&this.password?xhr.open(this.method,this.url,!0,this.username,this.password):xhr.open(this.method,this.url,!0)}catch(err){return this.callback(err)}if(this._withCredentials&&(xhr.withCredentials=!0),!this._formData&&"GET"!=this.method&&"HEAD"!=this.method&&"string"!=typeof data&&!this._isHost(data)){var contentType=this._header["content-type"],serialize=this._serializer||request.serialize[contentType?contentType.split(";")[0]:""];!serialize&&isJSON(contentType)&&(serialize=request.serialize["application/json"]),serialize&&(data=serialize(data))}for(var field in this.header)null!=this.header[field]&&this.header.hasOwnProperty(field)&&xhr.setRequestHeader(field,this.header[field]);return this._responseType&&(xhr.responseType=this._responseType),this.emit("request",this),xhr.send(void 0!==data?data:null),this},request.agent=function(){return new agentBase},["GET","POST","OPTIONS","PATCH","PUT","DELETE"].forEach(function(method){agentBase.prototype[method.toLowerCase()]=function(url,fn){var req=new request.Request(method,url);return this._setDefaults(req),fn&&req.end(fn),req}}),agentBase.prototype.del=agentBase.prototype.delete,request.get=function(url,data,fn){var req=request("GET",url);return"function"==typeof data&&(fn=data,data=null),data&&req.query(data),fn&&req.end(fn),req},request.head=function(url,data,fn){var req=request("HEAD",url);return"function"==typeof data&&(fn=data,data=null),data&&req.query(data),fn&&req.end(fn),req},request.options=function(url,data,fn){var req=request("OPTIONS",url);return"function"==typeof data&&(fn=data,data=null),data&&req.send(data),fn&&req.end(fn),req},request.del=del,request.delete=del,request.patch=function(url,data,fn){var req=request("PATCH",url);return"function"==typeof data&&(fn=data,data=null),data&&req.send(data),fn&&req.end(fn),req},request.post=function(url,data,fn){var req=request("POST",url);return"function"==typeof data&&(fn=data,data=null),data&&req.send(data),fn&&req.end(fn),req},request.put=function(url,data,fn){var req=request("PUT",url);return"function"==typeof data&&(fn=data,data=null),data&&req.send(data),fn&&req.end(fn),req}}),byteLength_1=(client.Request,function(b64){return 3*b64.length/4-placeHoldersCount(b64)}),toByteArray_1=function(b64){var i,j,l,tmp,placeHolders,arr,len=b64.length;placeHolders=placeHoldersCount(b64),arr=new Arr(3*len/4-placeHolders),l=placeHolders>0?len-4:len;var L=0;for(i=0,j=0;i<l;i+=4,j+=3)tmp=revLookup[b64.charCodeAt(i)]<<18|revLookup[b64.charCodeAt(i+1)]<<12|revLookup[b64.charCodeAt(i+2)]<<6|revLookup[b64.charCodeAt(i+3)],arr[L++]=tmp>>16&255,arr[L++]=tmp>>8&255,arr[L++]=255&tmp;2===placeHolders?(tmp=revLookup[b64.charCodeAt(i)]<<2|revLookup[b64.charCodeAt(i+1)]>>4,arr[L++]=255&tmp):1===placeHolders&&(tmp=revLookup[b64.charCodeAt(i)]<<10|revLookup[b64.charCodeAt(i+1)]<<4|revLookup[b64.charCodeAt(i+2)]>>2,arr[L++]=tmp>>8&255,arr[L++]=255&tmp);return arr},fromByteArray_1=function(uint8){for(var tmp,len=uint8.length,extraBytes=len%3,output="",parts=[],i=0,len2=len-extraBytes;i<len2;i+=16383)parts.push(encodeChunk(uint8,i,i+16383>len2?len2:i+16383));1===extraBytes?(tmp=uint8[len-1],output+=lookup[tmp>>2],output+=lookup[tmp<<4&63],output+="=="):2===extraBytes&&(tmp=(uint8[len-2]<<8)+uint8[len-1],output+=lookup[tmp>>10],output+=lookup[tmp>>4&63],output+=lookup[tmp<<2&63],output+="=");return parts.push(output),parts.join("")},lookup=[],revLookup=[],Arr="undefined"!=typeof Uint8Array?Uint8Array:Array,code="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=0,len=code.length;i<len;++i)lookup[i]=code[i],revLookup[code.charCodeAt(i)]=i;function placeHoldersCount(b64){var len=b64.length;if(len%4>0)throw new Error("Invalid string. Length must be a multiple of 4");return"="===b64[len-2]?2:"="===b64[len-1]?1:0}function encodeChunk(uint8,start,end){for(var tmp,num,output=[],i=start;i<end;i+=3)tmp=(uint8[i]<<16)+(uint8[i+1]<<8)+uint8[i+2],output.push(lookup[(num=tmp)>>18&63]+lookup[num>>12&63]+lookup[num>>6&63]+lookup[63&num]);return output.join("")}revLookup["-".charCodeAt(0)]=62,revLookup["_".charCodeAt(0)]=63;var base64Js={byteLength:byteLength_1,toByteArray:toByteArray_1,fromByteArray:fromByteArray_1};var base64Url={encode:function(str){return base64Js.fromByteArray(function(str){for(var arr=new Array(str.length),a=0;a<str.length;a++)arr[a]=str.charCodeAt(a);return arr}(str)).replace(/\+/g,"-").replace(/\//g,"_")},decode:function(str){return str=function(str){var mod=str.length%4;return 0===mod?str:str+new Array(4-mod+1).join("=")}(str).replace(/-/g,"+").replace(/_/g,"/"),function(array){for(var result="",i=0;i<array.length;i++)result+=String.fromCharCode(array[i]);return result}(base64Js.toByteArray(str))}},version={raw:"9.8.2"};function RequestWrapper(req){this.request=req,this.method=req.method,this.url=req.url,this.body=req._data,this.headers=req._header}function RequestObj(req){this.request=req}function RequestBuilder(options){this._sendTelemetry=!1!==options._sendTelemetry||options._sendTelemetry,this._telemetryInfo=options._telemetryInfo||null,this._timesToRetryFailedRequests=options._timesToRetryFailedRequests,this.headers=options.headers||{}}RequestWrapper.prototype.abort=function(){this.request.abort()},RequestWrapper.prototype.getMethod=function(){return this.method},RequestWrapper.prototype.getBody=function(){return this.body},RequestWrapper.prototype.getUrl=function(){return this.url},RequestWrapper.prototype.getHeaders=function(){return this.headers},RequestObj.prototype.set=function(key,value){return this.request=this.request.set(key,value),this},RequestObj.prototype.send=function(body){return this.request=this.request.send(body),this},RequestObj.prototype.withCredentials=function(){return this.request=this.request.withCredentials(),this},RequestObj.prototype.end=function(cb){return this.request=this.request.end(cb),new RequestWrapper(this.request)},RequestBuilder.prototype.setCommonConfiguration=function(ongoingRequest,options){if(options=options||{},this._timesToRetryFailedRequests>0&&(ongoingRequest=ongoingRequest.retry(this._timesToRetryFailedRequests)),options.noHeaders)return ongoingRequest;var headers=this.headers;ongoingRequest=ongoingRequest.set("Content-Type","application/json");for(var keys=Object.keys(this.headers),a=0;a<keys.length;a++)ongoingRequest=ongoingRequest.set(keys[a],headers[keys[a]]);return this._sendTelemetry&&(ongoingRequest=ongoingRequest.set("Auth0-Client",this.getTelemetryData())),ongoingRequest},RequestBuilder.prototype.getTelemetryData=function(){var clientInfo=this._telemetryInfo||{name:"auth0.js",version:version.raw},jsonClientInfo=JSON.stringify(clientInfo);return base64Url.encode(jsonClientInfo)},RequestBuilder.prototype.get=function(url,options){return new RequestObj(this.setCommonConfiguration(client.get(url),options))},RequestBuilder.prototype.post=function(url,options){return new RequestObj(this.setCommonConfiguration(client.post(url),options))},RequestBuilder.prototype.patch=function(url,options){return new RequestObj(this.setCommonConfiguration(client.patch(url),options))};var toString=Object.prototype.toString;function attribute(o,attr,type,text){if(type="array"===type?"object":type,o&&typeof o[attr]!==type)throw new Error(text)}function variable(o,type,text){if(typeof o!==type)throw new Error(text)}function value(o,values,text){if(-1===values.indexOf(o))throw new Error(text)}var assert={check:function(o,config,attributes){if(config.optional&&!o||variable(o,config.type,config.message),"object"===config.type&&attributes)for(var keys=Object.keys(attributes),index=0;index<keys.length;index++){var a=keys[index];attributes[a].optional&&!o[a]||attributes[a].condition&&!attributes[a].condition(o)||(attribute(o,a,attributes[a].type,attributes[a].message),attributes[a].values&&value(o[a],attributes[a].values,attributes[a].value_message))}},attribute:attribute,variable:variable,value:value,isArray:function(array){return this.supportsIsArray()?Array.isArray(array):"[object Array]"===toString.call(array)},supportsIsArray:function(){return null!=Array.isArray}};function objectAssignPolyfill(target){if(null==target)throw new TypeError("Cannot convert first argument to object");for(var to=Object(target),i=1;i<arguments.length;i++){var nextSource=arguments[i];if(null!=nextSource)for(var keysArray=Object.keys(Object(nextSource)),nextIndex=0,len=keysArray.length;nextIndex<len;nextIndex++){var nextKey=keysArray[nextIndex],desc=Object.getOwnPropertyDescriptor(nextSource,nextKey);void 0!==desc&&desc.enumerable&&(to[nextKey]=nextSource[nextKey])}}return to}var objectAssign={get:function(){return Object.assign?Object.assign:objectAssignPolyfill},objectAssignPolyfill:objectAssignPolyfill};function pick(object,keys){return keys.reduce(function(prev,key){return object[key]&&(prev[key]=object[key]),prev},{})}function extend(){var params=function(obj){var values=[];for(var key in obj)values.push(obj[key]);return values}(arguments);return params.unshift({}),objectAssign.get().apply(void 0,params)}function getLocationFromUrl(href){var match=href.match(/^(https?:|file:)\/\/(([^:\/?#]*)(?::([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);return match&&{href:href,protocol:match[1],host:match[2],hostname:match[3],port:match[4],pathname:match[5],search:match[6],hash:match[7]}}var objectHelper={toSnakeCase:function toSnakeCase(object,exceptions){return"object"!=typeof object||assert.isArray(object)||null===object?object:(exceptions=exceptions||[],Object.keys(object).reduce(function(p,key){return p[-1===exceptions.indexOf(key)?function(str){for(var code,newKey="",index=0,wasPrevNumber=!0,wasPrevUppercase=!0;index<str.length;)code=str.charCodeAt(index),!wasPrevUppercase&&code>=65&&code<=90||!wasPrevNumber&&code>=48&&code<=57?(newKey+="_",newKey+=str[index].toLowerCase()):newKey+=str[index].toLowerCase(),wasPrevNumber=code>=48&&code<=57,wasPrevUppercase=code>=65&&code<=90,index++;return newKey}(key):key]=toSnakeCase(object[key]),p},{}))},toCamelCase:function toCamelCase(object,exceptions){return"object"!=typeof object||assert.isArray(object)||null===object?object:(exceptions=exceptions||[],Object.keys(object).reduce(function(p,key){var parts;return p[-1===exceptions.indexOf(key)?(parts=key.split("_")).reduce(function(p,c){return p+c.charAt(0).toUpperCase()+c.slice(1)},parts.shift()):key]=toCamelCase(object[key]),p},{}))},blacklist:function(object,blacklistedKeys){return Object.keys(object).reduce(function(p,key){return-1===blacklistedKeys.indexOf(key)&&(p[key]=object[key]),p},{})},merge:function(object,keys){return{base:keys?pick(object,keys):object,with:function(object2,keys2){return object2=keys2?pick(object2,keys2):object2,extend(this.base,object2)}}},pick:pick,getKeysNotIn:function(obj,allowedKeys){var notAllowed=[];for(var key in obj)-1===allowedKeys.indexOf(key)&&notAllowed.push(key);return notAllowed},extend:extend,getOriginFromUrl:function(url){if(url){var parsed=getLocationFromUrl(url),origin=parsed.protocol+"//"+parsed.hostname;return parsed.port&&(origin+=":"+parsed.port),origin}},getLocationFromUrl:getLocationFromUrl};function getWindow(){return window}var windowHandler={redirect:function(url){getWindow().location=url},getDocument:function(){return getWindow().document},getWindow:getWindow,getOrigin:function(){var location=getWindow().location,origin=location.origin;return origin||(origin=objectHelper.getOriginFromUrl(location.href)),origin}};function DummyStorage(){}DummyStorage.prototype.getItem=function(){return null},DummyStorage.prototype.removeItem=function(){},DummyStorage.prototype.setItem=function(){};var js_cookie=createCommonjsModule(function(module,exports){!function(factory){if(module.exports=factory(),!!0){var OldCookies=window.Cookies,api=window.Cookies=factory();api.noConflict=function(){return window.Cookies=OldCookies,api}}}(function(){function extend(){for(var i=0,result={};i<arguments.length;i++){var attributes=arguments[i];for(var key in attributes)result[key]=attributes[key]}return result}return function init(converter){function api(key,value,attributes){var result;if("undefined"!=typeof document){if(arguments.length>1){if("number"==typeof(attributes=extend({path:"/"},api.defaults,attributes)).expires){var expires=new Date;expires.setMilliseconds(expires.getMilliseconds()+864e5*attributes.expires),attributes.expires=expires}attributes.expires=attributes.expires?attributes.expires.toUTCString():"";try{result=JSON.stringify(value),/^[\{\[]/.test(result)&&(value=result)}catch(e){}value=converter.write?converter.write(value,key):encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),key=(key=(key=encodeURIComponent(String(key))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var stringifiedAttributes="";for(var attributeName in attributes)attributes[attributeName]&&(stringifiedAttributes+="; "+attributeName,!0!==attributes[attributeName]&&(stringifiedAttributes+="="+attributes[attributeName]));return document.cookie=key+"="+value+stringifiedAttributes}key||(result={});for(var cookies=document.cookie?document.cookie.split("; "):[],rdecode=/(%[0-9A-Z]{2})+/g,i=0;i<cookies.length;i++){var parts=cookies[i].split("="),cookie=parts.slice(1).join("=");this.json||'"'!==cookie.charAt(0)||(cookie=cookie.slice(1,-1));try{var name=parts[0].replace(rdecode,decodeURIComponent);if(cookie=converter.read?converter.read(cookie,name):converter(cookie,name)||cookie.replace(rdecode,decodeURIComponent),this.json)try{cookie=JSON.parse(cookie)}catch(e){}if(key===name){result=cookie;break}key||(result[name]=cookie)}catch(e){}}return result}}return api.set=api,api.get=function(key){return api.call(api,key)},api.getJSON=function(){return api.apply({json:!0},[].slice.call(arguments))},api.defaults={},api.remove=function(key,attributes){api(key,"",extend(attributes,{expires:-1}))},api.withConverter=init,api}(function(){})})});function CookieStorage(){}function Warn(options){this.disableWarnings=options.disableWarnings}function StorageHandler(options){if(this.warn=new Warn({}),this.storage=new CookieStorage,!0===options.__tryLocalStorageFirst)try{var localStorage=windowHandler.getWindow().localStorage;localStorage&&(this.storage=localStorage)}catch(e){this.warn.warning(e),this.warn.warning("Can't use localStorage. Using CookieStorage instead.")}}function Storage(options){this.handler=new StorageHandler(options)}function SSODataStorage(options){this.storage=new Storage(options)}function buildResponse(error,description){return{error:error,errorDescription:description}}CookieStorage.prototype.getItem=function(key){return js_cookie.get(key)},CookieStorage.prototype.removeItem=function(key){js_cookie.remove(key)},CookieStorage.prototype.setItem=function(key,value,options){var params=objectHelper.extend({expires:1},options);js_cookie.set(key,value,params)},Warn.prototype.warning=function(message){this.disableWarnings||console.warn(message)},StorageHandler.prototype.failover=function(){this.storage instanceof DummyStorage?this.warn.warning("DummyStorage: ignore failover"):this.storage instanceof CookieStorage?(this.warn.warning("CookieStorage: failing over DummyStorage"),this.storage=new DummyStorage):(this.warn.warning("LocalStorage: failing over CookieStorage"),this.storage=new CookieStorage)},StorageHandler.prototype.getItem=function(key){try{return this.storage.getItem(key)}catch(e){return this.warn.warning(e),this.failover(),this.getItem(key)}},StorageHandler.prototype.removeItem=function(key){try{return this.storage.removeItem(key)}catch(e){return this.warn.warning(e),this.failover(),this.removeItem(key)}},StorageHandler.prototype.setItem=function(key,value,options){try{return this.storage.setItem(key,value,options)}catch(e){return this.warn.warning(e),this.failover(),this.setItem(key,value,options)}},Storage.prototype.getItem=function(key){var value=this.handler.getItem(key);try{return JSON.parse(value)}catch(_){return value}},Storage.prototype.removeItem=function(key){return this.handler.removeItem(key)},Storage.prototype.setItem=function(key,value,options){var json=JSON.stringify(value);return this.handler.setItem(key,json,options)},SSODataStorage.prototype.set=function(connection,sub){var ssodata={lastUsedConnection:connection,lastUsedSub:sub};this.storage.setItem("auth0.ssodata",JSON.stringify(ssodata))},SSODataStorage.prototype.get=function(){var ssodata=this.storage.getItem("auth0.ssodata");if(ssodata)return JSON.parse(ssodata)};var error={buildResponse:buildResponse,invalidToken:function(description){return buildResponse("invalid_token",description)}};function wrapCallback(cb,options){return(options=options||{}).ignoreCasing=!!options.ignoreCasing&&options.ignoreCasing,function(err,data){var errObj;return err||data?(!err&&data.err&&(err=data.err,data=null),!err&&data.error&&(err=data,data=null),err?(errObj={original:err},err.response&&err.response.statusCode&&(errObj.statusCode=err.response.statusCode),err.response&&err.response.statusText&&(errObj.statusText=err.response.statusText),err.response&&err.response.body&&(err=err.response.body),err.err&&(err=err.err),errObj.code=err.code||err.error||err.error_code||err.status||null,errObj.description=err.errorDescription||err.error_description||err.description||err.error||err.details||err.err||null,options.forceLegacyError&&(errObj.error=errObj.code,errObj.error_description=errObj.description),err.name&&(errObj.name=err.name),err.policy&&(errObj.policy=err.policy),cb(errObj)):!data.type||"text/html"!==data.type&&"text/plain"!==data.type?options.ignoreCasing?cb(null,data.body||data):cb(null,objectHelper.toCamelCase(data.body||data)):cb(null,data.text)):cb(error.buildResponse("generic_error","Something went wrong"))}}var tokenParams=["realm","audience","client_id","client_secret","redirect_uri","scope","code","grant_type","username","password","refresh_token","assertion","client_assertion","client_assertion_type","code_verifier"],authorizeParams=["connection","connection_scope","auth0Client","owp","device","realm","protocol","_csrf","_intstate","login_ticket","client_id","response_type","response_mode","redirect_uri","audience","scope","state","nonce","display","prompt","max_age","ui_locales","claims_locales","id_token_hint","login_hint","acr_values","claims","registration","request","request_uri","code_challenge","code_challenge_method","access_type","display"];var parametersWhitelist={oauthTokenParams:function(warn,params){return objectHelper.pick(params,tokenParams)},oauthAuthorizeParams:function(warn,params){var notAllowed=objectHelper.getKeysNotIn(params,authorizeParams);return notAllowed.length>0&&warn.warning("Following parameters are not allowed on the `/authorize` endpoint: ["+notAllowed.join(",")+"]"),params}},core=createCommonjsModule(function(module,exports){var CryptoJS;module.exports=(CryptoJS=CryptoJS||function(Math,undefined){var create=Object.create||function(){function F(){}return function(obj){var subtype;return F.prototype=obj,subtype=new F,F.prototype=null,subtype}}(),C={},C_lib=C.lib={},Base=C_lib.Base={extend:function(overrides){var subtype=create(this);return overrides&&subtype.mixIn(overrides),subtype.hasOwnProperty("init")&&this.init!==subtype.init||(subtype.init=function(){subtype.$super.init.apply(this,arguments)}),subtype.init.prototype=subtype,subtype.$super=this,subtype},create:function(){var instance=this.extend();return instance.init.apply(instance,arguments),instance},init:function(){},mixIn:function(properties){for(var propertyName in properties)properties.hasOwnProperty(propertyName)&&(this[propertyName]=properties[propertyName]);properties.hasOwnProperty("toString")&&(this.toString=properties.toString)},clone:function(){return this.init.prototype.extend(this)}},WordArray=C_lib.WordArray=Base.extend({init:function(words,sigBytes){words=this.words=words||[],this.sigBytes=null!=sigBytes?sigBytes:4*words.length},toString:function(encoder){return(encoder||Hex).stringify(this)},concat:function(wordArray){var thisWords=this.words,thatWords=wordArray.words,thisSigBytes=this.sigBytes,thatSigBytes=wordArray.sigBytes;if(this.clamp(),thisSigBytes%4)for(var i=0;i<thatSigBytes;i++){var thatByte=thatWords[i>>>2]>>>24-i%4*8&255;thisWords[thisSigBytes+i>>>2]|=thatByte<<24-(thisSigBytes+i)%4*8}else for(var i=0;i<thatSigBytes;i+=4)thisWords[thisSigBytes+i>>>2]=thatWords[i>>>2];return this.sigBytes+=thatSigBytes,this},clamp:function(){var words=this.words,sigBytes=this.sigBytes;words[sigBytes>>>2]&=4294967295<<32-sigBytes%4*8,words.length=Math.ceil(sigBytes/4)},clone:function(){var clone=Base.clone.call(this);return clone.words=this.words.slice(0),clone},random:function(nBytes){for(var rcache,words=[],r=function(m_w){var m_w=m_w,m_z=987654321,mask=4294967295;return function(){var result=((m_z=36969*(65535&m_z)+(m_z>>16)&mask)<<16)+(m_w=18e3*(65535&m_w)+(m_w>>16)&mask)&mask;return result/=4294967296,(result+=.5)*(Math.random()>.5?1:-1)}},i=0;i<nBytes;i+=4){var _r=r(4294967296*(rcache||Math.random()));rcache=987654071*_r(),words.push(4294967296*_r()|0)}return new WordArray.init(words,nBytes)}}),C_enc=C.enc={},Hex=C_enc.Hex={stringify:function(wordArray){for(var words=wordArray.words,sigBytes=wordArray.sigBytes,hexChars=[],i=0;i<sigBytes;i++){var bite=words[i>>>2]>>>24-i%4*8&255;hexChars.push((bite>>>4).toString(16)),hexChars.push((15&bite).toString(16))}return hexChars.join("")},parse:function(hexStr){for(var hexStrLength=hexStr.length,words=[],i=0;i<hexStrLength;i+=2)words[i>>>3]|=parseInt(hexStr.substr(i,2),16)<<24-i%8*4;return new WordArray.init(words,hexStrLength/2)}},Latin1=C_enc.Latin1={stringify:function(wordArray){for(var words=wordArray.words,sigBytes=wordArray.sigBytes,latin1Chars=[],i=0;i<sigBytes;i++){var bite=words[i>>>2]>>>24-i%4*8&255;latin1Chars.push(String.fromCharCode(bite))}return latin1Chars.join("")},parse:function(latin1Str){for(var latin1StrLength=latin1Str.length,words=[],i=0;i<latin1StrLength;i++)words[i>>>2]|=(255&latin1Str.charCodeAt(i))<<24-i%4*8;return new WordArray.init(words,latin1StrLength)}},Utf8=C_enc.Utf8={stringify:function(wordArray){try{return decodeURIComponent(escape(Latin1.stringify(wordArray)))}catch(e){throw new Error("Malformed UTF-8 data")}},parse:function(utf8Str){return Latin1.parse(unescape(encodeURIComponent(utf8Str)))}},BufferedBlockAlgorithm=C_lib.BufferedBlockAlgorithm=Base.extend({reset:function(){this._data=new WordArray.init,this._nDataBytes=0},_append:function(data){"string"==typeof data&&(data=Utf8.parse(data)),this._data.concat(data),this._nDataBytes+=data.sigBytes},_process:function(doFlush){var data=this._data,dataWords=data.words,dataSigBytes=data.sigBytes,blockSize=this.blockSize,blockSizeBytes=4*blockSize,nBlocksReady=dataSigBytes/blockSizeBytes,nWordsReady=(nBlocksReady=doFlush?Math.ceil(nBlocksReady):Math.max((0|nBlocksReady)-this._minBufferSize,0))*blockSize,nBytesReady=Math.min(4*nWordsReady,dataSigBytes);if(nWordsReady){for(var offset=0;offset<nWordsReady;offset+=blockSize)this._doProcessBlock(dataWords,offset);var processedWords=dataWords.splice(0,nWordsReady);data.sigBytes-=nBytesReady}return new WordArray.init(processedWords,nBytesReady)},clone:function(){var clone=Base.clone.call(this);return clone._data=this._data.clone(),clone},_minBufferSize:0}),C_algo=(C_lib.Hasher=BufferedBlockAlgorithm.extend({cfg:Base.extend(),init:function(cfg){this.cfg=this.cfg.extend(cfg),this.reset()},reset:function(){BufferedBlockAlgorithm.reset.call(this),this._doReset()},update:function(messageUpdate){return this._append(messageUpdate),this._process(),this},finalize:function(messageUpdate){messageUpdate&&this._append(messageUpdate);var hash=this._doFinalize();return hash},blockSize:16,_createHelper:function(hasher){return function(message,cfg){return new hasher.init(cfg).finalize(message)}},_createHmacHelper:function(hasher){return function(message,key){return new C_algo.HMAC.init(hasher,key).finalize(message)}}}),C.algo={});return C}(Math),CryptoJS)}),sha256=createCommonjsModule(function(module,exports){var CryptoJS;module.exports=(CryptoJS=core,function(Math){var C=CryptoJS,C_lib=C.lib,WordArray=C_lib.WordArray,Hasher=C_lib.Hasher,C_algo=C.algo,H=[],K=[];!function(){function isPrime(n){for(var sqrtN=Math.sqrt(n),factor=2;factor<=sqrtN;factor++)if(!(n%factor))return!1;return!0}function getFractionalBits(n){return 4294967296*(n-(0|n))|0}for(var n=2,nPrime=0;nPrime<64;)isPrime(n)&&(nPrime<8&&(H[nPrime]=getFractionalBits(Math.pow(n,.5))),K[nPrime]=getFractionalBits(Math.pow(n,1/3)),nPrime++),n++}();var W=[],SHA256=C_algo.SHA256=Hasher.extend({_doReset:function(){this._hash=new WordArray.init(H.slice(0))},_doProcessBlock:function(M,offset){for(var H=this._hash.words,a=H[0],b=H[1],c=H[2],d=H[3],e=H[4],f=H[5],g=H[6],h=H[7],i=0;i<64;i++){if(i<16)W[i]=0|M[offset+i];else{var gamma0x=W[i-15],gamma0=(gamma0x<<25|gamma0x>>>7)^(gamma0x<<14|gamma0x>>>18)^gamma0x>>>3,gamma1x=W[i-2],gamma1=(gamma1x<<15|gamma1x>>>17)^(gamma1x<<13|gamma1x>>>19)^gamma1x>>>10;W[i]=gamma0+W[i-7]+gamma1+W[i-16]}var maj=a&b^a&c^b&c,sigma0=(a<<30|a>>>2)^(a<<19|a>>>13)^(a<<10|a>>>22),t1=h+((e<<26|e>>>6)^(e<<21|e>>>11)^(e<<7|e>>>25))+(e&f^~e&g)+K[i]+W[i];h=g,g=f,f=e,e=d+t1|0,d=c,c=b,b=a,a=t1+(sigma0+maj)|0}H[0]=H[0]+a|0,H[1]=H[1]+b|0,H[2]=H[2]+c|0,H[3]=H[3]+d|0,H[4]=H[4]+e|0,H[5]=H[5]+f|0,H[6]=H[6]+g|0,H[7]=H[7]+h|0},_doFinalize:function(){var data=this._data,dataWords=data.words,nBitsTotal=8*this._nDataBytes,nBitsLeft=8*data.sigBytes;return dataWords[nBitsLeft>>>5]|=128<<24-nBitsLeft%32,dataWords[14+(nBitsLeft+64>>>9<<4)]=Math.floor(nBitsTotal/4294967296),dataWords[15+(nBitsLeft+64>>>9<<4)]=nBitsTotal,data.sigBytes=4*dataWords.length,this._process(),this._hash},clone:function(){var clone=Hasher.clone.call(this);return clone._hash=this._hash.clone(),clone}});C.SHA256=Hasher._createHelper(SHA256),C.HmacSHA256=Hasher._createHmacHelper(SHA256)}(Math),CryptoJS.SHA256)}),encBase64=createCommonjsModule(function(module,exports){var CryptoJS,C,WordArray;module.exports=(WordArray=(C=CryptoJS=core).lib.WordArray,C.enc.Base64={stringify:function(wordArray){var words=wordArray.words,sigBytes=wordArray.sigBytes,map=this._map;wordArray.clamp();for(var base64Chars=[],i=0;i<sigBytes;i+=3)for(var triplet=(words[i>>>2]>>>24-i%4*8&255)<<16|(words[i+1>>>2]>>>24-(i+1)%4*8&255)<<8|words[i+2>>>2]>>>24-(i+2)%4*8&255,j=0;j<4&&i+.75*j<sigBytes;j++)base64Chars.push(map.charAt(triplet>>>6*(3-j)&63));var paddingChar=map.charAt(64);if(paddingChar)for(;base64Chars.length%4;)base64Chars.push(paddingChar);return base64Chars.join("")},parse:function(base64Str){var base64StrLength=base64Str.length,map=this._map,reverseMap=this._reverseMap;if(!reverseMap){reverseMap=this._reverseMap=[];for(var j=0;j<map.length;j++)reverseMap[map.charCodeAt(j)]=j}var paddingChar=map.charAt(64);if(paddingChar){var paddingIndex=base64Str.indexOf(paddingChar);-1!==paddingIndex&&(base64StrLength=paddingIndex)}return function(base64Str,base64StrLength,reverseMap){for(var words=[],nBytes=0,i=0;i<base64StrLength;i++)if(i%4){var bits1=reverseMap[base64Str.charCodeAt(i-1)]<<i%4*2,bits2=reverseMap[base64Str.charCodeAt(i)]>>>6-i%4*2;words[nBytes>>>2]|=(bits1|bits2)<<24-nBytes%4*8,nBytes++}return WordArray.create(words,nBytes)}(base64Str,base64StrLength,reverseMap)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="},CryptoJS.enc.Base64)}),encHex=createCommonjsModule(function(module,exports){module.exports=core.enc.Hex}),BigInteger=createCommonjsModule(function(module,exports){(function(){var dbits;function BigInteger(a,b,c){null!=a&&("number"==typeof a?this.fromNumber(a,b,c):null==b&&"string"!=typeof a?this.fromString(a,256):this.fromString(a,b))}function nbi(){return new BigInteger(null)}var inBrowser="undefined"!=typeof navigator;inBrowser&&"Microsoft Internet Explorer"==navigator.appName?(BigInteger.prototype.am=function(i,x,w,j,c,n){for(var xl=32767&x,xh=x>>15;--n>=0;){var l=32767&this[i],h=this[i++]>>15,m=xh*l+h*xl;c=((l=xl*l+((32767&m)<<15)+w[j]+(1073741823&c))>>>30)+(m>>>15)+xh*h+(c>>>30),w[j++]=1073741823&l}return c},dbits=30):inBrowser&&"Netscape"!=navigator.appName?(BigInteger.prototype.am=function(i,x,w,j,c,n){for(;--n>=0;){var v=x*this[i++]+w[j]+c;c=Math.floor(v/67108864),w[j++]=67108863&v}return c},dbits=26):(BigInteger.prototype.am=function(i,x,w,j,c,n){for(var xl=16383&x,xh=x>>14;--n>=0;){var l=16383&this[i],h=this[i++]>>14,m=xh*l+h*xl;c=((l=xl*l+((16383&m)<<14)+w[j]+c)>>28)+(m>>14)+xh*h,w[j++]=268435455&l}return c},dbits=28),BigInteger.prototype.DB=dbits,BigInteger.prototype.DM=(1<<dbits)-1,BigInteger.prototype.DV=1<<dbits;BigInteger.prototype.FV=Math.pow(2,52),BigInteger.prototype.F1=52-dbits,BigInteger.prototype.F2=2*dbits-52;var rr,vv,BI_RM="0123456789abcdefghijklmnopqrstuvwxyz",BI_RC=new Array;for(rr="0".charCodeAt(0),vv=0;vv<=9;++vv)BI_RC[rr++]=vv;for(rr="a".charCodeAt(0),vv=10;vv<36;++vv)BI_RC[rr++]=vv;for(rr="A".charCodeAt(0),vv=10;vv<36;++vv)BI_RC[rr++]=vv;function int2char(n){return BI_RM.charAt(n)}function intAt(s,i){var c=BI_RC[s.charCodeAt(i)];return null==c?-1:c}function nbv(i){var r=nbi();return r.fromInt(i),r}function nbits(x){var t,r=1;return 0!=(t=x>>>16)&&(x=t,r+=16),0!=(t=x>>8)&&(x=t,r+=8),0!=(t=x>>4)&&(x=t,r+=4),0!=(t=x>>2)&&(x=t,r+=2),0!=(t=x>>1)&&(x=t,r+=1),r}function Classic(m){this.m=m}function Montgomery(m){this.m=m,this.mp=m.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<m.DB-15)-1,this.mt2=2*m.t}function op_and(x,y){return x&y}function op_or(x,y){return x|y}function op_xor(x,y){return x^y}function op_andnot(x,y){return x&~y}function lbit(x){if(0==x)return-1;var r=0;return 0==(65535&x)&&(x>>=16,r+=16),0==(255&x)&&(x>>=8,r+=8),0==(15&x)&&(x>>=4,r+=4),0==(3&x)&&(x>>=2,r+=2),0==(1&x)&&++r,r}function cbit(x){for(var r=0;0!=x;)x&=x-1,++r;return r}function NullExp(){}function nNop(x){return x}function Barrett(m){this.r2=nbi(),this.q3=nbi(),BigInteger.ONE.dlShiftTo(2*m.t,this.r2),this.mu=this.r2.divide(m),this.m=m}Classic.prototype.convert=function(x){return x.s<0||x.compareTo(this.m)>=0?x.mod(this.m):x},Classic.prototype.revert=function(x){return x},Classic.prototype.reduce=function(x){x.divRemTo(this.m,null,x)},Classic.prototype.mulTo=function(x,y,r){x.multiplyTo(y,r),this.reduce(r)},Classic.prototype.sqrTo=function(x,r){x.squareTo(r),this.reduce(r)},Montgomery.prototype.convert=function(x){var r=nbi();return x.abs().dlShiftTo(this.m.t,r),r.divRemTo(this.m,null,r),x.s<0&&r.compareTo(BigInteger.ZERO)>0&&this.m.subTo(r,r),r},Montgomery.prototype.revert=function(x){var r=nbi();return x.copyTo(r),this.reduce(r),r},Montgomery.prototype.reduce=function(x){for(;x.t<=this.mt2;)x[x.t++]=0;for(var i=0;i<this.m.t;++i){var j=32767&x[i],u0=j*this.mpl+((j*this.mph+(x[i]>>15)*this.mpl&this.um)<<15)&x.DM;for(x[j=i+this.m.t]+=this.m.am(0,u0,x,i,0,this.m.t);x[j]>=x.DV;)x[j]-=x.DV,x[++j]++}x.clamp(),x.drShiftTo(this.m.t,x),x.compareTo(this.m)>=0&&x.subTo(this.m,x)},Montgomery.prototype.mulTo=function(x,y,r){x.multiplyTo(y,r),this.reduce(r)},Montgomery.prototype.sqrTo=function(x,r){x.squareTo(r),this.reduce(r)},BigInteger.prototype.copyTo=function(r){for(var i=this.t-1;i>=0;--i)r[i]=this[i];r.t=this.t,r.s=this.s},BigInteger.prototype.fromInt=function(x){this.t=1,this.s=x<0?-1:0,x>0?this[0]=x:x<-1?this[0]=x+this.DV:this.t=0},BigInteger.prototype.fromString=function(s,b){var k;if(16==b)k=4;else if(8==b)k=3;else if(256==b)k=8;else if(2==b)k=1;else if(32==b)k=5;else{if(4!=b)return void this.fromRadix(s,b);k=2}this.t=0,this.s=0;for(var i=s.length,mi=!1,sh=0;--i>=0;){var x=8==k?255&s[i]:intAt(s,i);x<0?"-"==s.charAt(i)&&(mi=!0):(mi=!1,0==sh?this[this.t++]=x:sh+k>this.DB?(this[this.t-1]|=(x&(1<<this.DB-sh)-1)<<sh,this[this.t++]=x>>this.DB-sh):this[this.t-1]|=x<<sh,(sh+=k)>=this.DB&&(sh-=this.DB))}8==k&&0!=(128&s[0])&&(this.s=-1,sh>0&&(this[this.t-1]|=(1<<this.DB-sh)-1<<sh)),this.clamp(),mi&&BigInteger.ZERO.subTo(this,this)},BigInteger.prototype.clamp=function(){for(var c=this.s&this.DM;this.t>0&&this[this.t-1]==c;)--this.t},BigInteger.prototype.dlShiftTo=function(n,r){var i;for(i=this.t-1;i>=0;--i)r[i+n]=this[i];for(i=n-1;i>=0;--i)r[i]=0;r.t=this.t+n,r.s=this.s},BigInteger.prototype.drShiftTo=function(n,r){for(var i=n;i<this.t;++i)r[i-n]=this[i];r.t=Math.max(this.t-n,0),r.s=this.s},BigInteger.prototype.lShiftTo=function(n,r){var i,bs=n%this.DB,cbs=this.DB-bs,bm=(1<<cbs)-1,ds=Math.floor(n/this.DB),c=this.s<<bs&this.DM;for(i=this.t-1;i>=0;--i)r[i+ds+1]=this[i]>>cbs|c,c=(this[i]&bm)<<bs;for(i=ds-1;i>=0;--i)r[i]=0;r[ds]=c,r.t=this.t+ds+1,r.s=this.s,r.clamp()},BigInteger.prototype.rShiftTo=function(n,r){r.s=this.s;var ds=Math.floor(n/this.DB);if(ds>=this.t)r.t=0;else{var bs=n%this.DB,cbs=this.DB-bs,bm=(1<<bs)-1;r[0]=this[ds]>>bs;for(var i=ds+1;i<this.t;++i)r[i-ds-1]|=(this[i]&bm)<<cbs,r[i-ds]=this[i]>>bs;bs>0&&(r[this.t-ds-1]|=(this.s&bm)<<cbs),r.t=this.t-ds,r.clamp()}},BigInteger.prototype.subTo=function(a,r){for(var i=0,c=0,m=Math.min(a.t,this.t);i<m;)c+=this[i]-a[i],r[i++]=c&this.DM,c>>=this.DB;if(a.t<this.t){for(c-=a.s;i<this.t;)c+=this[i],r[i++]=c&this.DM,c>>=this.DB;c+=this.s}else{for(c+=this.s;i<a.t;)c-=a[i],r[i++]=c&this.DM,c>>=this.DB;c-=a.s}r.s=c<0?-1:0,c<-1?r[i++]=this.DV+c:c>0&&(r[i++]=c),r.t=i,r.clamp()},BigInteger.prototype.multiplyTo=function(a,r){var x=this.abs(),y=a.abs(),i=x.t;for(r.t=i+y.t;--i>=0;)r[i]=0;for(i=0;i<y.t;++i)r[i+x.t]=x.am(0,y[i],r,i,0,x.t);r.s=0,r.clamp(),this.s!=a.s&&BigInteger.ZERO.subTo(r,r)},BigInteger.prototype.squareTo=function(r){for(var x=this.abs(),i=r.t=2*x.t;--i>=0;)r[i]=0;for(i=0;i<x.t-1;++i){var c=x.am(i,x[i],r,2*i,0,1);(r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1))>=x.DV&&(r[i+x.t]-=x.DV,r[i+x.t+1]=1)}r.t>0&&(r[r.t-1]+=x.am(i,x[i],r,2*i,0,1)),r.s=0,r.clamp()},BigInteger.prototype.divRemTo=function(m,q,r){var pm=m.abs();if(!(pm.t<=0)){var pt=this.abs();if(pt.t<pm.t)return null!=q&&q.fromInt(0),void(null!=r&&this.copyTo(r));null==r&&(r=nbi());var y=nbi(),ts=this.s,ms=m.s,nsh=this.DB-nbits(pm[pm.t-1]);nsh>0?(pm.lShiftTo(nsh,y),pt.lShiftTo(nsh,r)):(pm.copyTo(y),pt.copyTo(r));var ys=y.t,y0=y[ys-1];if(0!=y0){var yt=y0*(1<<this.F1)+(ys>1?y[ys-2]>>this.F2:0),d1=this.FV/yt,d2=(1<<this.F1)/yt,e=1<<this.F2,i=r.t,j=i-ys,t=null==q?nbi():q;for(y.dlShiftTo(j,t),r.compareTo(t)>=0&&(r[r.t++]=1,r.subTo(t,r)),BigInteger.ONE.dlShiftTo(ys,t),t.subTo(y,y);y.t<ys;)y[y.t++]=0;for(;--j>=0;){var qd=r[--i]==y0?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);if((r[i]+=y.am(0,qd,r,j,0,ys))<qd)for(y.dlShiftTo(j,t),r.subTo(t,r);r[i]<--qd;)r.subTo(t,r)}null!=q&&(r.drShiftTo(ys,q),ts!=ms&&BigInteger.ZERO.subTo(q,q)),r.t=ys,r.clamp(),nsh>0&&r.rShiftTo(nsh,r),ts<0&&BigInteger.ZERO.subTo(r,r)}}},BigInteger.prototype.invDigit=function(){if(this.t<1)return 0;var x=this[0];if(0==(1&x))return 0;var y=3&x;return(y=(y=(y=(y=y*(2-(15&x)*y)&15)*(2-(255&x)*y)&255)*(2-((65535&x)*y&65535))&65535)*(2-x*y%this.DV)%this.DV)>0?this.DV-y:-y},BigInteger.prototype.isEven=function(){return 0==(this.t>0?1&this[0]:this.s)},BigInteger.prototype.exp=function(e,z){if(e>4294967295||e<1)return BigInteger.ONE;var r=nbi(),r2=nbi(),g=z.convert(this),i=nbits(e)-1;for(g.copyTo(r);--i>=0;)if(z.sqrTo(r,r2),(e&1<<i)>0)z.mulTo(r2,g,r);else{var t=r;r=r2,r2=t}return z.revert(r)},BigInteger.prototype.toString=function(b){if(this.s<0)return"-"+this.negate().toString(b);var k;if(16==b)k=4;else if(8==b)k=3;else if(2==b)k=1;else if(32==b)k=5;else{if(4!=b)return this.toRadix(b);k=2}var d,km=(1<<k)-1,m=!1,r="",i=this.t,p=this.DB-i*this.DB%k;if(i-- >0)for(p<this.DB&&(d=this[i]>>p)>0&&(m=!0,r=int2char(d));i>=0;)p<k?(d=(this[i]&(1<<p)-1)<<k-p,d|=this[--i]>>(p+=this.DB-k)):(d=this[i]>>(p-=k)&km,p<=0&&(p+=this.DB,--i)),d>0&&(m=!0),m&&(r+=int2char(d));return m?r:"0"},BigInteger.prototype.negate=function(){var r=nbi();return BigInteger.ZERO.subTo(this,r),r},BigInteger.prototype.abs=function(){return this.s<0?this.negate():this},BigInteger.prototype.compareTo=function(a){var r=this.s-a.s;if(0!=r)return r;var i=this.t;if(0!=(r=i-a.t))return this.s<0?-r:r;for(;--i>=0;)if(0!=(r=this[i]-a[i]))return r;return 0},BigInteger.prototype.bitLength=function(){return this.t<=0?0:this.DB*(this.t-1)+nbits(this[this.t-1]^this.s&this.DM)},BigInteger.prototype.mod=function(a){var r=nbi();return this.abs().divRemTo(a,null,r),this.s<0&&r.compareTo(BigInteger.ZERO)>0&&a.subTo(r,r),r},BigInteger.prototype.modPowInt=function(e,m){var z;return z=e<256||m.isEven()?new Classic(m):new Montgomery(m),this.exp(e,z)},BigInteger.ZERO=nbv(0),BigInteger.ONE=nbv(1),NullExp.prototype.convert=nNop,NullExp.prototype.revert=nNop,NullExp.prototype.mulTo=function(x,y,r){x.multiplyTo(y,r)},NullExp.prototype.sqrTo=function(x,r){x.squareTo(r)},Barrett.prototype.convert=function(x){if(x.s<0||x.t>2*this.m.t)return x.mod(this.m);if(x.compareTo(this.m)<0)return x;var r=nbi();return x.copyTo(r),this.reduce(r),r},Barrett.prototype.revert=function(x){return x},Barrett.prototype.reduce=function(x){for(x.drShiftTo(this.m.t-1,this.r2),x.t>this.m.t+1&&(x.t=this.m.t+1,x.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);x.compareTo(this.r2)<0;)x.dAddOffset(1,this.m.t+1);for(x.subTo(this.r2,x);x.compareTo(this.m)>=0;)x.subTo(this.m,x)},Barrett.prototype.mulTo=function(x,y,r){x.multiplyTo(y,r),this.reduce(r)},Barrett.prototype.sqrTo=function(x,r){x.squareTo(r),this.reduce(r)};var rng_state,rng_pool,rng_pptr,lowprimes=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],lplim=(1<<26)/lowprimes[lowprimes.length-1];function rng_seed_time(){var x;x=(new Date).getTime(),rng_pool[rng_pptr++]^=255&x,rng_pool[rng_pptr++]^=x>>8&255,rng_pool[rng_pptr++]^=x>>16&255,rng_pool[rng_pptr++]^=x>>24&255,rng_pptr>=rng_psize&&(rng_pptr-=rng_psize)}if(BigInteger.prototype.chunkSize=function(r){return Math.floor(Math.LN2*this.DB/Math.log(r))},BigInteger.prototype.toRadix=function(b){if(null==b&&(b=10),0==this.signum()||b<2||b>36)return"0";var cs=this.chunkSize(b),a=Math.pow(b,cs),d=nbv(a),y=nbi(),z=nbi(),r="";for(this.divRemTo(d,y,z);y.signum()>0;)r=(a+z.intValue()).toString(b).substr(1)+r,y.divRemTo(d,y,z);return z.intValue().toString(b)+r},BigInteger.prototype.fromRadix=function(s,b){this.fromInt(0),null==b&&(b=10);for(var cs=this.chunkSize(b),d=Math.pow(b,cs),mi=!1,j=0,w=0,i=0;i<s.length;++i){var x=intAt(s,i);x<0?"-"==s.charAt(i)&&0==this.signum()&&(mi=!0):(w=b*w+x,++j>=cs&&(this.dMultiply(d),this.dAddOffset(w,0),j=0,w=0))}j>0&&(this.dMultiply(Math.pow(b,j)),this.dAddOffset(w,0)),mi&&BigInteger.ZERO.subTo(this,this)},BigInteger.prototype.fromNumber=function(a,b,c){if("number"==typeof b)if(a<2)this.fromInt(1);else for(this.fromNumber(a,c),this.testBit(a-1)||this.bitwiseTo(BigInteger.ONE.shiftLeft(a-1),op_or,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(b);)this.dAddOffset(2,0),this.bitLength()>a&&this.subTo(BigInteger.ONE.shiftLeft(a-1),this);else{var x=new Array,t=7&a;x.length=1+(a>>3),b.nextBytes(x),t>0?x[0]&=(1<<t)-1:x[0]=0,this.fromString(x,256)}},BigInteger.prototype.bitwiseTo=function(a,op,r){var i,f,m=Math.min(a.t,this.t);for(i=0;i<m;++i)r[i]=op(this[i],a[i]);if(a.t<this.t){for(f=a.s&this.DM,i=m;i<this.t;++i)r[i]=op(this[i],f);r.t=this.t}else{for(f=this.s&this.DM,i=m;i<a.t;++i)r[i]=op(f,a[i]);r.t=a.t}r.s=op(this.s,a.s),r.clamp()},BigInteger.prototype.changeBit=function(n,op){var r=BigInteger.ONE.shiftLeft(n);return this.bitwiseTo(r,op,r),r},BigInteger.prototype.addTo=function(a,r){for(var i=0,c=0,m=Math.min(a.t,this.t);i<m;)c+=this[i]+a[i],r[i++]=c&this.DM,c>>=this.DB;if(a.t<this.t){for(c+=a.s;i<this.t;)c+=this[i],r[i++]=c&this.DM,c>>=this.DB;c+=this.s}else{for(c+=this.s;i<a.t;)c+=a[i],r[i++]=c&this.DM,c>>=this.DB;c+=a.s}r.s=c<0?-1:0,c>0?r[i++]=c:c<-1&&(r[i++]=this.DV+c),r.t=i,r.clamp()},BigInteger.prototype.dMultiply=function(n){this[this.t]=this.am(0,n-1,this,0,0,this.t),++this.t,this.clamp()},BigInteger.prototype.dAddOffset=function(n,w){if(0!=n){for(;this.t<=w;)this[this.t++]=0;for(this[w]+=n;this[w]>=this.DV;)this[w]-=this.DV,++w>=this.t&&(this[this.t++]=0),++this[w]}},BigInteger.prototype.multiplyLowerTo=function(a,n,r){var j,i=Math.min(this.t+a.t,n);for(r.s=0,r.t=i;i>0;)r[--i]=0;for(j=r.t-this.t;i<j;++i)r[i+this.t]=this.am(0,a[i],r,i,0,this.t);for(j=Math.min(a.t,n);i<j;++i)this.am(0,a[i],r,i,0,n-i);r.clamp()},BigInteger.prototype.multiplyUpperTo=function(a,n,r){--n;var i=r.t=this.t+a.t-n;for(r.s=0;--i>=0;)r[i]=0;for(i=Math.max(n-this.t,0);i<a.t;++i)r[this.t+i-n]=this.am(n-i,a[i],r,0,0,this.t+i-n);r.clamp(),r.drShiftTo(1,r)},BigInteger.prototype.modInt=function(n){if(n<=0)return 0;var d=this.DV%n,r=this.s<0?n-1:0;if(this.t>0)if(0==d)r=this[0]%n;else for(var i=this.t-1;i>=0;--i)r=(d*r+this[i])%n;return r},BigInteger.prototype.millerRabin=function(t){var n1=this.subtract(BigInteger.ONE),k=n1.getLowestSetBit();if(k<=0)return!1;var r=n1.shiftRight(k);(t=t+1>>1)>lowprimes.length&&(t=lowprimes.length);for(var a=nbi(),i=0;i<t;++i){a.fromInt(lowprimes[Math.floor(Math.random()*lowprimes.length)]);var y=a.modPow(r,this);if(0!=y.compareTo(BigInteger.ONE)&&0!=y.compareTo(n1)){for(var j=1;j++<k&&0!=y.compareTo(n1);)if(0==(y=y.modPowInt(2,this)).compareTo(BigInteger.ONE))return!1;if(0!=y.compareTo(n1))return!1}}return!0},BigInteger.prototype.clone=function(){var r=nbi();return this.copyTo(r),r},BigInteger.prototype.intValue=function(){if(this.s<0){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]},BigInteger.prototype.byteValue=function(){return 0==this.t?this.s:this[0]<<24>>24},BigInteger.prototype.shortValue=function(){return 0==this.t?this.s:this[0]<<16>>16},BigInteger.prototype.signum=function(){return this.s<0?-1:this.t<=0||1==this.t&&this[0]<=0?0:1},BigInteger.prototype.toByteArray=function(){var i=this.t,r=new Array;r[0]=this.s;var d,p=this.DB-i*this.DB%8,k=0;if(i-- >0)for(p<this.DB&&(d=this[i]>>p)!=(this.s&this.DM)>>p&&(r[k++]=d|this.s<<this.DB-p);i>=0;)p<8?(d=(this[i]&(1<<p)-1)<<8-p,d|=this[--i]>>(p+=this.DB-8)):(d=this[i]>>(p-=8)&255,p<=0&&(p+=this.DB,--i)),0!=(128&d)&&(d|=-256),0==k&&(128&this.s)!=(128&d)&&++k,(k>0||d!=this.s)&&(r[k++]=d);return r},BigInteger.prototype.equals=function(a){return 0==this.compareTo(a)},BigInteger.prototype.min=function(a){return this.compareTo(a)<0?this:a},BigInteger.prototype.max=function(a){return this.compareTo(a)>0?this:a},BigInteger.prototype.and=function(a){var r=nbi();return this.bitwiseTo(a,op_and,r),r},BigInteger.prototype.or=function(a){var r=nbi();return this.bitwiseTo(a,op_or,r),r},BigInteger.prototype.xor=function(a){var r=nbi();return this.bitwiseTo(a,op_xor,r),r},BigInteger.prototype.andNot=function(a){var r=nbi();return this.bitwiseTo(a,op_andnot,r),r},BigInteger.prototype.not=function(){for(var r=nbi(),i=0;i<this.t;++i)r[i]=this.DM&~this[i];return r.t=this.t,r.s=~this.s,r},BigInteger.prototype.shiftLeft=function(n){var r=nbi();return n<0?this.rShiftTo(-n,r):this.lShiftTo(n,r),r},BigInteger.prototype.shiftRight=function(n){var r=nbi();return n<0?this.lShiftTo(-n,r):this.rShiftTo(n,r),r},BigInteger.prototype.getLowestSetBit=function(){for(var i=0;i<this.t;++i)if(0!=this[i])return i*this.DB+lbit(this[i]);return this.s<0?this.t*this.DB:-1},BigInteger.prototype.bitCount=function(){for(var r=0,x=this.s&this.DM,i=0;i<this.t;++i)r+=cbit(this[i]^x);return r},BigInteger.prototype.testBit=function(n){var j=Math.floor(n/this.DB);return j>=this.t?0!=this.s:0!=(this[j]&1<<n%this.DB)},BigInteger.prototype.setBit=function(n){return this.changeBit(n,op_or)},BigInteger.prototype.clearBit=function(n){return this.changeBit(n,op_andnot)},BigInteger.prototype.flipBit=function(n){return this.changeBit(n,op_xor)},BigInteger.prototype.add=function(a){var r=nbi();return this.addTo(a,r),r},BigInteger.prototype.subtract=function(a){var r=nbi();return this.subTo(a,r),r},BigInteger.prototype.multiply=function(a){var r=nbi();return this.multiplyTo(a,r),r},BigInteger.prototype.divide=function(a){var r=nbi();return this.divRemTo(a,r,null),r},BigInteger.prototype.remainder=function(a){var r=nbi();return this.divRemTo(a,null,r),r},BigInteger.prototype.divideAndRemainder=function(a){var q=nbi(),r=nbi();return this.divRemTo(a,q,r),new Array(q,r)},BigInteger.prototype.modPow=function(e,m){var k,z,i=e.bitLength(),r=nbv(1);if(i<=0)return r;k=i<18?1:i<48?3:i<144?4:i<768?5:6,z=i<8?new Classic(m):m.isEven()?new Barrett(m):new Montgomery(m);var g=new Array,n=3,k1=k-1,km=(1<<k)-1;if(g[1]=z.convert(this),k>1){var g2=nbi();for(z.sqrTo(g[1],g2);n<=km;)g[n]=nbi(),z.mulTo(g2,g[n-2],g[n]),n+=2}var w,t,j=e.t-1,is1=!0,r2=nbi();for(i=nbits(e[j])-1;j>=0;){for(i>=k1?w=e[j]>>i-k1&km:(w=(e[j]&(1<<i+1)-1)<<k1-i,j>0&&(w|=e[j-1]>>this.DB+i-k1)),n=k;0==(1&w);)w>>=1,--n;if((i-=n)<0&&(i+=this.DB,--j),is1)g[w].copyTo(r),is1=!1;else{for(;n>1;)z.sqrTo(r,r2),z.sqrTo(r2,r),n-=2;n>0?z.sqrTo(r,r2):(t=r,r=r2,r2=t),z.mulTo(r2,g[w],r)}for(;j>=0&&0==(e[j]&1<<i);)z.sqrTo(r,r2),t=r,r=r2,r2=t,--i<0&&(i=this.DB-1,--j)}return z.revert(r)},BigInteger.prototype.modInverse=function(m){var ac=m.isEven();if(this.isEven()&&ac||0==m.signum())return BigInteger.ZERO;for(var u=m.clone(),v=this.clone(),a=nbv(1),b=nbv(0),c=nbv(0),d=nbv(1);0!=u.signum();){for(;u.isEven();)u.rShiftTo(1,u),ac?(a.isEven()&&b.isEven()||(a.addTo(this,a),b.subTo(m,b)),a.rShiftTo(1,a)):b.isEven()||b.subTo(m,b),b.rShiftTo(1,b);for(;v.isEven();)v.rShiftTo(1,v),ac?(c.isEven()&&d.isEven()||(c.addTo(this,c),d.subTo(m,d)),c.rShiftTo(1,c)):d.isEven()||d.subTo(m,d),d.rShiftTo(1,d);u.compareTo(v)>=0?(u.subTo(v,u),ac&&a.subTo(c,a),b.subTo(d,b)):(v.subTo(u,v),ac&&c.subTo(a,c),d.subTo(b,d))}return 0!=v.compareTo(BigInteger.ONE)?BigInteger.ZERO:d.compareTo(m)>=0?d.subtract(m):d.signum()<0?(d.addTo(m,d),d.signum()<0?d.add(m):d):d},BigInteger.prototype.pow=function(e){return this.exp(e,new NullExp)},BigInteger.prototype.gcd=function(a){var x=this.s<0?this.negate():this.clone(),y=a.s<0?a.negate():a.clone();if(x.compareTo(y)<0){var t=x;x=y,y=t}var i=x.getLowestSetBit(),g=y.getLowestSetBit();if(g<0)return x;for(i<g&&(g=i),g>0&&(x.rShiftTo(g,x),y.rShiftTo(g,y));x.signum()>0;)(i=x.getLowestSetBit())>0&&x.rShiftTo(i,x),(i=y.getLowestSetBit())>0&&y.rShiftTo(i,y),x.compareTo(y)>=0?(x.subTo(y,x),x.rShiftTo(1,x)):(y.subTo(x,y),y.rShiftTo(1,y));return g>0&&y.lShiftTo(g,y),y},BigInteger.prototype.isProbablePrime=function(t){var i,x=this.abs();if(1==x.t&&x[0]<=lowprimes[lowprimes.length-1]){for(i=0;i<lowprimes.length;++i)if(x[0]==lowprimes[i])return!0;return!1}if(x.isEven())return!1;for(i=1;i<lowprimes.length;){for(var m=lowprimes[i],j=i+1;j<lowprimes.length&&m<lplim;)m*=lowprimes[j++];for(m=x.modInt(m);i<j;)if(m%lowprimes[i++]==0)return!1}return x.millerRabin(t)},BigInteger.prototype.square=function(){var r=nbi();return this.squareTo(r),r},BigInteger.prototype.Barrett=Barrett,null==rng_pool){var t;if(rng_pool=new Array,rng_pptr=0,"undefined"!=typeof window&&window.crypto)if(window.crypto.getRandomValues){var ua=new Uint8Array(32);for(window.crypto.getRandomValues(ua),t=0;t<32;++t)rng_pool[rng_pptr++]=ua[t]}else if("Netscape"==navigator.appName&&navigator.appVersion<"5"){var z=window.crypto.random(32);for(t=0;t<z.length;++t)rng_pool[rng_pptr++]=255&z.charCodeAt(t)}for(;rng_pptr<rng_psize;)t=Math.floor(65536*Math.random()),rng_pool[rng_pptr++]=t>>>8,rng_pool[rng_pptr++]=255&t;rng_pptr=0,rng_seed_time()}function rng_get_byte(){if(null==rng_state){for(rng_seed_time(),(rng_state=new Arcfour).init(rng_pool),rng_pptr=0;rng_pptr<rng_pool.length;++rng_pptr)rng_pool[rng_pptr]=0;rng_pptr=0}return rng_state.next()}function SecureRandom(){}function Arcfour(){this.i=0,this.j=0,this.S=new Array}SecureRandom.prototype.nextBytes=function(ba){var i;for(i=0;i<ba.length;++i)ba[i]=rng_get_byte()},Arcfour.prototype.init=function(key){var i,j,t;for(i=0;i<256;++i)this.S[i]=i;for(j=0,i=0;i<256;++i)j=j+this.S[i]+key[i%key.length]&255,t=this.S[i],this.S[i]=this.S[j],this.S[j]=t;this.i=0,this.j=0},Arcfour.prototype.next=function(){var t;return this.i=this.i+1&255,this.j=this.j+this.S[this.i]&255,t=this.S[this.i],this.S[this.i]=this.S[this.j],this.S[this.j]=t,this.S[t+this.S[this.i]&255]};var rng_psize=256;BigInteger.SecureRandom=SecureRandom,BigInteger.BigInteger=BigInteger,module.exports=BigInteger}).call(commonjsGlobal)}).BigInteger,DigestInfoHead={sha1:"3021300906052b0e03021a05000414",sha224:"302d300d06096086480165030402040500041c",sha256:"3031300d060960864801650304020105000420",sha384:"3041300d060960864801650304020205000430",sha512:"3051300d060960864801650304020305000440",md2:"3020300c06082a864886f70d020205000410",md5:"3020300c06082a864886f70d020505000410",ripemd160:"3021300906052b2403020105000414"},DigestAlgs={sha256:sha256};function RSAVerifier(modulus,exp){if(this.n=null,this.e=0,!(null!=modulus&&null!=exp&&modulus.length>0&&exp.length>0))throw new Error("Invalid key data");this.n=new BigInteger(modulus,16),this.e=parseInt(exp,16)}RSAVerifier.prototype.verify=function(msg,encsig){encsig=encsig.replace(/[^0-9a-f]|[\s\n]]/gi,"");var sig=new BigInteger(encsig,16);if(sig.bitLength()>this.n.bitLength())throw new Error("Signature does not match with the key modulus.");var digestInfo=function(hDigestInfo){for(var algName in DigestInfoHead){var head=DigestInfoHead[algName],len=head.length;if(hDigestInfo.substring(0,len)===head)return{alg:algName,hash:hDigestInfo.substring(len)}}return[]}(sig.modPowInt(this.e,this.n).toString(16).replace(/^1f+00/,""));if(0===digestInfo.length)return!1;if(!DigestAlgs.hasOwnProperty(digestInfo.alg))throw new Error("Hashing algorithm is not supported.");var msgHash=DigestAlgs[digestInfo.alg](msg).toString();return digestInfo.hash===msgHash};var rsaVerifier=RSAVerifier;function padding$1(str){var mod=str.length%4;return 0===mod?str:str+new Array(1+(4-mod)).join("=")}function byteArrayToString$1(array){for(var result="",i=0;i<array.length;i++)result+=String.fromCharCode(array[i]);return result}function stringToByteArray$1(str){for(var arr=new Array(str.length),a=0;a<str.length;a++)arr[a]=str.charCodeAt(a);return arr}function byteArrayToHex(raw){for(var HEX="",i=0;i<raw.length;i++){var _hex=raw[i].toString(16);HEX+=2===_hex.length?_hex:"0"+_hex}return HEX}var base64_1={encodeString:function(str){return base64Js.fromByteArray(stringToByteArray$1(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,function(match,p1){return String.fromCharCode("0x"+p1)}))).replace(/\+/g,"-").replace(/\//g,"_")},decodeToString:function(str){return str=padding$1(str).replace(/\-/g,"+").replace(/_/g,"/"),decodeURIComponent(byteArrayToString$1(base64Js.toByteArray(str)).split("").map(function(c){return"%"+("00"+c.charCodeAt(0).toString(16)).slice(-2)}).join(""))},byteArrayToString:byteArrayToString$1,stringToByteArray:stringToByteArray$1,padding:padding$1,byteArrayToHex:byteArrayToHex,decodeToHEX:function(str){return byteArrayToHex(base64Js.toByteArray(padding$1(str)))},base64ToBase64Url:function(base64String){var SAFE_URL_ENCODING_MAPPING={"+":"-","/":"_","=":""};return base64String.replace(/[+\/=]/g,function(m){return SAFE_URL_ENCODING_MAPPING[m]})}},urlJoin$1=createCommonjsModule(function(module){var context,definition;context=commonjsGlobal,definition=function(){return function(){var input=arguments;"object"==typeof arguments[0]&&(input=arguments[0],arguments[1]);var joined=[].slice.call(input,0).join("/");return joined.replace(/:\//g,"://").replace(/([^:\s])\/+/g,"$1/").replace(/\/(\?|&|#[^!])/g,"$1").replace(/(\?.+)\?/g,"$1&")}},module.exports?module.exports=definition():context.urljoin=definition()});function process(jwks){return{modulus:base64_1.decodeToHEX(jwks.n),exp:base64_1.decodeToHEX(jwks.e)}}var jwks={process:process,getJWKS:function(options,cb){var url=options.jwksURI||urlJoin$1(options.iss,".well-known","jwks.json");return client.get(url).end(function(err,data){var a,key,matchingKey=null;if(err)return cb(err);for(a=0;a<data.body.keys.length&&null===matchingKey;a++)(key=data.body.keys[a]).kid===options.kid&&(matchingKey=key);return cb(null,process(matchingKey))})}};function ConfigurationError(message){this.name="ConfigurationError",this.message=message||""}function TokenValidationError(message){this.name="TokenValidationError",this.message=message||""}ConfigurationError.prototype=Error.prototype,TokenValidationError.prototype=Error.prototype;var error$1={ConfigurationError:ConfigurationError,TokenValidationError:TokenValidationError};function DummyCache(){}DummyCache.prototype.get=function(){return null},DummyCache.prototype.has=function(){return!1},DummyCache.prototype.set=function(){};var dummyCache=DummyCache,supportedAlgs=["RS256"];function IdTokenVerifier(parameters){var options=parameters||{};if(this.jwksCache=options.jwksCache||new dummyCache,this.expectedAlg=options.expectedAlg||"RS256",this.issuer=options.issuer,this.audience=options.audience,this.leeway=options.leeway||0,this.__disableExpirationCheck=options.__disableExpirationCheck||!1,this.jwksURI=options.jwksURI,this.leeway<0||this.leeway>60)throw new error$1.ConfigurationError("The leeway should be positive and lower than a minute.");if(-1===supportedAlgs.indexOf(this.expectedAlg))throw new error$1.ConfigurationError("Algorithm "+this.expectedAlg+" is not supported. (Expected algs: ["+supportedAlgs.join(",")+"])")}IdTokenVerifier.prototype.verify=function(token,nonce,cb){var jwt=this.decode(token);if(jwt instanceof Error)return cb(jwt,!1);var headAndPayload=jwt.encoded.header+"."+jwt.encoded.payload,signature=base64_1.decodeToHEX(jwt.encoded.signature),alg=jwt.header.alg,kid=jwt.header.kid,aud=jwt.payload.aud,iss=jwt.payload.iss,exp=jwt.payload.exp,nbf=jwt.payload.nbf,tnonce=jwt.payload.nonce||null;if(this.issuer!==iss)return cb(new error$1.TokenValidationError("Issuer "+iss+" is not valid."),!1);if(this.audience!==aud)return cb(new error$1.TokenValidationError("Audience "+aud+" is not valid."),!1);if(this.expectedAlg!==alg)return cb(new error$1.TokenValidationError("Algorithm "+alg+" is not supported. (Expected algs: ["+supportedAlgs.join(",")+"])"),!1);if(tnonce!==nonce)return cb(new error$1.TokenValidationError("Nonce does not match."),!1);var expirationError=this.verifyExpAndNbf(exp,nbf);return expirationError?cb(expirationError,!1):this.getRsaVerifier(iss,kid,function(err,rsaVerifier$$1){return err?cb(err):rsaVerifier$$1.verify(headAndPayload,signature)?cb(null,jwt.payload):cb(new error$1.TokenValidationError("Invalid signature."))})},IdTokenVerifier.prototype.verifyExpAndNbf=function(exp,nbf){var now=new Date,expDate=new Date(0),nbfDate=new Date(0);return this.__disableExpirationCheck?null:(expDate.setUTCSeconds(exp+this.leeway),now>expDate?new error$1.TokenValidationError("Expired token."):void 0===nbf?null:(nbfDate.setUTCSeconds(nbf-this.leeway),now<nbfDate?new error$1.TokenValidationError("The token is not valid until later in the future. Please check your computed clock."):null))},IdTokenVerifier.prototype.verifyExpAndIat=function(exp,iat){var now=new Date,expDate=new Date(0),iatDate=new Date(0);return this.__disableExpirationCheck?null:(expDate.setUTCSeconds(exp+this.leeway),now>expDate?new error$1.TokenValidationError("Expired token."):(iatDate.setUTCSeconds(iat-this.leeway),now<iatDate?new error$1.TokenValidationError("The token was issued in the future. Please check your computed clock."):null))},IdTokenVerifier.prototype.getRsaVerifier=function(iss,kid,cb){var _this=this,cachekey=iss+kid;if(this.jwksCache.has(cachekey)){var keyInfo=this.jwksCache.get(cachekey);cb(null,new rsaVerifier(keyInfo.modulus,keyInfo.exp))}else jwks.getJWKS({jwksURI:this.jwksURI,iss:iss,kid:kid},function(err,keyInfo){return err?cb(err):(_this.jwksCache.set(cachekey,keyInfo),cb(null,new rsaVerifier(keyInfo.modulus,keyInfo.exp)))})},IdTokenVerifier.prototype.decode=function(token){var header,payload,parts=token.split(".");if(3!==parts.length)return new error$1.TokenValidationError("Cannot decode a malformed JWT");try{header=JSON.parse(base64_1.decodeToString(parts[0])),payload=JSON.parse(base64_1.decodeToString(parts[1]))}catch(e){return new error$1.TokenValidationError("Token header or payload is not valid JSON")}return{header:header,payload:payload,encoded:{header:parts[0],payload:parts[1],signature:parts[2]}}},IdTokenVerifier.prototype.validateAccessToken=function(accessToken,alg,atHash,cb){if(this.expectedAlg!==alg)return cb(new error$1.TokenValidationError("Algorithm "+alg+" is not supported. (Expected alg: "+this.expectedAlg+")"));var sha256AccessToken=sha256(accessToken),hashToHex=encHex.stringify(sha256AccessToken),hashToHexFirstHalf=hashToHex.substring(0,hashToHex.length/2),hashFirstHalfWordArray=encHex.parse(hashToHexFirstHalf),hashFirstHalfBase64=encBase64.stringify(hashFirstHalfWordArray);return cb(base64_1.base64ToBase64Url(hashFirstHalfBase64)!==atHash?new error$1.TokenValidationError("Invalid access_token"):null)};var src=IdTokenVerifier;function PluginHandler(webAuth,plugins){this.plugins=plugins;for(var a=0;a<this.plugins.length;a++){if(this.plugins[a].version!==version.raw){var pluginName="";throw this.plugins[a].constructor&&this.plugins[a].constructor.name&&(pluginName=this.plugins[a].constructor.name),new Error("Plugin "+pluginName+" version ("+this.plugins[a].version+") is not compatible with the SDK version ("+version.raw+")")}this.plugins[a].setWebAuth(webAuth)}}PluginHandler.prototype.get=function(extensibilityPoint){for(var a=0;a<this.plugins.length;a++)if(this.plugins[a].supports(extensibilityPoint))return this.plugins[a].init();return null};var random={randomString:function(length){var bytes=new Uint8Array(length),result=[],charset="0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~",cryptoObj=windowHandler.getWindow().crypto||windowHandler.getWindow().msCrypto;if(!cryptoObj)return null;for(var random=cryptoObj.getRandomValues(bytes),a=0;a<random.length;a++)result.push(charset[random[a]%charset.length]);return result.join("")}},DEFAULT_NAMESPACE="com.auth0.auth.";function TransactionManager(options){var transaction=options.transaction||{};this.namespace=transaction.namespace||DEFAULT_NAMESPACE,this.keyLength=transaction.keyLength||32,this.storage=new Storage(options)}function IframeHandler(options){if(this.url=options.url,this.callback=options.callback,this.timeout=options.timeout||6e4,this.timeoutCallback=options.timeoutCallback||null,this.eventListenerType=options.eventListenerType||"message",this.iframe=null,this.timeoutHandle=null,this._destroyTimeout=null,this.transientMessageEventListener=null,this.proxyEventListener=null,this.eventValidator=options.eventValidator||{isValid:function(){return!0}},"function"!=typeof this.callback)throw new Error("options.callback must be a function")}function WebMessageHandler(webAuth){this.webAuth=webAuth,this.warn=new Warn(webAuth.baseOptions)}function CrossOriginAuthentication(webAuth,options){this.webAuth=webAuth,this.baseOptions=options,this.request=new RequestBuilder(options),this.webMessageHandler=new WebMessageHandler(webAuth),this.storage=new Storage(options)}function createKey(origin,coId){return["co/verifier",encodeURIComponent(origin),encodeURIComponent(coId)].join("/")}function Redirect(auth0,options){this.webAuth=auth0,this.baseOptions=options,this.crossOriginAuthentication=new CrossOriginAuthentication(auth0,this.baseOptions),this.warn=new Warn({disableWarnings:!!options._disableDeprecationWarnings})}TransactionManager.prototype.process=function(options){if(!options.responseType)throw new Error("responseType is required");var lastUsedConnection=options.realm||options.connection,responseTypeIncludesIdToken=-1!==options.responseType.indexOf("id_token"),transaction=this.generateTransaction(options.appState,options.state,options.nonce,lastUsedConnection,responseTypeIncludesIdToken);return options.state||(options.state=transaction.state),responseTypeIncludesIdToken&&!options.nonce&&(options.nonce=transaction.nonce),options},TransactionManager.prototype.generateTransaction=function(appState,state,nonce,lastUsedConnection,generateNonce){return state=state||random.randomString(this.keyLength),nonce=nonce||(generateNonce?random.randomString(this.keyLength):null),this.storage.setItem(this.namespace+state,{nonce:nonce,appState:appState,state:state,lastUsedConnection:lastUsedConnection},{expires:1/48}),{state:state,nonce:nonce}},TransactionManager.prototype.getStoredTransaction=function(state){var transactionData;return transactionData=this.storage.getItem(this.namespace+state),this.clearTransaction(state),transactionData},TransactionManager.prototype.clearTransaction=function(state){this.storage.removeItem(this.namespace+state)},IframeHandler.prototype.init=function(){var _this=this,_window=windowHandler.getWindow();switch(this.iframe=_window.document.createElement("iframe"),this.iframe.style.display="none",this.proxyEventListener=function(e){_this.eventListener(e)},this.eventListenerType){case"message":this.eventSourceObject=_window;break;case"load":this.eventSourceObject=this.iframe;break;default:throw new Error("Unsupported event listener type: "+this.eventListenerType)}this.eventSourceObject.addEventListener(this.eventListenerType,this.proxyEventListener,!1),_window.document.body.appendChild(this.iframe),this.iframe.src=this.url,this.timeoutHandle=setTimeout(function(){_this.timeoutHandler()},this.timeout)},IframeHandler.prototype.eventListener=function(event){var eventData={event:event,sourceObject:this.eventSourceObject};this.eventValidator.isValid(eventData)&&(this.destroy(),this.callback(eventData))},IframeHandler.prototype.timeoutHandler=function(){this.destroy(),this.timeoutCallback&&this.timeoutCallback()},IframeHandler.prototype.destroy=function(){var _this=this;clearTimeout(this.timeoutHandle),this._destroyTimeout=setTimeout(function(){_this.eventSourceObject.removeEventListener(_this.eventListenerType,_this.proxyEventListener,!1),_this.iframe.parentNode&&_this.iframe.parentNode.removeChild(_this.iframe)},0)},WebMessageHandler.prototype.run=function(options,cb){var _this=this;options.responseMode="web_message",options.prompt="none";var currentOrigin=windowHandler.getOrigin(),redirectUriOrigin=objectHelper.getOriginFromUrl(options.redirectUri);if(redirectUriOrigin&&currentOrigin!==redirectUriOrigin)return cb({error:"origin_mismatch",error_description:"The redirectUri's origin ("+redirectUriOrigin+") should match the window's origin ("+currentOrigin+")."});!function(authorizeUrl,options,callback){new IframeHandler({url:authorizeUrl,eventListenerType:"message",callback:function(eventData){callback(null,eventData)},timeout:options.timeout,eventValidator:{isValid:function(eventData){return"authorization_response"===eventData.event.data.type&&options.state===eventData.event.data.response.state}},timeoutCallback:function(){callback({error:"timeout",error_description:"Timeout during executing web_message communication",state:options.state})}}).init()}(this.webAuth.client.buildAuthorizeUrl(options),options,function(err,eventData){var error=err;if(!err&&eventData.event.data.response.error&&(error=eventData.event.data.response),!error){var parsedHash=eventData.event.data.response;return _this.webAuth.validateAuthenticationResponse(options,parsedHash,cb)}return"consent_required"===error.error&&"localhost"===windowHandler.getWindow().location.hostname&&_this.warn.warning("Consent Required. Consent can't be skipped on localhost. Read more here: https://auth0.com/docs/api-auth/user-consent#skipping-consent-for-first-party-clients"),_this.webAuth.transactionManager.clearTransaction(error.state),cb(objectHelper.pick(error,["error","error_description"]))})},CrossOriginAuthentication.prototype.login=function(options,cb){var _this=this,url=urlJoin(this.baseOptions.rootUrl,"/co/authenticate");options.username=options.username||options.email,delete options.email;var authenticateBody={client_id:options.clientID||this.baseOptions.clientID,username:options.username};options.password&&(authenticateBody.password=options.password),options.otp&&(authenticateBody.otp=options.otp);var realm=options.realm||this.baseOptions.realm;if(realm){var credentialType=options.credentialType||this.baseOptions.credentialType||"http://auth0.com/oauth/grant-type/password-realm";authenticateBody.realm=realm,authenticateBody.credential_type=credentialType}else authenticateBody.credential_type="password";this.request.post(url).withCredentials().send(authenticateBody).end(function(err,data){if(err){var errorObject=err.response&&err.response.body||{error:"request_error",error_description:JSON.stringify(err)};return wrapCallback(cb,{forceLegacyError:!0})(errorObject)}var popupMode=!0===options.popup;options=objectHelper.blacklist(options,["password","credentialType","otp","popup"]);var authorizeOptions=objectHelper.merge(options).with({loginTicket:data.body.login_ticket}),key=createKey(_this.baseOptions.rootUrl,data.body.co_id);_this.storage.setItem(key,data.body.co_verifier,{expires:1/96}),popupMode?_this.webMessageHandler.run(authorizeOptions,wrapCallback(cb,{forceLegacyError:!0})):_this.webAuth.authorize(authorizeOptions)})},CrossOriginAuthentication.prototype.callback=function(){var targetOrigin=decodeURIComponent(function(name){var parts=("&"+windowHandler.getWindow().location.hash.substring(1)).split("&"+name+"=");if(2===parts.length)return parts.pop().split("&").shift()}("origin")),theWindow=windowHandler.getWindow(),_this=this;theWindow.addEventListener("message",function(evt){if("co_verifier_request"===evt.data.type){var key=createKey(evt.origin,evt.data.request.id),verifier=function(storage,key){try{var verifier=storage.getItem(key);return storage.removeItem(key),verifier||""}catch(e){return""}}(_this.storage,key);evt.source.postMessage({type:"co_verifier_response",response:{verifier:verifier}},evt.origin)}}),theWindow.parent.postMessage({type:"ready"},targetOrigin)},Redirect.prototype.loginWithCredentials=function(options,cb){options.realm=options.realm||options.connection,delete options.connection,this.crossOriginAuthentication.login(options,cb)},Redirect.prototype.signupAndLogin=function(options,cb){var _this=this;return this.webAuth.client.dbConnection.signup(options,function(err){return err?cb(err):(options.realm=options.realm||options.connection,delete options.connection,_this.webAuth.login(options,cb))})};var winchan=createCommonjsModule(function(module){var WinChan=function(){var RELAY_FRAME_NAME="__winchan_relay_frame",CLOSE_CMD="die";function addListener(w,event,cb){w.attachEvent?w.attachEvent("on"+event,cb):w.addEventListener&&w.addEventListener(event,cb,!1)}function removeListener(w,event,cb){w.detachEvent?w.detachEvent("on"+event,cb):w.removeEventListener&&w.removeEventListener(event,cb,!1)}function extractOrigin(url){/^https?:\/\//.test(url)||(url=window.location.href);var m=/^(https?:\/\/[\-_a-zA-Z\.0-9:]+)/.exec(url);return m?m[1]:url}var isIE=function(){if("undefined"==typeof navigator)return!1;var rv=-1,ua=navigator.userAgent;"Microsoft Internet Explorer"===navigator.appName?null!=new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})").exec(ua)&&(rv=parseFloat(RegExp.$1)):ua.indexOf("Trident")>-1&&null!==new RegExp("rv:([0-9]{2,2}[.0-9]{0,})").exec(ua)&&(rv=parseFloat(RegExp.$1));return rv>=8}();return"undefined"!=typeof window&&window.JSON&&window.JSON.stringify&&window.JSON.parse&&window.postMessage?{open:function(opts,cb){if(!cb)throw"missing required callback argument";var err,iframe;opts.url||(err="missing required 'url' parameter"),opts.relay_url||(err="missing required 'relay_url' parameter"),err&&setTimeout(function(){cb(err)},0),opts.window_name||(opts.window_name=null),opts.window_features&&!function(){try{var userAgent=navigator.userAgent;return-1!=userAgent.indexOf("Fennec/")||-1!=userAgent.indexOf("Firefox/")&&-1!=userAgent.indexOf("Android")}catch(e){}return!1}()||(opts.window_features=void 0);var messageTarget,origin=opts.origin||extractOrigin(opts.url);if(origin!==extractOrigin(opts.relay_url))return setTimeout(function(){cb("invalid arguments: origin of url and relay_url must match")},0);isIE&&((iframe=document.createElement("iframe")).setAttribute("src",opts.relay_url),iframe.style.display="none",iframe.setAttribute("name",RELAY_FRAME_NAME),document.body.appendChild(iframe),messageTarget=iframe.contentWindow);var w=opts.popup||window.open(opts.url,opts.window_name,opts.window_features);opts.popup&&(w.location.href=opts.url),messageTarget||(messageTarget=w);var closeInterval=setInterval(function(){w&&w.closed&&(cleanup(),cb&&(cb("User closed the popup window"),cb=null))},500),req=JSON.stringify({a:"request",d:opts.params});function cleanup(){if(iframe&&document.body.removeChild(iframe),iframe=void 0,closeInterval&&(closeInterval=clearInterval(closeInterval)),removeListener(window,"message",onMessage),removeListener(window,"unload",cleanup),w)try{w.close()}catch(securityViolation){messageTarget.postMessage(CLOSE_CMD,origin)}w=messageTarget=void 0}function onMessage(e){if(e.origin===origin){try{var d=JSON.parse(e.data)}catch(err){if(cb)return cb(err);throw err}"ready"===d.a?messageTarget.postMessage(req,origin):"error"===d.a?(cleanup(),cb&&(cb(d.d),cb=null)):"response"===d.a&&(cleanup(),cb&&(cb(null,d.d),cb=null))}}return addListener(window,"unload",cleanup),addListener(window,"message",onMessage),{close:cleanup,focus:function(){if(w)try{w.focus()}catch(e){}}}},onOpen:function(cb){var o="*",msgTarget=isIE?function(){window.location;for(var frames=window.opener.frames,i=frames.length-1;i>=0;i--)try{if(frames[i].location.protocol===window.location.protocol&&frames[i].location.host===window.location.host&&frames[i].name===RELAY_FRAME_NAME)return frames[i]}catch(e){}}():window.opener;if(!msgTarget)throw"can't find relay frame";function doPost(msg){msg=JSON.stringify(msg),isIE?msgTarget.doPost(msg,o):msgTarget.postMessage(msg,o)}function onDie(e){if(e.data===CLOSE_CMD)try{window.close()}catch(o_O){}}addListener(isIE?msgTarget:window,"message",function onMessage(e){var d;try{d=JSON.parse(e.data)}catch(err){}d&&"request"===d.a&&(removeListener(window,"message",onMessage),o=e.origin,cb&&setTimeout(function(){cb(o,d.d,function(r){cb=void 0,doPost({a:"response",d:r})})},0))}),addListener(isIE?msgTarget:window,"message",onDie);try{doPost({a:"ready"})}catch(e){addListener(msgTarget,"load",function(e){doPost({a:"ready"})})}var onUnload=function(){try{removeListener(isIE?msgTarget:window,"message",onDie)}catch(ohWell){}cb&&doPost({a:"error",d:"client closed window"}),cb=void 0;try{window.close()}catch(e){}};return addListener(window,"unload",onUnload),{detach:function(){removeListener(window,"unload",onUnload)}}}}:{open:function(url,winopts,arg,cb){setTimeout(function(){cb("unsupported browser")},0)},onOpen:function(cb){setTimeout(function(){cb("unsupported browser")},0)}}}();module.exports&&(module.exports=WinChan)});var urlHelper={extractOrigin:function(url){/^https?:\/\//.test(url)||(url=window.location.href);var m=/^(https?:\/\/[-_a-zA-Z.0-9:]+)/.exec(url);return m?m[1]:url}};function PopupHandler(){this._current_popup=null}function Popup(webAuth,options){this.baseOptions=options,this.baseOptions.popupOrigin=options.popupOrigin,this.client=webAuth.client,this.webAuth=webAuth,this.transactionManager=new TransactionManager(this.baseOptions),this.crossOriginAuthentication=new CrossOriginAuthentication(webAuth,this.baseOptions),this.warn=new Warn({disableWarnings:!!options._disableDeprecationWarnings})}function SilentAuthenticationHandler(options){this.authenticationUrl=options.authenticationUrl,this.timeout=options.timeout||6e4,this.handler=null,this.postMessageDataType=options.postMessageDataType||!1,this.postMessageOrigin=options.postMessageOrigin||windowHandler.getWindow().location.origin||windowHandler.getWindow().location.protocol+"//"+windowHandler.getWindow().location.hostname+(windowHandler.getWindow().location.port?":"+windowHandler.getWindow().location.port:"")}function UsernamePassword(options){this.baseOptions=options,this.request=new RequestBuilder(options),this.transactionManager=new TransactionManager(this.baseOptions)}function HostedPages(client,options){this.baseOptions=options,this.client=client,this.request=new RequestBuilder(this.baseOptions),this.warn=new Warn({disableWarnings:!!options._disableDeprecationWarnings})}function WebAuth(options){assert.check(options,{type:"object",message:"options parameter is not valid"},{domain:{type:"string",message:"domain option is required"},clientID:{type:"string",message:"clientID option is required"},responseType:{optional:!0,type:"string",message:"responseType is not valid"},responseMode:{optional:!0,type:"string",message:"responseMode is not valid"},redirectUri:{optional:!0,type:"string",message:"redirectUri is not valid"},scope:{optional:!0,type:"string",message:"scope is not valid"},audience:{optional:!0,type:"string",message:"audience is not valid"},popupOrigin:{optional:!0,type:"string",message:"popupOrigin is not valid"},leeway:{optional:!0,type:"number",message:"leeway is not valid"},plugins:{optional:!0,type:"array",message:"plugins is not valid"},_disableDeprecationWarnings:{optional:!0,type:"boolean",message:"_disableDeprecationWarnings option is not valid"},_sendTelemetry:{optional:!0,type:"boolean",message:"_sendTelemetry option is not valid"},_telemetryInfo:{optional:!0,type:"object",message:"_telemetryInfo option is not valid"},_timesToRetryFailedRequests:{optional:!0,type:"number",message:"_timesToRetryFailedRequests option is not valid"}}),options.overrides&&assert.check(options.overrides,{type:"object",message:"overrides option is not valid"},{__tenant:{optional:!0,type:"string",message:"__tenant option is required"},__token_issuer:{optional:!0,type:"string",message:"__token_issuer option is required"},__jwks_uri:{optional:!0,type:"string",message:"__jwks_uri is required"}}),this.baseOptions=options,this.baseOptions.plugins=new PluginHandler(this,this.baseOptions.plugins||[]),this.baseOptions._sendTelemetry=!1!==this.baseOptions._sendTelemetry||this.baseOptions._sendTelemetry,this.baseOptions._timesToRetryFailedRequests=options._timesToRetryFailedRequests?parseInt(options._timesToRetryFailedRequests,0):0,this.baseOptions.tenant=this.baseOptions.overrides&&this.baseOptions.overrides.__tenant||this.baseOptions.domain.split(".")[0],this.baseOptions.token_issuer=this.baseOptions.overrides&&this.baseOptions.overrides.__token_issuer||"https://"+this.baseOptions.domain+"/",this.baseOptions.jwksURI=this.baseOptions.overrides&&this.baseOptions.overrides.__jwks_uri,this.transactionManager=new TransactionManager(this.baseOptions),this.client=new Authentication(this.baseOptions),this.redirect=new Redirect(this,this.baseOptions),this.popup=new Popup(this,this.baseOptions),this.crossOriginAuthentication=new CrossOriginAuthentication(this,this.baseOptions),this.webMessageHandler=new WebMessageHandler(this),this._universalLogin=new HostedPages(this,this.baseOptions),this.ssodataStorage=new SSODataStorage(this.baseOptions)}function PasswordlessAuthentication(request,options){this.baseOptions=options,this.request=request}function DBConnection(request,options){this.baseOptions=options,this.request=request}function Authentication(auth0,options){2===arguments.length?this.auth0=auth0:options=auth0,assert.check(options,{type:"object",message:"options parameter is not valid"},{domain:{type:"string",message:"domain option is required"},clientID:{type:"string",message:"clientID option is required"},responseType:{optional:!0,type:"string",message:"responseType is not valid"},responseMode:{optional:!0,type:"string",message:"responseMode is not valid"},redirectUri:{optional:!0,type:"string",message:"redirectUri is not valid"},scope:{optional:!0,type:"string",message:"scope is not valid"},audience:{optional:!0,type:"string",message:"audience is not valid"},_disableDeprecationWarnings:{optional:!0,type:"boolean",message:"_disableDeprecationWarnings option is not valid"},_sendTelemetry:{optional:!0,type:"boolean",message:"_sendTelemetry option is not valid"},_telemetryInfo:{optional:!0,type:"object",message:"_telemetryInfo option is not valid"}}),this.baseOptions=options,this.baseOptions._sendTelemetry=!1!==this.baseOptions._sendTelemetry||this.baseOptions._sendTelemetry,this.baseOptions.rootUrl="https://"+this.baseOptions.domain,this.request=new RequestBuilder(this.baseOptions),this.passwordless=new PasswordlessAuthentication(this.request,this.baseOptions),this.dbConnection=new DBConnection(this.request,this.baseOptions),this.warn=new Warn({disableWarnings:!!options._disableDeprecationWarnings}),this.ssodataStorage=new SSODataStorage(this.baseOptions)}function Management(options){assert.check(options,{type:"object",message:"options parameter is not valid"},{domain:{type:"string",message:"domain option is required"},token:{type:"string",message:"token option is required"},_sendTelemetry:{optional:!0,type:"boolean",message:"_sendTelemetry option is not valid"},_telemetryInfo:{optional:!0,type:"object",message:"_telemetryInfo option is not valid"}}),this.baseOptions=options,this.baseOptions.headers={Authorization:"Bearer "+this.baseOptions.token},this.request=new RequestBuilder(this.baseOptions),this.baseOptions.rootUrl=urlJoin("https://"+this.baseOptions.domain,"api","v2")}PopupHandler.prototype.calculatePosition=function(options){var width=options.width||500,height=options.height||600,_window=windowHandler.getWindow(),screenX=void 0!==_window.screenX?_window.screenX:_window.screenLeft,screenY=void 0!==_window.screenY?_window.screenY:_window.screenTop;return{width:width,height:height,left:screenX+((void 0!==_window.outerWidth?_window.outerWidth:_window.document.body.clientWidth)-width)/2,top:screenY+((void 0!==_window.outerHeight?_window.outerHeight:_window.document.body.clientHeight)-height)/2}},PopupHandler.prototype.preload=function(options){var _this=this,_window=windowHandler.getWindow(),popupPosition=this.calculatePosition(options.popupOptions||{}),popupOptions=objectHelper.merge(popupPosition).with(options.popupOptions),url=options.url||"about:blank",windowFeatures=lib_stringify(popupOptions,{encode:!1,delimiter:","});return this._current_popup&&!this._current_popup.closed?this._current_popup:(this._current_popup=_window.open(url,"auth0_signup_popup",windowFeatures),this._current_popup.kill=function(){this.close(),_this._current_popup=null},this._current_popup)},PopupHandler.prototype.load=function(url,relayUrl,options,cb){var _this=this,popupPosition=this.calculatePosition(options.popupOptions||{}),popupOptions=objectHelper.merge(popupPosition).with(options.popupOptions),winchanOptions=objectHelper.merge({url:url,relay_url:relayUrl,window_features:lib_stringify(popupOptions,{delimiter:",",encode:!1}),popup:this._current_popup}).with(options),popup=winchan.open(winchanOptions,function(err,data){return _this._current_popup=null,cb(err,data)});return popup.focus(),popup},Popup.prototype.buildPopupHandler=function(){var pluginHandler=this.baseOptions.plugins.get("popup.getPopupHandler");return pluginHandler?pluginHandler.getPopupHandler():new PopupHandler},Popup.prototype.preload=function(options){options=options||{};var popup=this.buildPopupHandler();return popup.preload(options),popup},Popup.prototype.getPopupHandler=function(options,preload){return options.popupHandler?options.popupHandler:preload?this.preload(options):this.buildPopupHandler()},Popup.prototype.callback=function(options){var _this=this,theWindow=windowHandler.getWindow(),originUrl=(options=options||{}).popupOrigin||this.baseOptions.popupOrigin||windowHandler.getOrigin();theWindow.opener?winchan.onOpen(function(popupOrigin,r,cb){if(popupOrigin!==originUrl)return cb({error:"origin_mismatch",error_description:"The popup's origin ("+popupOrigin+") should match the `popupOrigin` parameter ("+originUrl+")."});_this.webAuth.parseHash(options||{},function(err,data){return cb(err||data)})}):theWindow.doPost=function(msg){theWindow.parent&&theWindow.parent.postMessage(msg,originUrl)}},Popup.prototype.authorize=function(options,cb){var url,relayUrl,popOpts={},pluginHandler=this.baseOptions.plugins.get("popup.authorize"),params=objectHelper.merge(this.baseOptions,["clientID","scope","domain","audience","tenant","responseType","redirectUri","_csrf","state","_intstate","nonce"]).with(objectHelper.blacklist(options,["popupHandler"]));return assert.check(params,{type:"object",message:"options parameter is not valid"},{responseType:{type:"string",message:"responseType option is required"}}),relayUrl=urlJoin(this.baseOptions.rootUrl,"relay.html"),options.owp?params.owp=!0:(popOpts.origin=urlHelper.extractOrigin(params.redirectUri),relayUrl=params.redirectUri),options.popupOptions&&(popOpts.popupOptions=objectHelper.pick(options.popupOptions,["width","height"])),pluginHandler&&(params=pluginHandler.processParams(params)),(params=this.transactionManager.process(params)).scope=params.scope||"openid profile email",delete params.domain,url=this.client.buildAuthorizeUrl(params),this.getPopupHandler(options).load(url,relayUrl,popOpts,wrapCallback(cb))},Popup.prototype.loginWithCredentials=function(options,cb){options.realm=options.realm||options.connection,options.popup=!0,options=objectHelper.merge(this.baseOptions,["redirectUri","responseType","state","nonce"]).with(objectHelper.blacklist(options,["popupHandler","connection"])),options=this.transactionManager.process(options),this.crossOriginAuthentication.login(options,cb)},Popup.prototype.passwordlessVerify=function(options,cb){var _this=this;return this.client.passwordless.verify(objectHelper.blacklist(options,["popupHandler"]),function(err){if(err)return cb(err);options.username=options.phoneNumber||options.email,options.password=options.verificationCode,delete options.email,delete options.phoneNumber,delete options.verificationCode,delete options.type,_this.client.loginWithResourceOwner(options,cb)})},Popup.prototype.signupAndLogin=function(options,cb){var _this=this,popupHandler=this.getPopupHandler(options,!0);return options.popupHandler=popupHandler,this.client.dbConnection.signup(objectHelper.blacklist(options,["popupHandler"]),function(err){if(err)return popupHandler._current_popup&&popupHandler._current_popup.kill(),cb(err);_this.loginWithCredentials(options,cb)})},SilentAuthenticationHandler.create=function(options){return new SilentAuthenticationHandler(options)},SilentAuthenticationHandler.prototype.login=function(usePostMessage,callback){this.handler=new IframeHandler({auth0:this.auth0,url:this.authenticationUrl,eventListenerType:usePostMessage?"message":"load",callback:this.getCallbackHandler(callback,usePostMessage),timeout:this.timeout,eventValidator:this.getEventValidator(),timeoutCallback:function(){callback(null,"#error=timeout&error_description=Timeout+during+authentication+renew.")},usePostMessage:usePostMessage||!1}),this.handler.init()},SilentAuthenticationHandler.prototype.getEventValidator=function(){var _this=this;return{isValid:function(eventData){switch(eventData.event.type){case"message":return eventData.event.origin===_this.postMessageOrigin&&eventData.event.source===_this.handler.iframe.contentWindow&&(!1===_this.postMessageDataType||eventData.event.data.type&&eventData.event.data.type===_this.postMessageDataType);case"load":if("about:"===eventData.sourceObject.contentWindow.location.protocol)return!1;default:return!0}}}},SilentAuthenticationHandler.prototype.getCallbackHandler=function(callback,usePostMessage){return function(eventData){var callbackValue;callbackValue=usePostMessage?"object"==typeof eventData.event.data&&eventData.event.data.hash?eventData.event.data.hash:eventData.event.data:eventData.sourceObject.contentWindow.location.hash,callback(null,callbackValue)}},UsernamePassword.prototype.login=function(options,cb){var url,body;return url=urlJoin(this.baseOptions.rootUrl,"usernamepassword","login"),options.username=options.username||options.email,options=objectHelper.blacklist(options,["email"]),body=objectHelper.merge(this.baseOptions,["clientID","redirectUri","tenant","responseType","responseMode","scope","audience"]).with(options),body=this.transactionManager.process(body),body=objectHelper.toSnakeCase(body,["auth0Client"]),this.request.post(url).send(body).end(wrapCallback(cb))},UsernamePassword.prototype.callback=function(formHtml){var div,_document=windowHandler.getDocument();(div=_document.createElement("div")).innerHTML=formHtml,_document.body.appendChild(div).children[0].submit()},HostedPages.prototype.login=function(options,cb){if(windowHandler.getWindow().location.host!==this.baseOptions.domain)throw new Error("This method is meant to be used only inside the Universal Login Page.");var usernamePassword,params=objectHelper.merge(this.baseOptions,["clientID","redirectUri","tenant","responseType","responseMode","scope","audience","_csrf","state","_intstate","nonce"]).with(options);return assert.check(params,{type:"object",message:"options parameter is not valid"},{responseType:{type:"string",message:"responseType option is required"}}),(usernamePassword=new UsernamePassword(this.baseOptions)).login(params,function(err,data){return err?cb(err):usernamePassword.callback(data)})},HostedPages.prototype.signupAndLogin=function(options,cb){var _this=this;return _this.client.client.dbConnection.signup(options,function(err){return err?cb(err):_this.login(options,cb)})},HostedPages.prototype.getSSOData=function(withActiveDirectories,cb){var url,params="";return"function"==typeof withActiveDirectories&&(cb=withActiveDirectories,withActiveDirectories=!1),assert.check(withActiveDirectories,{type:"boolean",message:"withActiveDirectories parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),withActiveDirectories&&(params="?"+lib_stringify({ldaps:1,client_id:this.baseOptions.clientID})),url=urlJoin(this.baseOptions.rootUrl,"user","ssodata",params),this.request.get(url,{noHeaders:!0}).withCredentials().end(wrapCallback(cb))},WebAuth.prototype.parseHash=function(options,cb){var parsedQs,err;cb||"function"!=typeof options?options=options||{}:(cb=options,options={});var _window=windowHandler.getWindow(),hashStr=void 0===options.hash?_window.location.hash:options.hash;if(hashStr=hashStr.replace(/^#?\/?/,""),(parsedQs=lib_parse(hashStr)).hasOwnProperty("error"))return err=error.buildResponse(parsedQs.error,parsedQs.error_description),parsedQs.state&&(err.state=parsedQs.state),cb(err);if(!parsedQs.hasOwnProperty("access_token")&&!parsedQs.hasOwnProperty("id_token")&&!parsedQs.hasOwnProperty("refresh_token"))return cb(null,null);var responseTypes=(this.baseOptions.responseType||options.responseType||"").split(" ");return responseTypes.length>0&&-1!==responseTypes.indexOf("token")&&!parsedQs.hasOwnProperty("access_token")?cb(error.buildResponse("invalid_hash","response_type contains `token`, but the parsed hash does not contain an `access_token` property")):responseTypes.length>0&&-1!==responseTypes.indexOf("id_token")&&!parsedQs.hasOwnProperty("id_token")?cb(error.buildResponse("invalid_hash","response_type contains `id_token`, but the parsed hash does not contain an `id_token` property")):this.validateAuthenticationResponse(options,parsedQs,cb)},WebAuth.prototype.validateAuthenticationResponse=function(options,parsedHash,cb){var _this=this;options.__enableIdPInitiatedLogin=options.__enableIdPInitiatedLogin||options.__enableImpersonation;var state=parsedHash.state,transaction=this.transactionManager.getStoredTransaction(state),transactionState=options.state||transaction&&transaction.state||null,transactionStateMatchesState=transactionState===state;if(!(!state&&!transactionState&&options.__enableIdPInitiatedLogin)&&!transactionStateMatchesState)return cb({error:"invalid_token",errorDescription:"`state` does not match."});var transactionNonce=options.nonce||transaction&&transaction.nonce||null,appState=options.state||transaction&&transaction.appState||null,callback=function(err,payload){if(err)return cb(err);var sub;transaction&&transaction.lastUsedConnection&&(payload&&(sub=payload.sub),_this.ssodataStorage.set(transaction.lastUsedConnection,sub));return cb(null,function(qsParams,appState,token){return{accessToken:qsParams.access_token||null,idToken:qsParams.id_token||null,idTokenPayload:token||null,appState:appState||null,refreshToken:qsParams.refresh_token||null,state:qsParams.state||null,expiresIn:qsParams.expires_in?parseInt(qsParams.expires_in,10):null,tokenType:qsParams.token_type||null,scope:qsParams.scope||null}}(parsedHash,appState,payload))};return parsedHash.id_token?this.validateToken(parsedHash.id_token,transactionNonce,function(validationError,payload){if(!validationError)return parsedHash.access_token&&payload.at_hash?(new src).validateAccessToken(parsedHash.access_token,"RS256",payload.at_hash,function(err){return err?callback(error.invalidToken(err.message)):callback(null,payload)}):callback(null,payload);if("invalid_token"!==validationError.error)return callback(validationError);if("HS256"!==(new src).decode(parsedHash.id_token).header.alg)return callback(validationError);if(!parsedHash.access_token){return callback({error:"invalid_token",description:"The id_token cannot be validated because it was signed with the HS256 algorithm and public clients (like a browser) can’t store secrets. Please read the associated doc for possible ways to fix this. Read more: https://auth0.com/docs/errors/libraries/auth0-js/invalid-token#parsing-an-hs256-signed-id-token-without-an-access-token"})}return _this.client.userInfo(parsedHash.access_token,function(errUserInfo,profile){return errUserInfo?callback(errUserInfo):callback(null,profile)})}):callback(null,null)},WebAuth.prototype.validateToken=function(token,nonce,cb){new src({issuer:this.baseOptions.token_issuer,jwksURI:this.baseOptions.jwksURI,audience:this.baseOptions.clientID,leeway:this.baseOptions.leeway||0,__disableExpirationCheck:this.baseOptions.__disableExpirationCheck}).verify(token,nonce,function(err,payload){if(err)return cb(error.invalidToken(err.message));cb(null,payload)})},WebAuth.prototype.renewAuth=function(options,cb){var usePostMessage=!!options.usePostMessage,postMessageDataType=options.postMessageDataType||!1,postMessageOrigin=options.postMessageOrigin||windowHandler.getWindow().origin,timeout=options.timeout,_this=this,params=objectHelper.merge(this.baseOptions,["clientID","redirectUri","responseType","scope","audience","_csrf","state","_intstate","nonce"]).with(options);params.responseType=params.responseType||"token",params.responseMode=params.responseMode||"fragment",params=this.transactionManager.process(params),assert.check(params,{type:"object",message:"options parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),params.prompt="none",params=objectHelper.blacklist(params,["usePostMessage","tenant","postMessageDataType","postMessageOrigin"]),SilentAuthenticationHandler.create({authenticationUrl:this.client.buildAuthorizeUrl(params),postMessageDataType:postMessageDataType,postMessageOrigin:postMessageOrigin,timeout:timeout}).login(usePostMessage,function(err,hash){if("object"==typeof hash)return cb(err,hash);_this.parseHash({hash:hash},cb)})},WebAuth.prototype.checkSession=function(options,cb){var params=objectHelper.merge(this.baseOptions,["clientID","responseType","redirectUri","scope","audience","_csrf","state","_intstate","nonce"]).with(options);return"code"===params.responseType?cb({error:"error",error_description:"responseType can't be `code`"}):(options.nonce||(params=this.transactionManager.process(params)),params.redirectUri?(assert.check(params,{type:"object",message:"options parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),params=objectHelper.blacklist(params,["usePostMessage","tenant","postMessageDataType"]),void this.webMessageHandler.run(params,cb)):cb({error:"error",error_description:"redirectUri can't be empty"}))},WebAuth.prototype.changePassword=function(options,cb){return this.client.dbConnection.changePassword(options,cb)},WebAuth.prototype.passwordlessStart=function(options,cb){var authParams=objectHelper.merge(this.baseOptions,["responseType","responseMode","redirectUri","scope","audience","_csrf","state","_intstate","nonce"]).with(options.authParams);return options.authParams=this.transactionManager.process(authParams),this.client.passwordless.start(options,cb)},WebAuth.prototype.signup=function(options,cb){return this.client.dbConnection.signup(options,cb)},WebAuth.prototype.authorize=function(options){var params=objectHelper.merge(this.baseOptions,["clientID","responseType","responseMode","redirectUri","scope","audience","_csrf","state","_intstate","nonce"]).with(options);assert.check(params,{type:"object",message:"options parameter is not valid"},{responseType:{type:"string",message:"responseType option is required"}}),(params=this.transactionManager.process(params)).scope=params.scope||"openid profile email",windowHandler.redirect(this.client.buildAuthorizeUrl(params))},WebAuth.prototype.signupAndAuthorize=function(options,cb){var _this=this;return this.client.dbConnection.signup(objectHelper.blacklist(options,["popupHandler"]),function(err){if(err)return cb(err);options.realm=options.connection,options.username||(options.username=options.email),_this.client.login(options,cb)})},WebAuth.prototype.login=function(options,cb){var params=objectHelper.merge(this.baseOptions,["clientID","responseType","redirectUri","scope","audience","_csrf","state","_intstate","nonce"]).with(options);params=this.transactionManager.process(params),windowHandler.getWindow().location.host===this.baseOptions.domain?(params.connection=params.realm,delete params.realm,this._universalLogin.login(params,cb)):this.crossOriginAuthentication.login(params,cb)},WebAuth.prototype.passwordlessLogin=function(options,cb){var params=objectHelper.merge(this.baseOptions,["clientID","responseType","redirectUri","scope","audience","_csrf","state","_intstate","nonce"]).with(options);if(params=this.transactionManager.process(params),windowHandler.getWindow().location.host===this.baseOptions.domain)this.passwordlessVerify(params,cb);else{var crossOriginOptions=objectHelper.extend({credentialType:"http://auth0.com/oauth/grant-type/passwordless/otp",realm:params.connection,username:params.email||params.phoneNumber,otp:params.verificationCode},objectHelper.blacklist(params,["connection","email","phoneNumber","verificationCode"]));this.crossOriginAuthentication.login(crossOriginOptions,cb)}},WebAuth.prototype.crossOriginAuthenticationCallback=function(){this.crossOriginVerification()},WebAuth.prototype.crossOriginVerification=function(){this.crossOriginAuthentication.callback()},WebAuth.prototype.logout=function(options){windowHandler.redirect(this.client.buildLogoutUrl(options))},WebAuth.prototype.passwordlessVerify=function(options,cb){var _this=this,params=objectHelper.merge(this.baseOptions,["clientID","responseType","responseMode","redirectUri","scope","audience","_csrf","state","_intstate","nonce"]).with(options);return assert.check(params,{type:"object",message:"options parameter is not valid"},{responseType:{type:"string",message:"responseType option is required"}}),params=this.transactionManager.process(params),this.client.passwordless.verify(params,function(err){return err?cb(err):windowHandler.redirect(_this.client.passwordless.buildVerifyUrl(params))})},PasswordlessAuthentication.prototype.buildVerifyUrl=function(options){var params,qString;return assert.check(options,{type:"object",message:"options parameter is not valid"},{connection:{type:"string",message:"connection option is required"},verificationCode:{type:"string",message:"verificationCode option is required"},phoneNumber:{optional:!1,type:"string",message:"phoneNumber option is required",condition:function(o){return!o.email}},email:{optional:!1,type:"string",message:"email option is required",condition:function(o){return!o.phoneNumber}}}),params=objectHelper.merge(this.baseOptions,["clientID","responseType","responseMode","redirectUri","scope","audience","_csrf","state","_intstate","protocol","nonce"]).with(options),this.baseOptions._sendTelemetry&&(params.auth0Client=this.request.getTelemetryData()),params=objectHelper.toSnakeCase(params,["auth0Client"]),qString=lib_stringify(params),urlJoin(this.baseOptions.rootUrl,"passwordless","verify_redirect","?"+qString)},PasswordlessAuthentication.prototype.start=function(options,cb){var url,body;return assert.check(options,{type:"object",message:"options parameter is not valid"},{connection:{type:"string",message:"connection option is required"},send:{type:"string",message:"send option is required",values:["link","code"],value_message:"send is not valid ([link, code])"},phoneNumber:{optional:!0,type:"string",message:"phoneNumber option is required",condition:function(o){return"code"===o.send||!o.email}},email:{optional:!0,type:"string",message:"email option is required",condition:function(o){return"link"===o.send||!o.phoneNumber}},authParams:{optional:!0,type:"object",message:"authParams option is required"}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"passwordless","start"),(body=objectHelper.merge(this.baseOptions,["clientID","responseType","redirectUri","scope"]).with(options)).scope&&(body.authParams=body.authParams||{},body.authParams.scope=body.scope),body.redirectUri&&(body.authParams=body.authParams||{},body.authParams.redirect_uri=body.redirectUri),body.responseType&&(body.authParams=body.authParams||{},body.authParams.response_type=body.responseType),delete body.redirectUri,delete body.responseType,delete body.scope,body=objectHelper.toSnakeCase(body,["auth0Client","authParams"]),this.request.post(url).send(body).end(wrapCallback(cb))},PasswordlessAuthentication.prototype.verify=function(options,cb){var url,cleanOption;return assert.check(options,{type:"object",message:"options parameter is not valid"},{connection:{type:"string",message:"connection option is required"},verificationCode:{type:"string",message:"verificationCode option is required"},phoneNumber:{optional:!1,type:"string",message:"phoneNumber option is required",condition:function(o){return!o.email}},email:{optional:!1,type:"string",message:"email option is required",condition:function(o){return!o.phoneNumber}}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),cleanOption=objectHelper.pick(options,["connection","verificationCode","phoneNumber","email","auth0Client"]),cleanOption=objectHelper.toSnakeCase(cleanOption,["auth0Client"]),url=urlJoin(this.baseOptions.rootUrl,"passwordless","verify"),this.request.post(url).send(cleanOption).end(wrapCallback(cb))},DBConnection.prototype.signup=function(options,cb){var url,body,metadata;return assert.check(options,{type:"object",message:"options parameter is not valid"},{connection:{type:"string",message:"connection option is required"},email:{type:"string",message:"email option is required"},password:{type:"string",message:"password option is required"}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"dbconnections","signup"),metadata=(body=objectHelper.merge(this.baseOptions,["clientID"]).with(options)).user_metadata||body.userMetadata,body=objectHelper.blacklist(body,["scope","userMetadata","user_metadata"]),body=objectHelper.toSnakeCase(body,["auth0Client"]),metadata&&(body.user_metadata=metadata),this.request.post(url).send(body).end(wrapCallback(cb))},DBConnection.prototype.changePassword=function(options,cb){var url,body;return assert.check(options,{type:"object",message:"options parameter is not valid"},{connection:{type:"string",message:"connection option is required"},email:{type:"string",message:"email option is required"}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"dbconnections","change_password"),body=objectHelper.merge(this.baseOptions,["clientID"]).with(options,["email","connection"]),body=objectHelper.toSnakeCase(body,["auth0Client"]),this.request.post(url).send(body).end(wrapCallback(cb))},Authentication.prototype.buildAuthorizeUrl=function(options){var params,qString;return assert.check(options,{type:"object",message:"options parameter is not valid"}),params=objectHelper.merge(this.baseOptions,["clientID","responseType","responseMode","redirectUri","scope","audience"]).with(options),assert.check(params,{type:"object",message:"options parameter is not valid"},{clientID:{type:"string",message:"clientID option is required"},redirectUri:{optional:!0,type:"string",message:"redirectUri option is required"},responseType:{type:"string",message:"responseType option is required"},nonce:{type:"string",message:"nonce option is required",condition:function(o){return-1===o.responseType.indexOf("code")&&-1!==o.responseType.indexOf("id_token")}},scope:{optional:!0,type:"string",message:"scope option is required"},audience:{optional:!0,type:"string",message:"audience option is required"}}),this.baseOptions._sendTelemetry&&(params.auth0Client=this.request.getTelemetryData()),params.connection_scope&&assert.isArray(params.connection_scope)&&(params.connection_scope=params.connection_scope.join(",")),params=objectHelper.blacklist(params,["username","popupOptions","domain","tenant","timeout"]),params=objectHelper.toSnakeCase(params,["auth0Client"]),params=parametersWhitelist.oauthAuthorizeParams(this.warn,params),qString=lib_stringify(params),urlJoin(this.baseOptions.rootUrl,"authorize","?"+qString)},Authentication.prototype.buildLogoutUrl=function(options){var params,qString;return assert.check(options,{optional:!0,type:"object",message:"options parameter is not valid"}),params=objectHelper.merge(this.baseOptions,["clientID"]).with(options||{}),this.baseOptions._sendTelemetry&&(params.auth0Client=this.request.getTelemetryData()),params=objectHelper.toSnakeCase(params,["auth0Client","returnTo"]),qString=lib_stringify(objectHelper.blacklist(params,["federated"])),options&&void 0!==options.federated&&!1!==options.federated&&"false"!==options.federated&&(qString+="&federated"),urlJoin(this.baseOptions.rootUrl,"v2","logout","?"+qString)},Authentication.prototype.loginWithDefaultDirectory=function(options,cb){return assert.check(options,{type:"object",message:"options parameter is not valid"},{username:{type:"string",message:"username option is required"},password:{type:"string",message:"password option is required"},scope:{optional:!0,type:"string",message:"scope option is required"},audience:{optional:!0,type:"string",message:"audience option is required"}}),options.grantType="password",this.oauthToken(options,cb)},Authentication.prototype.login=function(options,cb){return assert.check(options,{type:"object",message:"options parameter is not valid"},{username:{type:"string",message:"username option is required"},password:{type:"string",message:"password option is required"},realm:{type:"string",message:"realm option is required"},scope:{optional:!0,type:"string",message:"scope option is required"},audience:{optional:!0,type:"string",message:"audience option is required"}}),options.grantType="http://auth0.com/oauth/grant-type/password-realm",this.oauthToken(options,cb)},Authentication.prototype.oauthToken=function(options,cb){var url,body;return assert.check(options,{type:"object",message:"options parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"oauth","token"),body=objectHelper.merge(this.baseOptions,["clientID","scope","audience"]).with(options),assert.check(body,{type:"object",message:"options parameter is not valid"},{clientID:{type:"string",message:"clientID option is required"},grantType:{type:"string",message:"grantType option is required"},scope:{optional:!0,type:"string",message:"scope option is required"},audience:{optional:!0,type:"string",message:"audience option is required"}}),body=objectHelper.toSnakeCase(body,["auth0Client"]),body=parametersWhitelist.oauthTokenParams(this.warn,body),this.request.post(url).send(body).end(wrapCallback(cb))},Authentication.prototype.loginWithResourceOwner=function(options,cb){var url,body;return assert.check(options,{type:"object",message:"options parameter is not valid"},{username:{type:"string",message:"username option is required"},password:{type:"string",message:"password option is required"},connection:{type:"string",message:"connection option is required"},scope:{optional:!0,type:"string",message:"scope option is required"}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"oauth","ro"),body=objectHelper.merge(this.baseOptions,["clientID","scope"]).with(options,["username","password","scope","connection","device"]),(body=objectHelper.toSnakeCase(body,["auth0Client"])).grant_type=body.grant_type||"password",this.request.post(url).send(body).end(wrapCallback(cb))},Authentication.prototype.getSSOData=function(withActiveDirectories,cb){if(this.auth0||(this.auth0=new WebAuth(this.baseOptions)),windowHandler.getWindow().location.host===this.baseOptions.domain)return this.auth0._universalLogin.getSSOData(withActiveDirectories,cb);"function"==typeof withActiveDirectories&&(cb=withActiveDirectories),assert.check(cb,{type:"function",message:"cb parameter is not valid"});var clientId=this.baseOptions.clientID,ssodataInformation=this.ssodataStorage.get()||{};this.auth0.checkSession({responseType:"token id_token",scope:"openid profile email",connection:ssodataInformation.lastUsedConnection,timeout:5e3},function(err,result){return err?"login_required"===err.error?cb(null,{sso:!1}):("consent_required"===err.error&&(err.error_description="Consent required. When using `getSSOData`, the user has to be authenticated with the following scope: `openid profile email`."),cb(err,{sso:!1})):ssodataInformation.lastUsedSub&&ssodataInformation.lastUsedSub!==result.idTokenPayload.sub?cb(err,{sso:!1}):cb(null,{lastUsedConnection:{name:ssodataInformation.lastUsedConnection},lastUsedUserID:result.idTokenPayload.sub,lastUsedUsername:result.idTokenPayload.email||result.idTokenPayload.name,lastUsedClientID:clientId,sessionClients:[clientId],sso:!0})})},Authentication.prototype.userInfo=function(accessToken,cb){var url;return assert.check(accessToken,{type:"string",message:"accessToken parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"userinfo"),this.request.get(url).set("Authorization","Bearer "+accessToken).end(wrapCallback(cb,{ignoreCasing:!0}))},Authentication.prototype.delegation=function(options,cb){var url,body;return assert.check(options,{type:"object",message:"options parameter is not valid"},{grant_type:{type:"string",message:"grant_type option is required"}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"delegation"),body=objectHelper.merge(this.baseOptions,["clientID"]).with(options),body=objectHelper.toSnakeCase(body,["auth0Client"]),this.request.post(url).send(body).end(wrapCallback(cb))},Authentication.prototype.getUserCountry=function(cb){var url;return assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"user","geoloc","country"),this.request.get(url).end(wrapCallback(cb))},Management.prototype.getUser=function(userId,cb){var url;return assert.check(userId,{type:"string",message:"userId parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"users",userId),this.request.get(url).end(wrapCallback(cb,{ignoreCasing:!0}))},Management.prototype.patchUserMetadata=function(userId,userMetadata,cb){var url;return assert.check(userId,{type:"string",message:"userId parameter is not valid"}),assert.check(userMetadata,{type:"object",message:"userMetadata parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"users",userId),this.request.patch(url).send({user_metadata:userMetadata}).end(wrapCallback(cb,{ignoreCasing:!0}))},Management.prototype.linkUser=function(userId,secondaryUserToken,cb){var url;return assert.check(userId,{type:"string",message:"userId parameter is not valid"}),assert.check(secondaryUserToken,{type:"string",message:"secondaryUserToken parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"users",userId,"identities"),this.request.post(url).send({link_with:secondaryUserToken}).end(wrapCallback(cb,{ignoreCasing:!0}))};var index={Authentication:Authentication,Management:Management,WebAuth:WebAuth,version:version};exports.Authentication=Authentication,exports.Management=Management,exports.WebAuth=WebAuth,exports.version=version,exports.default=index,Object.defineProperty(exports,"__esModule",{value:!0})});
	//# sourceMappingURL=auth0.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(49), __esModule: true };

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(48);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(50);
	var $Object = __webpack_require__(34).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(72);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(71), 'Object', { defineProperty: __webpack_require__(73).f });


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoreDispatcher = function () {
	  function CoreDispatcher() {
	    (0, _classCallCheck3.default)(this, CoreDispatcher);
	
	    this.eventMap = {};
	    this.destroyed = false;
	  }
	
	  CoreDispatcher.prototype.on = function on(eventName, handler) {
	    var listeners = this.getListener(eventName);
	    if (listeners.indexOf(handler) === -1) {
	      listeners.push(handler);
	    }
	    this.eventMap[eventName] = this.eventMap[eventName] || listeners;
	    return this;
	  };
	
	  CoreDispatcher.prototype.once = function once(eventName, handler) {
	    var _this = this;
	
	    var f2 = function f2(e) {
	      handler(e);
	      _this.off(eventName, f2);
	    };
	    return this.on(eventName, f2);
	  };
	
	  CoreDispatcher.prototype.off = function off(eventName, handler) {
	    var listeners = this.getListener(eventName);
	    if (!handler) {
	      this.eventMap[eventName].length = 0;
	      delete this.eventMap[eventName];
	    } else {
	      var i = listeners.indexOf(handler);
	      if (i > -1) {
	        listeners.splice(i, 1);
	        if (!listeners.length) {
	          delete this.eventMap[eventName];
	        }
	      }
	    }
	    return this;
	  };
	
	  CoreDispatcher.prototype.commitEvent = function commitEvent(listeners, eventObject) {
	    for (var i = 0, l = listeners.length; i < l; i++) {
	      if (listeners[i]) {
	        listeners[i](eventObject);
	      } else if (console) {
	        console.warn('listener undefined', i);
	      }
	    }
	    return this;
	  };
	
	  CoreDispatcher.prototype.commitEvents = function commitEvents(listeners, eventObjects) {
	    for (var i = 0, l = listeners.length; i < l; i++) {
	      if (listeners[i]) {
	        for (var ii = 0, ll = eventObjects.length; ii < ll; ii++) {
	          listeners[i](eventObjects[ii]);
	        }
	      } else if (console) {
	        console.warn('listener undefined', i);
	      }
	    }
	    return this;
	  };
	
	  CoreDispatcher.prototype.createEventObject = function createEventObject(eventType, eventObject) {
	    var evtObj = {
	      type: eventType,
	      target: this
	    };
	
	    if (eventObject) {
	      evtObj = (0, _objectAssign2.default)(evtObj, eventObject);
	    }
	
	    return evtObj;
	  };
	
	  CoreDispatcher.prototype.triggerSync = function triggerSync(eventObjects) {
	    var listenerCollection = [];
	    for (var i = 0, l = eventObjects.length; i < l; i++) {
	      var listeners = this.getListener(eventObjects[i].type);
	      for (var ii = 0, ll = listeners.length; ii < ll; ii++) {
	        var listener = listeners[ii];
	        if (listenerCollection.indexOf(listener) < 0) {
	          listenerCollection.push(listener);
	        }
	      }
	    }
	  };
	
	  CoreDispatcher.prototype.trigger = function trigger(eventType, eventObject) {
	    var listeners = this.getListener(eventType);
	    if (listeners && listeners.length) {
	      return this.commitEvent(listeners, this.createEventObject(eventType, eventObject));
	    }
	    return this;
	  };
	
	  CoreDispatcher.prototype.clear = function clear() {
	    if (this.eventMap) {
	      var keys = Object.keys(this.eventMap);
	      for (var i = 0, l = keys.length; i < l; i++) {
	        this.eventMap[keys[i]].length = 0;
	        delete this.eventMap[keys[i]];
	      }
	    }
	  };
	
	  CoreDispatcher.prototype.getListener = function getListener(eventName) {
	    return !!this.eventMap && this.eventMap[eventName] ? this.eventMap[eventName] : [];
	  };
	
	  CoreDispatcher.prototype.destroy = function destroy() {
	    this.clear();
	    this.eventMap = null;
	    this.destroyed = true;
	    return this;
	  };
	
	  return CoreDispatcher;
	}();
	
	exports.default = CoreDispatcher;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _core = __webpack_require__(52);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventDispatcher = function (_CoreDispatcher) {
	  (0, _inherits3.default)(EventDispatcher, _CoreDispatcher);
	
	  function EventDispatcher() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        target = _ref.target,
	        currentTarget = _ref.currentTarget;
	
	    (0, _classCallCheck3.default)(this, EventDispatcher);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _CoreDispatcher.call(this));
	
	    _this.target = target || _this;
	    _this.currentTarget = currentTarget || _this;
	
	    _this.addListener = _this.bind = _this.addEventListener = _this.on;
	    _this.removeListener = _this.unbind = _this.removeEventListener = _this.off;
	    _this.addListenerOnce = _this.one = _this.once;
	    _this.emit = _this.dispatch = _this.dispatchEvent = _this.trigger;
	
	    _this.hasListener = _this.hasListeners = _this.listens;
	    return _this;
	  }
	
	  EventDispatcher.prototype.listens = function listens(eventName) {
	    if (eventName) {
	      return this.getListener(eventName).length > 0;
	    }
	    return !!this.eventMap && Object.keys(this.eventMap).length > 0;
	  };
	
	  EventDispatcher.prototype.createEventObject = function createEventObject(eventType, eventObject) {
	    var evtObj = {
	      type: eventType,
	      target: this.target,
	      currentTarget: this.currentTarget
	    };
	
	    if (eventObject) {
	      evtObj = (0, _objectAssign2.default)(evtObj, eventObject);
	    }
	
	    return evtObj;
	  };
	
	  return EventDispatcher;
	}(_core2.default);
	
	exports.default = EventDispatcher;

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(54)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2),
	    PropTypes = __webpack_require__(4),
	    withSideEffect = __webpack_require__(64);
	
	function reducePropsToState(propsList) {
	  var innermostProps = propsList[propsList.length - 1];
	  if (innermostProps) {
	    return innermostProps.title;
	  }
	}
	
	function handleStateChangeOnClient(title) {
	  var nextTitle = title || '';
	  if (nextTitle !== document.title) {
	    document.title = nextTitle;
	  }
	}
	
	function DocumentTitle() {}
	DocumentTitle.prototype = Object.create(React.Component.prototype);
	
	DocumentTitle.displayName = 'DocumentTitle';
	DocumentTitle.propTypes = {
	  title: PropTypes.string.isRequired
	};
	
	DocumentTitle.prototype.render = function() {
	  if (this.props.children) {
	    return React.Children.only(this.props.children);
	  } else {
	    return null;
	  }
	};
	
	module.exports = withSideEffect(
	  reducePropsToState,
	  handleStateChangeOnClient
	)(DocumentTitle);


/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(92);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(59);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(25);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(14);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(57);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _reactDom2.default.createPortal !== undefined;
	
	var getCreatePortal = function getCreatePortal() {
	  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      parent.removeChild(_this.node);
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var createPortal = getCreatePortal();
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = document.createElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = document.createElement("div");
	      }
	
	      var createPortal = getCreatePortal();
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  role: "dialog",
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  parentSelector: function parentSelector() {
	    return document.body;
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	exports.default = Modal;

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(61);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(62);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(25);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(60);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(14);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus();
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	
	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen();
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus();
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.afterClose();
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      return this.shouldBeClosed() ? null : _react2.default.createElement(
	        "div",
	        {
	          ref: this.setOverlayRef,
	          className: this.buildClassName("overlay", overlayClassName),
	          style: _extends({}, overlayStyles, this.props.style.overlay),
	          onClick: this.handleOverlayOnClick,
	          onMouseDown: this.handleOverlayOnMouseDown
	        },
	        _react2.default.createElement(
	          "div",
	          _extends({
	            ref: this.setContentRef,
	            style: _extends({}, contentStyles, this.props.style.content),
	            className: this.buildClassName("content", className),
	            tabIndex: "-1",
	            onKeyDown: this.handleKeyDown,
	            onMouseDown: this.handleContentOnMouseDown,
	            onMouseUp: this.handleContentOnMouseUp,
	            onClick: this.handleContentOnClick,
	            role: this.props.role,
	            "aria-label": this.props.contentLabel
	          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
	            "data-testid": this.props.testId
	          }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	
	var _warning = __webpack_require__(31);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = "length" in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement) {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return false;
	  }
	
	  return true;
	}
	
	function hide(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).setAttribute("aria-hidden", "true");
	  }
	}
	
	function show(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).removeAttribute("aria-hidden");
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = null;
	}

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dumpClassLists = dumpClassLists;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	function dumpClassLists() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n";
	    }
	
	    classes = document.body.className;
	
	    // eslint-disable-next-line max-len
	    buffer += "\n\ndoc.body (" + classes + "):\n";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
	    }
	
	    buffer += "\n";
	
	    // eslint-disable-next-line no-console
	    console.log(buffer);
	  }
	}
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(26);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus();
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	
	var _exenv = __webpack_require__(23);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(26);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === document.activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  var target;
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof tabbable[x] === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }
	
	  event.preventDefault();
	
	  tabbable[x].focus();
	}
	module.exports = exports["default"];

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  // Otherwise we need to check some styles
	  var style = window.getComputedStyle(element);
	  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(58);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(23));
	var shallowEqual = _interopDefault(__webpack_require__(70));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(24);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _canSticky = null;
	
	var Can = function () {
	  function Can() {
	    (0, _classCallCheck3.default)(this, Can);
	  }
	
	  (0, _createClass3.default)(Can, null, [{
	    key: 'sticky',
	    get: function get() {
	      if (_canSticky !== null) {
	        return _canSticky;
	      }
	
	      if (typeof window !== 'undefined') {
	
	        if (window.Modernizr && window.Modernizr.hasOwnProperty('csspositionsticky')) {
	          return _canSticky = window.Modernizr.csspositionsticky;
	        }
	
	        var documentFragment = document.documentElement;
	        var testEl = document.createElement('div');
	        documentFragment.appendChild(testEl);
	        var prefixedSticky = ['sticky', '-webkit-sticky'];
	
	        _canSticky = false;
	
	        for (var i = 0; i < prefixedSticky.length; i++) {
	          testEl.style.position = prefixedSticky[i];
	          _canSticky = !!window.getComputedStyle(testEl).position.match('sticky');
	          if (_canSticky) {
	            break;
	          }
	        }
	        documentFragment.removeChild(testEl);
	      }
	      return _canSticky;
	    }
	  }]);
	  return Can;
	}();
	
	exports.default = Can;
	module.exports = exports['default'];

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(105);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(106);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _scrollfeatures = __webpack_require__(69);
	
	var _scrollfeatures2 = _interopRequireDefault(_scrollfeatures);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _featureDetect = __webpack_require__(65);
	
	var _featureDetect2 = _interopRequireDefault(_featureDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var log = function log() {};
	
	var initialState = {
	  initialized: false,
	  sticky: false,
	  absolute: false,
	  fixedOffset: '',
	  offsetHeight: 0,
	  bounds: {
	    top: null,
	    left: null,
	    right: null,
	    bottom: null,
	    height: null,
	    width: null
	  },
	  restrict: {
	    top: null,
	    left: null,
	    right: null,
	    bottom: null,
	    height: null,
	    width: null
	  },
	  wrapperStyle: null,
	  elementStyle: null,
	  initialStyle: null,
	  style: {
	    top: null,
	    bottom: null,
	    left: null,
	    right: null,
	    'margin-top': 0,
	    'margin-bottom': 0,
	    'margin-left': 0,
	    'margin-right': 0
	  },
	  disabled: false
	};
	
	var getAbsolutBoundingRect = function getAbsolutBoundingRect(el, fixedHeight) {
	  var rect = el.getBoundingClientRect();
	  var top = rect.top + _scrollfeatures2.default.windowY;
	  var height = fixedHeight || rect.height;
	  return {
	    top: top,
	    bottom: top + height,
	    height: height,
	    width: rect.width,
	    left: rect.left,
	    right: rect.right
	  };
	};
	
	var addBounds = function addBounds(rect1, rect2) {
	  var rect = (0, _objectAssign2.default)({}, rect1);
	  rect.top -= rect2.top;
	  rect.left -= rect2.left;
	  rect.right = rect.left + rect1.width;
	  rect.bottom = rect.top + rect1.height;
	  return rect;
	};
	
	var getPositionStyle = function getPositionStyle(el) {
	
	  var result = {};
	  var style = window.getComputedStyle(el, null);
	
	  for (var key in initialState.style) {
	    var value = parseInt(style.getPropertyValue(key));
	    value = isNaN(value) ? null : value;
	    result[key] = value;
	  }
	
	  return result;
	};
	
	var getPreviousElementSibling = function getPreviousElementSibling(el) {
	  var prev = el.previousElementSibling;
	  if (prev && prev.tagName.toLocaleLowerCase() === 'script') {
	    prev = getPreviousElementSibling(prev);
	  }
	  return prev;
	};
	
	var ReactStickyState = function (_Component) {
	  (0, _inherits3.default)(ReactStickyState, _Component);
	
	  function ReactStickyState(props, context) {
	    (0, _classCallCheck3.default)(this, ReactStickyState);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));
	
	    _this._updatingBounds = false;
	    _this._shouldComponentUpdate = true;
	    _this._updatingState = false;
	
	    _this.state = (0, _objectAssign2.default)({}, initialState, { disabled: props.disabled });
	
	    if (props.debug === true) {
	      log = console.log.bind(console);
	    }
	
	    return _this;
	  }
	
	  ReactStickyState.prototype.getBoundingClientRect = function getBoundingClientRect() {
	    return this.refs.el.getBoundingClientRect();
	  };
	
	  ReactStickyState.prototype.getBounds = function getBounds(noCache) {
	
	    var clientRect = this.getBoundingClientRect();
	    var offsetHeight = _scrollfeatures2.default.documentHeight;
	    noCache = noCache === true;
	
	    if (noCache !== true && this.state.bounds.height !== null) {
	      if (this.state.offsetHeight === offsetHeight && clientRect.height === this.state.bounds.height) {
	        return {
	          offsetHeight: offsetHeight,
	          style: this.state.style,
	          bounds: this.state.bounds,
	          restrict: this.state.restrict
	        };
	      }
	    }
	
	    // var style = noCache ? this.state.style : getPositionStyle(this.el);
	    var initialStyle = this.state.initialStyle;
	    if (!initialStyle) {
	      initialStyle = getPositionStyle(this.refs.el);
	    }
	
	    var style = initialStyle;
	    var child = this.refs.wrapper || this.refs.el;
	    var rect;
	    var restrict;
	    var offsetY = 0;
	    // var offsetX = 0;
	
	    if (!_featureDetect2.default.sticky) {
	      rect = getAbsolutBoundingRect(child, clientRect.height);
	      if (this.hasOwnScrollTarget) {
	        var parentRect = getAbsolutBoundingRect(this.scrollTarget);
	        offsetY = this.scroll.y;
	        rect = addBounds(rect, parentRect);
	        restrict = parentRect;
	        restrict.top = 0;
	        restrict.height = this.scroll.scrollHeight || restrict.height;
	        restrict.bottom = restrict.height;
	      }
	    } else {
	      var elem = getPreviousElementSibling(child);
	      offsetY = 0;
	
	      if (elem) {
	        offsetY = parseInt(window.getComputedStyle(elem)['margin-bottom']);
	        offsetY = offsetY || 0;
	        rect = getAbsolutBoundingRect(elem);
	        if (this.hasOwnScrollTarget) {
	          rect = addBounds(rect, getAbsolutBoundingRect(this.scrollTarget));
	          offsetY += this.scroll.y;
	        }
	        rect.top = rect.bottom + offsetY;
	      } else {
	        elem = child.parentNode;
	        offsetY = parseInt(window.getComputedStyle(elem)['padding-top']);
	        offsetY = offsetY || 0;
	        rect = getAbsolutBoundingRect(elem);
	        if (this.hasOwnScrollTarget) {
	          rect = addBounds(rect, getAbsolutBoundingRect(this.scrollTarget));
	          offsetY += this.scroll.y;
	        }
	        rect.top = rect.top + offsetY;
	      }
	      if (this.hasOwnScrollTarget) {
	        restrict = getAbsolutBoundingRect(this.scrollTarget);
	        restrict.top = 0;
	        restrict.height = this.scroll.scrollHeight || restrict.height;
	        restrict.bottom = restrict.height;
	      }
	
	      rect.height = child.clientHeight;
	      rect.width = child.clientWidth;
	      rect.bottom = rect.top + rect.height;
	    }
	
	    restrict = restrict || getAbsolutBoundingRect(child.parentNode);
	
	    return {
	      offsetHeight: offsetHeight,
	      style: style,
	      bounds: rect,
	      initialStyle: initialStyle,
	      restrict: restrict
	    };
	  };
	
	  ReactStickyState.prototype.updateBounds = function updateBounds(silent, noCache, cb) {
	    var _this2 = this;
	
	    noCache = noCache === true;
	    this._shouldComponentUpdate = silent !== true;
	
	    this.setState(this.getBounds(noCache), function () {
	      _this2._shouldComponentUpdate = true;
	      if (cb) {
	        cb();
	      }
	    });
	  };
	
	  // updateFixedOffset() {
	  //   if (this.hasOwnScrollTarget && !Can.sticky) {
	
	  //     if (this.state.sticky) {
	  //       this.setState({ fixedOffset: this.scrollTarget.getBoundingClientRect().top + 'px' });
	  //       if (!this.hasWindowScrollListener) {
	  //         this.hasWindowScrollListener = true;
	  //         ScrollFeatures.getInstance(window).on('scroll:progress', this.updateFixedOffset);
	  //       }
	  //     } else {
	  //       this.setState({ fixedOffset: '' });
	  //       if (this.hasWindowScrollListener) {
	  //         this.hasWindowScrollListener = false;
	  //         ScrollFeatures.getInstance(window).off('scroll:progress', this.updateFixedOffset);
	  //       }
	  //     }
	  //   }
	  // }
	
	
	  ReactStickyState.prototype.updateFixedOffset = function updateFixedOffset() {
	
	    var fixedOffset = this.state.fixedOffset;
	    if (this.state.sticky) {
	      this.setState({ fixedOffset: this.scrollTarget.getBoundingClientRect().top + 'px;' });
	    } else {
	      this.setState({ fixedOffset: '' });
	    }
	    // if (fixedOffset !== this.state.fixedOffset) {
	    //   this.render();
	    // }
	  };
	
	  ReactStickyState.prototype.addSrollHandler = function addSrollHandler() {
	    if (!this.scroll) {
	      var hasScrollTarget = _scrollfeatures2.default.hasInstance(this.scrollTarget);
	      this.scroll = _scrollfeatures2.default.getInstance(this.scrollTarget);
	      this.onScroll = this.onScroll.bind(this);
	      this.scroll.on('scroll:start', this.onScroll);
	      this.scroll.on('scroll:progress', this.onScroll);
	      this.scroll.on('scroll:stop', this.onScroll);
	
	      if (this.props.scrollClass.active) {
	        this.onScrollDirection = this.onScrollDirection.bind(this);
	        this.scroll.on('scroll:up', this.onScrollDirection);
	        this.scroll.on('scroll:down', this.onScrollDirection);
	        if (!this.props.scrollClass.persist) {
	          this.scroll.on('scroll:stop', this.onScrollDirection);
	        }
	      }
	      if (hasScrollTarget && this.scroll.scrollY > 0) {
	        this.scroll.trigger('scroll:progress');
	      }
	    }
	  };
	
	  ReactStickyState.prototype.removeSrollHandler = function removeSrollHandler() {
	    if (this.scroll) {
	      this.scroll.off('scroll:start', this.onScroll);
	      this.scroll.off('scroll:progress', this.onScroll);
	      this.scroll.off('scroll:stop', this.onScroll);
	      if (this.props.scrollClass.active) {
	        this.scroll.off('scroll:up', this.onScrollDirection);
	        this.scroll.off('scroll:down', this.onScrollDirection);
	        this.scroll.off('scroll:stop', this.onScrollDirection);
	      }
	      if (!this.scroll.hasListeners()) {
	        this.scroll.destroy();
	      }
	      this.onScroll = null;
	      this.onScrollDirection = null;
	      this.scroll = null;
	    }
	  };
	
	  ReactStickyState.prototype.addResizeHandler = function addResizeHandler() {
	    if (!this.onResize) {
	      this.onResize = this.update.bind(this);
	      window.addEventListener('sticky:update', this.onResize, false);
	      window.addEventListener('resize', this.onResize, false);
	      window.addEventListener('orientationchange', this.onResize, false);
	    }
	  };
	
	  ReactStickyState.prototype.removeResizeHandler = function removeResizeHandler() {
	    if (this.onResize) {
	      window.removeEventListener('sticky:update', this.onResize);
	      window.removeEventListener('resize', this.onResize);
	      window.removeEventListener('orientationchange', this.onResize);
	      this.onResize = null;
	    }
	  };
	
	  ReactStickyState.prototype.destroy = function destroy() {
	    this._updatingBounds = false;
	    this._shouldComponentUpdate = false;
	    this._updatingState = false;
	    this.removeSrollHandler();
	    this.removeResizeHandler();
	    this.scrollTarget = null;
	  };
	
	  ReactStickyState.prototype.getScrollClasses = function getScrollClasses(obj) {
	    if (this.options.scrollClass.active) {
	      obj = obj || {};
	      var direction = this.scroll.y <= 0 || this.scroll.y + this.scroll.clientHeight >= this.scroll.scrollHeight ? 0 : this.scroll.directionY;
	      obj[this.options.scrollClass.up] = direction < 0;
	      obj[this.options.scrollClass.down] = direction > 0;
	    }
	    return obj;
	  };
	
	  ReactStickyState.prototype.getScrollClass = function getScrollClass() {
	    if (this.props.scrollClass.up || this.props.scrollClass.down) {
	
	      var direction = this.scroll.y <= 0 || this.scroll.y + this.scroll.clientHeight >= this.scroll.scrollHeight ? 0 : this.scroll.directionY;
	      var scrollClass = direction < 0 ? this.props.scrollClass.up : this.props.scrollClass.down;
	      scrollClass = direction === 0 ? null : scrollClass;
	      return scrollClass;
	    }
	    return null;
	  };
	
	  ReactStickyState.prototype.onScrollDirection = function onScrollDirection(e) {
	    if (this.state.sticky || e && e.type === _scrollfeatures2.default.events.SCROLL_STOP) {
	      this.setState({
	        scrollClass: this.getScrollClass()
	      });
	    }
	  };
	
	  ReactStickyState.prototype.onScroll = function onScroll(e) {
	    this.updateStickyState(false);
	    if (this.hasOwnScrollTarget && !_featureDetect2.default.sticky) {
	      this.updateFixedOffset();
	      if (this.state.sticky && !this.hasWindowScrollListener) {
	        this.hasWindowScrollListener = true;
	        _scrollfeatures2.default.getInstance(window).on('scroll:progress', this.updateFixedOffset);
	      } else if (!this.state.sticky && this.hasWindowScrollListener) {
	        this.hasWindowScrollListener = false;
	        _scrollfeatures2.default.getInstance(window).off('scroll:progress', this.updateFixedOffset);
	      }
	    }
	  };
	
	  ReactStickyState.prototype.update = function update() {
	    var _this3 = this;
	
	    // this.scroll.updateScrollPosition();
	    this.updateBounds(true, true, function () {
	      _this3.updateStickyState(false);
	    });
	  };
	
	  // update(force = false) {
	
	  //   if (!this._updatingBounds) {
	  //     this._updatingBounds = true;
	  //     this.scroll.updateScrollPosition();
	  //     this.updateBounds(true, true, () => {
	  //       this.updateBounds(force, true, () => {
	  //         this.scroll.updateScrollPosition();
	  //         var updateSticky = this.updateStickyState(false, () => {
	  //           if (force && !updateSticky) {
	  //             this.forceUpdate();
	  //           }
	  //         });
	  //         this._updatingBounds = false;
	  //       });
	  //     });
	  //   }
	  // }
	
	
	  ReactStickyState.prototype.getStickyState = function getStickyState() {
	
	    if (this.state.disabled) {
	      return { sticky: false, absolute: false };
	    }
	
	    var scrollY = this.scroll.y;
	    // var scrollX = this.scroll.x;
	    var top = this.state.style.top;
	    var bottom = this.state.style.bottom;
	    // var left = this.state.style.left;
	    // var right = this.state.style.right;
	    var sticky = this.state.sticky;
	    var absolute = this.state.absolute;
	
	    if (top !== null) {
	      var offsetBottom = this.state.restrict.bottom - this.state.bounds.height - top;
	      top = this.state.bounds.top - top;
	
	      if (this.state.sticky === false && (scrollY >= top && scrollY <= offsetBottom || top <= 0 && scrollY < top)) {
	        sticky = true;
	        absolute = false;
	      } else if (this.state.sticky && (top > 0 && scrollY < top || scrollY > offsetBottom)) {
	        sticky = false;
	        absolute = scrollY > offsetBottom;
	      }
	    } else if (bottom !== null) {
	
	      scrollY += window.innerHeight;
	      var offsetTop = this.state.restrict.top + this.state.bounds.height - bottom;
	      bottom = this.state.bounds.bottom + bottom;
	
	      if (this.state.sticky === false && scrollY <= bottom && scrollY >= offsetTop) {
	        sticky = true;
	        absolute = false;
	      } else if (this.state.sticky && (scrollY > bottom || scrollY < offsetTop)) {
	        sticky = false;
	        absolute = scrollY <= offsetTop;
	      }
	    }
	    return { sticky: sticky, absolute: absolute };
	  };
	
	  ReactStickyState.prototype.updateStickyState = function updateStickyState(silent) {
	    var _this4 = this;
	
	    var values = this.getStickyState();
	
	    if (values.sticky !== this.state.sticky || values.absolute !== this.state.absolute) {
	      this._shouldComponentUpdate = silent !== true;
	      values = (0, _objectAssign2.default)(values, this.getBounds(false));
	      this._updatingState = true;
	      this.setState(values, function () {
	        _this4._shouldComponentUpdate = true;
	        _this4._updatingState = false;
	      });
	    }
	  };
	
	  // updateStickyState(bounds = true, cb) {
	  //   if (this._updatingState) {
	  //     return;
	  //   }
	  //   var values = this.getStickyState();
	
	  //   if (values.sticky !== this.state.sticky || values.absolute !== this.state.absolute) {
	  //     this._updatingState = true;
	  //     if (bounds) {
	  //       values = assign(values, this.getBounds(), { scrollClass: this.getScrollClass() });
	  //     }
	  //     this.setState(values, () => {
	  //       this._updatingState = false;
	  //       if (typeof cb === 'function') {
	  //         cb();
	  //       }
	  //     });
	  //     return true;
	  //   } else if (typeof cb === 'function') {
	  //     cb();
	  //   }
	  //   return false;
	  // }
	
	
	  ReactStickyState.prototype.initialize = function initialize() {
	    var _this5 = this;
	
	    if (!this.state.initialized && !this.state.disabled) {
	      this.setState({
	        initialized: true
	      }, function () {
	        var child = _this5.refs.wrapper || _this5.refs.el;
	        _this5.scrollTarget = _scrollfeatures2.default.getScrollParent(child);
	        _this5.hasOwnScrollTarget = _this5.scrollTarget !== window;
	        if (_this5.hasOwnScrollTarget) {
	          _this5.updateFixedOffset = _this5.updateFixedOffset.bind(_this5);
	        }
	
	        _this5.addSrollHandler();
	        _this5.addResizeHandler();
	        _this5.update();
	      });
	    }
	  };
	
	  ReactStickyState.prototype.shouldComponentUpdate = function shouldComponentUpdate(newProps, newState) {
	    return this._shouldComponentUpdate;
	  };
	
	  ReactStickyState.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this6 = this;
	
	    var intialize = !this.state.initialized && nextProps.initialize;
	
	    if (nextProps.disabled !== this.state.disabled) {
	      this.setState({
	        disabled: nextProps.disabled
	      }, function () {
	        if (intialize) {
	          _this6.initialize();
	        }
	      });
	    }
	  };
	
	  ReactStickyState.prototype.componentDidMount = function componentDidMount() {
	    if (!this.state.initialized && this.props.initialize) {
	      this.initialize();
	    }
	  };
	
	  ReactStickyState.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.destroy();
	  };
	
	  ReactStickyState.prototype.render = function render() {
	    var _classNames, _classNames2, _classNames3, _classNames4;
	
	    if (!this.state.initialized) {
	      return this.props.children;
	    }
	
	    var element = _react2.default.Children.only(this.props.children);
	
	    var _props = this.props,
	        wrapperClass = _props.wrapperClass,
	        stickyClass = _props.stickyClass,
	        fixedClass = _props.fixedClass,
	        stateClass = _props.stateClass,
	        disabledClass = _props.disabledClass,
	        absoluteClass = _props.absoluteClass,
	        disabled = _props.disabled,
	        debug = _props.debug,
	        tagName = _props.tagName,
	        props = (0, _objectWithoutProperties3.default)(_props, ['wrapperClass', 'stickyClass', 'fixedClass', 'stateClass', 'disabledClass', 'absoluteClass', 'disabled', 'debug', 'tagName']);
	
	
	    var style;
	    var refName = 'el';
	    var className = (0, _classnames2.default)((_classNames = {}, _classNames[stickyClass] = !this.state.disabled, _classNames[disabledClass] = this.state.disabled, _classNames), (_classNames2 = {}, _classNames2[fixedClass] = !_featureDetect2.default.sticky, _classNames2), (_classNames3 = {}, _classNames3[stateClass] = this.state.sticky && !this.state.disabled, _classNames3), (_classNames4 = {}, _classNames4[absoluteClass] = this.state.absolute, _classNames4), this.state.scrollClass);
	
	    if (!_featureDetect2.default.sticky) {
	      if (this.state.absolute) {
	
	        style = {
	          marginTop: this.state.style.top !== null ? this.state.restrict.height - (this.state.bounds.height + this.state.style.top) + (this.state.restrict.top - this.state.bounds.top) + 'px' : '',
	          marginBottom: this.state.style.bottom !== null ? this.state.restrict.height - (this.state.bounds.height + this.state.style.bottom) + (this.state.restrict.bottom - this.state.bounds.bottom) + 'px' : ''
	        };
	      } else if (this.hasOwnScrollTarget && this.state.fixedOffset !== '') {
	        style = {
	          marginTop: this.state.fixedOffset
	        };
	      }
	    }
	
	    if (element) {
	      element = _react2.default.cloneElement(element, { ref: refName, style: style, className: (0, _classnames2.default)(element.props.className, className) });
	    } else {
	      var Comp = this.props.tagName;
	      element = _react2.default.createElement(
	        Comp,
	        (0, _extends3.default)({ ref: refName, style: style, className: className }, props),
	        this.props.children
	      );
	    }
	
	    if (_featureDetect2.default.sticky) {
	      return element;
	    }
	
	    var height = this.state.disabled || this.state.bounds.height === null /*|| (!this.state.sticky && !this.state.absolute)*/ ? 'auto' : this.state.bounds.height + 'px';
	    var marginTop = height === 'auto' ? '' : this.state.style['margin-top'] ? this.state.style['margin-top'] + 'px' : '';
	    var marginBottom = height === 'auto' ? '' : this.state.style['margin-bottom'] ? this.state.style['margin-bottom'] + 'px' : '';
	
	    style = {
	      height: height,
	      marginTop: marginTop,
	      marginBottom: marginBottom
	    };
	    if (this.state.absolute) {
	      style.position = 'relative';
	    }
	    return _react2.default.createElement(
	      'div',
	      { ref: 'wrapper', className: wrapperClass, style: style },
	      element
	    );
	  };
	
	  return ReactStickyState;
	}(_react.Component);
	
	ReactStickyState.propTypes = {
	  initialize: _propTypes2.default.bool,
	  wrapperClass: _propTypes2.default.string,
	  stickyClass: _propTypes2.default.string,
	  fixedClass: _propTypes2.default.string,
	  stateClass: _propTypes2.default.string,
	  disabledClass: _propTypes2.default.string,
	  absoluteClass: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  debug: _propTypes2.default.bool,
	  wrapFixedSticky: _propTypes2.default.bool,
	  tagName: _propTypes2.default.string,
	  scrollClass: _propTypes2.default.shape({
	    down: _propTypes2.default.string,
	    up: _propTypes2.default.string,
	    none: _propTypes2.default.string,
	    persist: _propTypes2.default.bool,
	    active: _propTypes2.default.bool
	  })
	};
	ReactStickyState.defaultProps = {
	  initialize: true,
	  wrapperClass: 'sticky-wrap',
	  stickyClass: 'sticky',
	  fixedClass: 'sticky-fixed',
	  stateClass: 'is-sticky',
	  disabledClass: 'sticky-disabled',
	  absoluteClass: 'is-absolute',
	  wrapFixedSticky: true,
	  debug: false,
	  disabled: false,
	  tagName: 'div',
	  scrollClass: {
	    down: null,
	    up: null,
	    none: null,
	    persist: false,
	    active: false
	  }
	};
	exports.default = ReactStickyState;
	module.exports = exports['default'];

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	'use strict';
	
	var regex = /(auto|scroll)/;
	
	var hasOverflow = function hasOverflow(element) {
	  var style = window.getComputedStyle(element, null);
	  return regex.test(style.getPropertyValue('overflow') + style.getPropertyValue('overflow-y') + style.getPropertyValue('overflow-x'));
	};
	module.exports = hasOverflow;

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasOverflow = __webpack_require__(67);
	
	var scrollParent = function scrollParent(element) {
	
	  if (!(element instanceof HTMLElement)) {
	    return window;
	  }
	
	  while (element.parentNode) {
	    if (element.parentNode === document.body) {
	      return window;
	    }
	
	    if (hasOverflow(element.parentNode)) {
	      return element.parentNode;
	    }
	    element = element.parentNode;
	  }
	  return window;
	};
	
	module.exports = scrollParent;

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(7);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(19);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _createClass2 = __webpack_require__(24);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _inherits2 = __webpack_require__(18);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _eventdispatcher = __webpack_require__(53);
	
	var _eventdispatcher2 = _interopRequireDefault(_eventdispatcher);
	
	var _scrollParent = __webpack_require__(68);
	
	var _scrollParent2 = _interopRequireDefault(_scrollParent);
	
	var _raf = __webpack_require__(55);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScrollFeatures = function (_EventDispatcher) {
	  (0, _inherits3.default)(ScrollFeatures, _EventDispatcher);
	
	  ScrollFeatures.getInstance = function getInstance(scrollTarget, options) {
	    if (!scrollTarget.scrollFeatures) {
	      return new ScrollFeatures(scrollTarget, options);
	    }
	    return scrollTarget.scrollFeatures;
	  };
	
	  ScrollFeatures.hasInstance = function hasInstance(scrollTarget) {
	    return typeof scrollTarget.scrollFeatures !== 'undefined';
	  };
	
	  ScrollFeatures.getScrollParent = function getScrollParent(element) {
	    return (0, _scrollParent2.default)(element);
	  };
	
	  (0, _createClass3.default)(ScrollFeatures, null, [{
	    key: 'windowY',
	    get: function get() {
	      return window.pageYOffset || window.scrollY || 0;
	    }
	  }, {
	    key: 'windowX',
	    get: function get() {
	      return window.pageXOffset || window.scrollX || 0;
	    }
	  }, {
	    key: 'documentHeight',
	    get: function get() {
	      return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
	    }
	  }, {
	    key: 'documentWidth',
	    get: function get() {
	      return Math.max(document.body.scrollWidth, document.body.offsetWidth, document.documentElement.clientWidth, document.documentElement.scrollWidth, document.documentElement.offsetWidth);
	    }
	  }]);
	
	  function ScrollFeatures() {
	    var scrollTarget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    (0, _classCallCheck3.default)(this, ScrollFeatures);
	
	
	    if (ScrollFeatures.hasInstance(scrollTarget)) {
	      var _ret;
	
	      return _ret = ScrollFeatures.getInstance(scrollTarget), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _EventDispatcher.call(this, { target: scrollTarget }));
	
	    _this._scrollTarget = null;
	    _this._y = 0;
	    _this._x = 0;
	    _this._speedY = 0;
	    _this._maxSpeedY = 0;
	    _this._speedX = 0;
	    _this._lastSpeed = 0;
	    _this._lastDirectionY = ScrollFeatures.direction.none;
	    _this._lastDirectionX = ScrollFeatures.direction.none;
	    _this._stopFrames = 3;
	    _this._currentStopFrames = 0;
	    _this._firstRender = true;
	    _this._directionY = ScrollFeatures.direction.none;
	    _this._directionX = ScrollFeatures.direction.none;
	    _this._scrolling = false;
	    _this._canScrollY = false;
	    _this._canScrollX = false;
	
	
	    scrollTarget.scrollFeatures = _this;
	    _this._scrollTarget = scrollTarget;
	    _this.cancelFrame = false;
	    _this.options = options;
	
	    _this.init();
	    return _this;
	  }
	
	  ScrollFeatures.prototype.init = function init() {
	    var _this2 = this;
	
	    this.getScrollPosition = this._scrollTarget === window ? function () {
	      return { y: ScrollFeatures.windowY, x: ScrollFeatures.windowX };
	    }.bind(this) : function () {
	      return { y: this._scrollTarget.scrollTop, x: this._scrollTarget.scrollLeft };
	    }.bind(this);
	
	    this.onResize = function () {
	      _this2.trigger(ScrollFeatures.events.SCROLL_RESIZE);
	    };
	    this.onScroll = this.onScroll.bind(this);
	    this.onNextFrame = this.onNextFrame.bind(this);
	
	    this.updateScrollPosition();
	
	    if (this._scrollTarget !== window) {
	      var regex = /(auto|scroll)/;
	      var style = window.getComputedStyle(this._scrollTarget, null);
	      this._canScrollY = regex.test(style.getPropertyValue('overflow-y'));
	      this._canScrollX = regex.test(style.getPropertyValue('overflow-x'));
	    } else {
	      this._canScrollY = this.clientHeight < this.scrollHeight;
	      this._canScrollX = this.clientWidth < this.scrollWidth;
	    }
	
	    if (this._scrollTarget.addEventListener) {
	      this._scrollTarget.addEventListener('scroll', this.onScroll, false);
	      this._scrollTarget.addEventListener('resize', this.onResize, false);
	    } else if (this._scrollTarget.attachEvent) {
	      this._scrollTarget.attachEvent('scroll', this.onScroll);
	      this._scrollTarget.attachEvent('resize', this.onResize);
	    }
	  };
	
	  ScrollFeatures.prototype.destroy = function destroy() {
	
	    this._cancelNextFrame();
	    _EventDispatcher.prototype.destroy.call(this);
	
	    if (this._scrollTarget) {
	      if (this._scrollTarget.addEventListener) {
	        this._scrollTarget.removeEventListener('scroll', this.onScroll);
	        this._scrollTarget.removeEventListener('resize', this.onResize);
	      } else if (this._scrollTarget.attachEvent) {
	        this._scrollTarget.detachEvent('scroll', this.onScroll);
	        this._scrollTarget.detachEvent('resize', this.onResize);
	      }
	    }
	
	    // this.onResize = null;
	    // this.onScroll = null;
	    // this.getScrollPosition = null;
	    // this.onNextFrame = null;
	    delete this._scrollTarget.scrollFeatures;
	    this._scrollTarget = null;
	  };
	
	  ScrollFeatures.prototype.updateScrollPosition = function updateScrollPosition() {
	    this._y = this.y;
	    this._x = this.x;
	  };
	
	  ScrollFeatures.prototype.onScroll = function onScroll() {
	    this._currentStopFrames = 0;
	    if (this._firstRender) {
	      this._firstRender = false;
	      if (this.y > 1 || this.x > 1) {
	        this.updateScrollPosition();
	        this.trigger(ScrollFeatures.events.SCROLL_PROGRESS);
	        return;
	      }
	    }
	
	    if (!this._scrolling) {
	      this._scrolling = true;
	      this._maxSpeedY = 0;
	      this._lastDirectionY = ScrollFeatures.direction.none;
	      this._lastDirectionX = ScrollFeatures.direction.none;
	      this.trigger(ScrollFeatures.events.SCROLL_START);
	      this.cancelFrame = false;
	      (0, _raf2.default)(this.onNextFrame);
	    }
	  };
	
	  ScrollFeatures.prototype.onNextFrame = function onNextFrame() {
	    if (!this.cancelFrame) {
	      this._speedY = this._y - this.y;
	      this._speedX = this._x - this.x;
	
	      if (this._speedY < 0) {
	        this._maxSpeedY = this._speedY < this._maxSpeedY ? this._speedY : this._maxSpeedY;
	      } else if (this._speedY > 0) {
	        this._maxSpeedY = this._speedY > this._maxSpeedY ? this._speedY : this._maxSpeedY;
	      }
	
	      var speed = +this.speedY + +this.speedX;
	      if (this._scrolling && speed === 0 && this._currentStopFrames++ > this._stopFrames) {
	        this.onScrollStop();
	        return;
	      }
	
	      this.updateScrollPosition();
	
	      if (this._lastDirectionY !== this.directionY) {
	        this.trigger('scroll:' + (this.directionY === ScrollFeatures.direction.down ? 'down' : 'up'));
	      }
	      if (this._lastDirectionX !== this.directionX) {
	        this.trigger('scroll:' + (this.directionX === ScrollFeatures.direction.right ? 'right' : 'left'));
	      }
	
	      this._lastDirectionY = this.directionY;
	      this._lastDirectionX = this.directionX;
	
	      this.trigger(ScrollFeatures.events.SCROLL_PROGRESS);
	
	      (0, _raf2.default)(this.onNextFrame);
	    }
	  };
	
	  ScrollFeatures.prototype.onScrollStop = function onScrollStop() {
	
	    this._cancelNextFrame();
	    this._scrolling = false;
	
	    if (this._scrollTarget) {
	      this.updateScrollPosition();
	
	      this.trigger(ScrollFeatures.events.SCROLL_STOP);
	
	      if (this._canScrollY) {
	        if (this.y <= 0) {
	          this.trigger(ScrollFeatures.events.SCROLL_MIN);
	        } else if (this.y + this.clientHeight >= this.scrollHeight) {
	          this.trigger(ScrollFeatures.events.SCROLL_MAX);
	        }
	      }
	
	      if (this._canScrollX) {
	        if (this.x <= 0) {
	          this.trigger(ScrollFeatures.events.SCROLL_MIN);
	        } else if (this.x + this.clientWidth >= this.scrollWidth) {
	          this.trigger(ScrollFeatures.events.SCROLL_MAX);
	        }
	      }
	    } else {
	      this.trigger(ScrollFeatures.events.SCROLL_STOP);
	    }
	  };
	
	  ScrollFeatures.prototype._cancelNextFrame = function _cancelNextFrame() {
	    this.cancelFrame = true;
	    this._currentStopFrames = 0;
	  };
	
	  (0, _createClass3.default)(ScrollFeatures, [{
	    key: 'scrollPosition',
	    get: function get() {
	      return this.getScrollPosition();
	    }
	  }, {
	    key: 'directionY',
	    get: function get() {
	      if (!this._canScrollY || this.speedY === 0 && !this._scrolling) {
	        this._directionY = ScrollFeatures.direction.none;
	      } else {
	        if (this.speedY > 0) {
	          this._directionY = ScrollFeatures.direction.up;
	        } else if (this.speedY < 0) {
	          this._directionY = ScrollFeatures.direction.down;
	        }
	      }
	      return this._directionY;
	    }
	  }, {
	    key: 'directionX',
	    get: function get() {
	      if (!this._canScrollX || this.speedX === 0 && !this._scrolling) {
	        this._directionX = ScrollFeatures.direction.none;
	      } else {
	        if (this.speedX > 0) {
	          this._directionX = ScrollFeatures.direction.left;
	        } else if (this.speedX < 0) {
	          this._directionX = ScrollFeatures.direction.right;
	        }
	      }
	      return this._directionX;
	    }
	  }, {
	    key: 'scrollTarget',
	    get: function get() {
	      return this._scrollTarget;
	    }
	  }, {
	    key: 'scrolling',
	    get: function get() {
	      return this._scrolling;
	    }
	  }, {
	    key: 'speedY',
	    get: function get() {
	      return this._speedY;
	    }
	  }, {
	    key: 'speedX',
	    get: function get() {
	      return this._speedX;
	    }
	  }, {
	    key: 'maxSpeedY',
	    get: function get() {
	      return this._maxSpeedY;
	    }
	  }, {
	    key: 'canScrollY',
	    get: function get() {
	      return this._canScrollY;
	    }
	  }, {
	    key: 'canScrollX',
	    get: function get() {
	      return this._canScrollX;
	    }
	  }, {
	    key: 'y',
	    get: function get() {
	      return this.scrollPosition.y;
	    }
	  }, {
	    key: 'x',
	    get: function get() {
	      return this.scrollPosition.x;
	    }
	  }, {
	    key: 'clientHeight',
	    get: function get() {
	      return this._scrollTarget === window ? window.innerHeight : this._scrollTarget.clientHeight;
	    }
	  }, {
	    key: 'clientWidth',
	    get: function get() {
	      return this._scrollTarget === window ? window.innerWidth : this._scrollTarget.clientWidth;
	    }
	  }, {
	    key: 'scrollHeight',
	    get: function get() {
	      return this._scrollTarget === window ? ScrollFeatures.documentHeight : this._scrollTarget.scrollHeight;
	    }
	  }, {
	    key: 'scrollWidth',
	    get: function get() {
	      return this._scrollTarget === window ? ScrollFeatures.documentWidth : this._scrollTarget.scrollWidth;
	    }
	  }]);
	  return ScrollFeatures;
	}(_eventdispatcher2.default);
	
	ScrollFeatures.direction = {
	  up: -1,
	  down: 1,
	  none: 0,
	  right: 2,
	  left: -2
	};
	ScrollFeatures.events = {
	  SCROLL_PROGRESS: 'scroll:progress',
	  SCROLL_START: 'scroll:start',
	  SCROLL_STOP: 'scroll:stop',
	  SCROLL_DOWN: 'scroll:down',
	  SCROLL_UP: 'scroll:up',
	  SCROLL_MIN: 'scroll:min',
	  SCROLL_MAX: 'scroll:max',
	  SCROLL_RESIZE: 'scroll:resize'
	};
	exports.default = ScrollFeatures;
	module.exports = exports['default'];

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _PricingTable = __webpack_require__(41);
	
	var _PricingTable2 = _interopRequireDefault(_PricingTable);
	
	var _PricingTable3 = __webpack_require__(42);
	
	var _PricingTable4 = _interopRequireDefault(_PricingTable3);
	
	var _LoginTable = __webpack_require__(77);
	
	var _LoginTable2 = _interopRequireDefault(_LoginTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var auth = new _auth2.default();
	
	
	var hhsACx = 'clr-blue relative hhs';
	
	var BodyContent = function (_React$Component) {
	    _inherits(BodyContent, _React$Component);
	
	    function BodyContent(props) {
	        _classCallCheck(this, BodyContent);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            authenticated: false
	        };
	        return _this;
	    }
	
	    BodyContent.prototype.login = function login() {
	        //const type = {type: 'login'};
	        var email2 = { email: '' };
	        auth.login(email2);
	        this.setState({ authenticated: auth.isAuthenticated() }, function () {
	            // this.setState({username: auth.getUserName()})
	        });
	        this.setState({
	            username: auth.getUserName()
	        });
	        // this.setState({
	        //   authenticated: auth.isAuthenticated(),
	        // });
	    };
	
	    BodyContent.prototype.componentDidMount = function componentDidMount() {
	        if (auth.isAuthenticated()) {
	            this.setState({
	                authenticated: auth.isAuthenticated()
	            });
	        }
	    };
	
	    BodyContent.prototype.render = function render() {
	
	        console.log(this.props.freeOrNot);
	
	        var free = this.props.freeOrNot === '/processes/frontoffice/Pricing/' || this.props.freeOrNot === '/processes/frontoffice/PreDealChecks/' || this.props.freeOrNot === '/processes/frontoffice/TransactionExecution/' || this.props.freeOrNot === '/processes/operations/confirmations/' || this.props.freeOrNot === '/processes/operations/settlements/' || this.props.freeOrNot === '/processes/finance/accounting/' || this.props.freeOrNot === '/processes/credit_risk/credit_risk_control/' || this.props.freeOrNot === '/processes/market_risk/market_risk_control/' || this.props.freeOrNot === '/processes/frontoffice/' || this.props.freeOrNot === '/processes/operations/' || this.props.freeOrNot === '/processes/finance/' || this.props.freeOrNot === '/processes/credit_risk/' || this.props.freeOrNot === '/processes/market_risk/' || this.props.freeOrNot === '/concepts/trade_lifecycle_concepts/' || this.props.freeOrNot === '/concepts/risk_management_concepts' || this.props.freeOrNot === '/ftbModules/trade_lifecycle' || this.props.freeOrNot === '/ftbModules/new_entity' || this.props.freeOrNot === '/ftbModules/';
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            this.state.authenticated && _react2.default.createElement(
	                'span',
	                null,
	                this.props.content
	            ),
	            !this.state.authenticated && free && _react2.default.createElement(
	                'span',
	                null,
	                this.props.content
	            ),
	            !this.state.authenticated && !free && _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                    'section',
	                    { className: 'doc-content' },
	                    'Subscribe now or if you have already subscribed, ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            className: hhsACx,
	                            onClick: this.login.bind(this)
	                        },
	                        'sign in'
	                    ),
	                    ' here.',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(
	                        'table',
	                        { style: {
	                                border: '0px'
	                            } },
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(_PricingTable2.default, null)
	                            ),
	                            _react2.default.createElement('td', null)
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return BodyContent;
	}(_react2.default.Component);
	
	BodyContent.displayName = 'components/BodyContent';
	exports.default = BodyContent;
	module.exports = exports['default'];

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactModal = __webpack_require__(63);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _DisclaimerContainer = __webpack_require__(45);
	
	var _DisclaimerContainer2 = _interopRequireDefault(_DisclaimerContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description [renders meta data (yaml usually) as the hero el below breadcrumbs]
	 * @param {string|React.Element} description [paragraph below title]
	 * @param {string} label [small text right above the title]
	 * @param {string} path [the page route, for endpoint pages]
	 * @param {string} title [the title, used on non-endpoint pages (posts, etc)]
	 * @param {string} type [endpoint or not, used for styling and tabs]
	 * @return {React.Element}
	 */
	var Disclaimer = function Disclaimer(props) {
	  var showModal = props.showModal,
	      handleCloseModal = props.handleCloseModal,
	      hideModal = props.hideModal;
	
	
	  return _react2.default.createElement(
	    _reactModal2.default,
	    {
	      isOpen: showModal,
	      className: 'modal-container',
	      overlayClassName: 'modal-overlay',
	      contentLabel: 'Disclaimer Modal',
	      shouldCloseOnOverlayClick: false,
	      ariaHideApp: false
	    },
	    _react2.default.createElement(
	      'h4',
	      { className: 'modal-header' },
	      'Disclaimer'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'modal-body' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Do not rely on FTBC to make decisions regarding medical care. Always speak to your health provider about the risks and benefits of FDA-regulated products.  We may limit or otherwise restrict your access to the API in line with our ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'underline', to: '/terms/' },
	          ' Terms of Service'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'button bg-primary clr-white', onClick: function onClick() {
	          return handleCloseModal(hideModal);
	        } },
	      'ACCEPT'
	    )
	  );
	};
	
	Disclaimer.displayName = 'components/Disclaimer';
	exports.default = (0, _DisclaimerContainer2.default)(Disclaimer);
	module.exports = exports['default'];

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DocSidebarContainer = __webpack_require__(46);
	
	var _DocSidebarContainer2 = _interopRequireDefault(_DocSidebarContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Section = function Section(props) {
	  var isHeader = false;
	  var long_title = props.id;
	  if (props.collapse === true) {
	    isHeader = true;
	  }
	  return _react2.default.createElement(
	    "div",
	    { className: "pad-l-1 pad-b-2" },
	    _react2.default.createElement(
	      "h3",
	      { className: isHeader ? "row sidebar-cross" + (props.activeHeader.indexOf(long_title) > -1 ? ' ' : ' collapsed') : ' ',
	        title: long_title,
	        onClick: props.toggleSection },
	      props.title
	    ),
	    _react2.default.createElement(SectionLinks, _extends({}, props, {
	      isTutorial: long_title === "Tutorial"
	    }))
	  );
	};
	
	var SectionLinks = function SectionLinks(props) {
	
	  return _react2.default.createElement(
	    "ul",
	    { className: props.collapse ? props.activeHeader.indexOf(props.id) > -1 ? 'display-block' : 'display-none' : ' ' },
	    props.items.map(function (item, index) {
	      return _react2.default.createElement(SectionLink, {
	        node: item,
	        children: item.items,
	        key: index,
	        toggleSection: props.toggleSection,
	        toggleMobileSidebar: props.toggleMobileSidebar,
	        activeHeader: props.activeHeader
	      });
	    })
	  );
	};
	
	var SectionLink = function SectionLink(props) {
	
	  var childnodes = null;
	  if (props.children) {
	    childnodes = props.children.map(function (childnode, index) {
	      return _react2.default.createElement(SectionLink, {
	        key: index,
	        node: childnode,
	        children: childnode.items,
	        toggleSection: props.toggleSection,
	        toggleMobileSidebar: props.toggleMobileSidebar,
	        activeHeader: props.activeHeader,
	        isChild: true });
	    });
	  }
	
	  var item = props.node;
	  var title = item.title;
	  var link = item.link;
	  var long_title = title;
	
	  var isHeader = false;
	  if (Object.keys(item).indexOf("link") === -1) {
	    isHeader = true;
	    long_title = item.id;
	  } else {
	    long_title = link.split('/').slice(2, -1).join('_');
	  }
	  var itemCx = (0, _classnames2.default)({
	    'row': true,
	    'sidebar-item': !isHeader,
	    'sidebar-header sidebar-cross': isHeader,
	    'depth-2': !props.isChild,
	    'depth-3': props.isChild
	  });
	
	  return _react2.default.createElement(
	    "li",
	    { style: { listStyleType: 'none' } },
	    Object.keys(item).indexOf("link") === -1 ? _react2.default.createElement(
	      "span",
	      { className: itemCx + (props.activeHeader.indexOf(long_title) > -1 ? ' ' : ' collapsed'),
	        title: long_title,
	        onClick: props.toggleSection },
	      title
	    ) : link.charAt(0) === "#" ? _react2.default.createElement(
	      "a",
	      { href: link, className: itemCx, onClick: props.toggleMobileSidebar },
	      title
	    ) : _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        to: link,
	        key: link,
	        className: itemCx,
	        activeClassName: "sidebar-item-active",
	        onClick: props.toggleMobileSidebar,
	        exact: true
	      },
	      title
	    ),
	    childnodes ? _react2.default.createElement(
	      "ul",
	      { className: item.collapse ? props.activeHeader.indexOf(long_title) > -1 ? 'display-block' : 'display-none' : ' ' },
	      childnodes
	    ) : null
	  );
	};
	
	var DocBreadcrumbs = function DocBreadcrumbs(props) {
	  var breadcrumb = "Choose a topic";
	
	  if (typeof window === 'undefined') return _react2.default.createElement(
	    "span",
	    null,
	    breadcrumb
	  );
	
	  props.yaml.map(function (section, i) {
	    section.items.map(function (item, j) {
	      if (Object.keys(item).indexOf("items") > -1) {
	        item.items.map(function (subItem, k) {
	          if (subItem.link === props.path) {
	            breadcrumb = subItem.title;
	          }
	        });
	      }
	      if (item.link === props.path) {
	        breadcrumb = item.title;
	      }
	    });
	  });
	  return _react2.default.createElement(
	    "span",
	    null,
	    breadcrumb
	  );
	};
	
	var DocSidebar = function DocSidebar(props) {
	  var activeHeader = props.activeHeader,
	      path = props.path,
	      yaml = props.yaml,
	      showMobileSidebar = props.showMobileSidebar,
	      toggleSection = props.toggleSection,
	      toggleMobileSidebar = props.toggleMobileSidebar;
	
	
	  var sidebarCx = (0, _classnames2.default)({
	    'doc-sidebar': true,
	    'tab-hide': !showMobileSidebar
	  });
	
	  return _react2.default.createElement(
	    "section",
	    { id: "doc-sidebar" },
	    _react2.default.createElement(
	      "div",
	      { className: "doc-sidebar-mobile", onClick: toggleMobileSidebar },
	      _react2.default.createElement(DocBreadcrumbs, { path: path, yaml: yaml }),
	      _react2.default.createElement("i", { className: "fa fa-angle-down fa-2x" })
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: sidebarCx },
	      yaml.map(function (section, index) {
	        return _react2.default.createElement(
	          "div",
	          { key: index },
	          _react2.default.createElement(Section, _extends({}, section, {
	            title: section.title,
	            index: index,
	            activeHeader: activeHeader,
	            toggleSection: toggleSection,
	            toggleMobileSidebar: toggleMobileSidebar
	          }))
	        );
	      })
	    )
	  );
	};
	
	DocSidebar.displayName = 'components/DocSidebar';
	exports.default = (0, _DocSidebarContainer2.default)(DocSidebar);
	module.exports = exports["default"];

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var links = [{
	  txt: 'Front To Back Culture Home',
	  url: 'http://www.fronttobackculture.com'
	}, {
	  txt: 'Available Topics',
	  url: '/about/topics_available'
	}, {
	  txt: 'Roadmap Topics',
	  url: '/about/topics_roadmap'
	}, {
	  txt: 'How to Use',
	  url: '/about/how_to_use'
	}, {
	  txt: 'Pricing',
	  url: '/about/pricing'
	}, {
	  txt: 'Terms of Service',
	  url: '/terms'
	}, {
	  txt: 'Privacy Policy',
	  url: '/privacy'
	}, {
	  txt: 'Contact Us',
	  url: 'mailto:ftbcAcademy@fronttobackculture.com.sg'
	}];
	
	var aCx = 'clr-white inline-block small';
	var hhsCx = 'col pad-r-1 flex-box align-end dir-column m-marg-t-2 m-marg-l-2 hhs';
	var hhsACx = 'clr-white relative hhs';
	
	// PreFooter should remain stateless
	// although, it technically isn't pure
	// but links should never change once pulled in
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      'footer',
	      {
	        id: 'footer',
	        className: 'bg-primary-darker relative row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container flex-box just-between no-wrap pad-t-3 pad-b-3 footer-container' },
	        _react2.default.createElement(
	          'ul',
	          {
	            'aria-label': 'FTBC address and phone number',
	            className: 'col d-2 clr-white small footer-left',
	            tabIndex: 0
	          },
	          _react2.default.createElement(
	            'li',
	            { className: 'marg-b-1', style: { listStyleType: 'none' } },
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.fronttobackculture.com/' },
	              _react2.default.createElement('img', {
	                alt: 'Go to Front to Back Culutre website',
	                width: '180px',
	                src: '/img/FTBCLogoWhite.png'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { style: { listStyleType: 'none' } },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Front To Back Culture Pte Ltd'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { style: { listStyleType: 'none' } },
	            '24 Lorong Telok #02-01'
	          ),
	          _react2.default.createElement(
	            'li',
	            { style: { listStyleType: 'none' } },
	            'Singapore 049036'
	          ),
	          _react2.default.createElement(
	            'li',
	            { style: { listStyleType: 'none' } },
	            '+65 98256909'
	          ),
	          _react2.default.createElement(
	            'li',
	            { style: { listStyleType: 'none' } },
	            _react2.default.createElement(
	              'a',
	              {
	                className: aCx,
	                href: 'https://www.fronttobackculture.com/' },
	              'Contact Front To Back Culture'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'nav',
	          {
	            className: 'd-2 m-marg-t-2',
	            'aria-label': 'FTBC links' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'link-columns' },
	            links.map(function (item, i) {
	              return _react2.default.createElement(
	                'li',
	                {
	                  key: i,
	                  className: 'marg-b-1', style: { listStyleType: 'none' } },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: aCx,
	                    rel: 'noopener noreferrer',
	                    target: '_blank',
	                    href: item.url },
	                  item.txt
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'flex-row dir-column footer-right' },
	          _react2.default.createElement(
	            'p',
	            { className: 'small clr-white italic' },
	            'Some links on this website may direct you to non-FTBC locations. FTBC does not endorse or guarantee the integrity of information on these external sites.'
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	Footer.displayName = 'components/Footer';
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var auth = new _auth2.default();
	// const hhsCx = 'pad-r-1 flex-box dir-column m-marg-t-2 m-marg-l-2 hhs'
	var hhsCx = '';
	var hhsACx = 'clr-white relative';
	// const hhsACx = 'clr-white relative hhs'
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      authenticated: false,
	      username: ''
	    };
	    // this.state = {
	    //   username: ''
	    // }
	    return _this;
	  }
	
	  Header.prototype.login = function login() {
	    //const type = {type: 'login'};
	    var email2 = { email: '' };
	    auth.login(email2);
	    this.setState({ authenticated: auth.isAuthenticated() }, function () {
	      // this.setState({username: auth.getUserName()})
	    });
	    this.setState({
	      username: auth.getUserName()
	    });
	    // this.setState({
	    //   authenticated: auth.isAuthenticated(),
	    // });
	  };
	
	  Header.prototype.logout = function logout() {
	    auth.logout();
	    this.setState({ authenticated: auth.isAuthenticated() }, function () {});
	    this.setState({
	      username: ''
	    });
	  };
	
	  Header.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      authenticated: auth.isAuthenticated(),
	      username: auth.getUserName()
	    });
	  };
	
	  Header.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (auth.isAuthenticated() && !prevState.authenticated) {
	      this.setState({
	        authenticated: auth.isAuthenticated(),
	        username: auth.getUserName()
	      });
	    }
	  };
	
	  Header.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'container clr-white smallest blue-nav-bar' },
	      _react2.default.createElement(
	        'div',
	        { className: hhsCx },
	        !this.state.authenticated && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#',
	              className: hhsACx,
	              onClick: this.login.bind(this)
	            },
	            'Sign In'
	          )
	        ),
	        this.state.authenticated && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#',
	              className: hhsACx,
	              onClick: this.logout.bind(this)
	            },
	            'Log Out',
	
	            //  auth.getUserName() && (
	            //   <span> | {auth.getUserName()} </span>                      
	            //  )
	            this.state.username && _react2.default.createElement(
	              'span',
	              null,
	              ' | ',
	              this.state.username,
	              ' '
	            ),
	
	            //  !auth.getUserName() && (
	            //   <span> | You are login </span>
	            //  )
	            !this.state.username && _react2.default.createElement(
	              'span',
	              null,
	              ' | You are signed in '
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', {
	        className: 'txt-c right flex-box clearfix',
	        style: {
	          // ie stuff, mobile stuff
	          fontSize: '13px',
	          // ie needs more width than others
	          maxWidth: '345px'
	        }
	      })
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	Header.displayName = 'components/Header';
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var auth = new _auth2.default();
	
	var buttonStyles = {
	  fontSize: "13px",
	  textAlign: "center",
	  color: "#fff",
	  outline: "none",
	  padding: "12px 60px",
	  boxShadow: "2px 5px 10px rgba(0,0,0,.1)",
	  backgroundColor: "rgb(255, 178, 56)",
	  borderRadius: "6px",
	  letterSpacing: "1.5px"
	};
	var email = '';
	var Login = function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Login);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      disabled: false,
	      buttonText: "Login"
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Login.prototype.login = function login(email) {
	    //const type = {type: 'signup'};
	    var email2 = { email: email };
	    //console.log(email);
	    auth.login(email2);
	  };
	
	  Login.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          style: buttonStyles,
	          onClick: function onClick(event) {
	            return _this2.login(email);
	          },
	          disabled: this.state.disabled
	        },
	        this.state.buttonText
	      )
	    );
	  };
	
	  return Login;
	}(_react2.default.Component);
	
	exports.default = Login;
	module.exports = exports["default"];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Login = __webpack_require__(76);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PricingTable = function PricingTable(_ref) {
	  var toggleSignUpModal = _ref.toggleSignUpModal;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Pricing' },
	    _react2.default.createElement(
	      'div',
	      { className: 'Pricing__header' },
	      _react2.default.createElement(
	        'span',
	        { className: 'Pricing__title' },
	        'Base price'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'Pricing__price' },
	        '$25',
	        _react2.default.createElement(
	          'span',
	          { className: 'Pricing__price-time' },
	          '/mo'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'Pricing__features' },
	      _react2.default.createElement(
	        'li',
	        null,
	        'Access to all 50+ articles'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Unlimited access to articles'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Growing roadmaps of topic'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        '8 functional areas'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'Pricing__footer' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Login2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'Pricing__meta' },
	          'No credit card required'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'style',
	      { jsx: true },
	      '\n      .Pricing {\n        border-radius: 6px;\n        background-color: #ffffff;\n        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);\n        border: solid 1px rgba(11, 15, 21, 0.05);\n        padding: 25px 30px;\n        position: relative;\n        width: 370px;\n      }\n      @media screen and (max-width: 400px) {\n        .HiddenAtSm {\n          display: none;\n        }\n      }\n      @media screen and (min-width: 400px) {\n        .Pricing {\n          padding: 40px 50px;\n        }\n      }\n      .Pricing__header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n      }\n      .Pricing__title {\n        font-size: 24px;\n        color: #7a7f87;\n        vertical-align: middle;\n      }\n      .Pricing__price {\n        font-size: 48px;\n        font-weight: bold;\n        color: #0b0d11;\n        vertical-align: middle;\n      }\n      .Pricing__price-time {\n        font-size: 24px;\n        font-weight: normal;\n      }\n      .Pricing__features {\n        list-style: none;\n        font-size: 18px;\n        color: #0b0d11;\n        margin-top: 30px;\n      }\n      .Pricing__features li::before {\n        content: \'\\f00c\';\n        margin-right: 10px;\n        font-family: FontAwesome;\n        font-size: 14px;\n        color: #2c59c5;\n      }\n      .Pricing__features li + li {\n        margin-top: 16px;\n      }\n      .Pricing__footer {\n        margin-top: 40px;\n        text-align: center;\n      }\n      .Pricing__meta {\n        margin-top: 20px;\n        font-size: 14px;\n        color: #7a7f87;\n      }\n    '
	    )
	  );
	};
	
	exports.default = PricingTable;
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _aria = __webpack_require__(44);
	
	var _aria2 = _interopRequireDefault(_aria);
	
	var _NavContainer = __webpack_require__(47);
	
	var _NavContainer2 = _interopRequireDefault(_NavContainer);
	
	var _Disclaimer = __webpack_require__(36);
	
	var _Disclaimer2 = _interopRequireDefault(_Disclaimer);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var linkCx = 'sub-menu-item no-underline';
	
	var hamStyl = Object.freeze({
	  borderRadius: '5px',
	  height: '3px',
	  marginTop: '-1px',
	  transformOrigin: 'center center 0',
	  transition: '0.3s ease'
	});
	
	var Nav = function Nav(props) {
	  var showMobileNav = props.showMobileNav,
	      showModal = props.showModal,
	      toggleMobileNav = props.toggleMobileNav,
	      closeMobileNav = props.closeMobileNav,
	      toggleDropdownContent = props.toggleDropdownContent,
	      hideDropdownContent = props.hideDropdownContent,
	      showDropdownContent = props.showDropdownContent,
	      handleOpenModal = props.handleOpenModal,
	      handleCloseModal = props.handleCloseModal,
	      activeDropdown = props.activeDropdown,
	      path = props.path,
	      style = props.style,
	      validated = props.validated;
	
	
	  var navCx = (0, _classnames2.default)({
	    'bg-white col d-5 flex-row': true,
	    'tab-hide': !showMobileNav
	  });
	
	  return _react2.default.createElement(
	    'nav',
	    { className: 'bg-white clr-gray flex-box dir-column main-nav-bar', style: style },
	    _react2.default.createElement(
	      'a',
	      {
	        href: '#hero',
	        className: 'visually-hidden' },
	      'Skip navigation, go to start of content'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container dir-column tab-pad-b-1 tab-pad-t-1 nav-bar' },
	        _react2.default.createElement(
	          'div',
	          { className: showMobileNav ? 'dir-column relative' : 'flex-row relative' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container d-40 align-center logo-wrapper relative' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                className: 'nav-logos',
	                to: '/' },
	              _react2.default.createElement('img', {
	                className: 'open-fda-logo',
	                alt: 'Go to ftbcAcademy homepage',
	                src: '/img/ftbcAcademyLogoBlack.png'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'absolute right d-hide',
	                onClick: toggleMobileNav,
	                style: {
	                  height: '25px',
	                  transform: 'rotate(0deg)',
	                  width: '36px'
	                }
	              },
	              _react2.default.createElement('span', {
	                className: 'absolute bg-primary block row',
	                style: _extends({}, hamStyl, {
	                  transform: showMobileNav ? 'translate3d(0, 10px, 0) rotate(45deg)' : 'translate3d(0, 0, 0) rotate(0deg)'
	                })
	              }),
	              _react2.default.createElement('span', {
	                className: 'absolute bg-primary block row',
	                style: _extends({}, hamStyl, {
	                  transform: 'translate3d(0, 10px, 0)',
	                  opacity: showMobileNav ? 0 : 1
	                })
	              }),
	              _react2.default.createElement('span', {
	                className: 'absolute bg-primary block row',
	                style: _extends({}, hamStyl, {
	                  transform: showMobileNav ? 'translate3d(0, 10px, 0) rotate(-45deg)' : 'translate3d(0, 20px, 0) rotate(0deg)'
	                })
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: navCx },
	            _react2.default.createElement(
	              'div',
	              { className: 'menu-container responsive-header', role: 'navigation' },
	              _react2.default.createElement(
	                'div',
	                { className: 'dropdown', onMouseLeave: hideDropdownContent, onMouseEnter: showDropdownContent },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    title: 'Home',
	                    to: '/',
	                    className: path === '/' ? 'menu-header header-selected emphasis' : activeDropdown === 'Home' ? 'menu-header emphasis' : 'menu-header',
	                    onClick: closeMobileNav
	                  },
	                  'Home'
	                ),
	                _react2.default.createElement('div', { className: path === '/' ? 'menu-header-underbar' : 'menu-header-underbar display-none', style: { width: 'calc(100% - 1em)' } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dropdown', onMouseLeave: hideDropdownContent, onMouseEnter: showDropdownContent },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    title: 'About',
	                    className: path.indexOf('about') >= 0 ? 'menu-header header-selected emphasis' : activeDropdown === 'About' ? 'menu-header emphasis' : 'menu-header',
	                    onTouchStart: toggleDropdownContent
	                  },
	                  'About ',
	                  _react2.default.createElement('i', { className: "fa fa-angle-down " + (showMobileNav ? 'display-none' : '') })
	                ),
	                _react2.default.createElement('div', { className: path.indexOf('about') >= 0 ? 'menu-header-underbar' : 'menu-header-underbar display-none' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: activeDropdown === 'About' ? 'dropdown-content display-block' : 'dropdown-content display-none' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'sub-menu-container', role: 'navigation' },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/about/introduction/', onClick: closeMobileNav },
	                      'What is ftbcAcademy'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/about/topics_available/', onClick: closeMobileNav },
	                      'Available Topics'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/about/topics_roadmap/', onClick: closeMobileNav },
	                      'Topics Roadmap'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/about/how_to_use/', onClick: closeMobileNav },
	                      'How to Use'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/about/contributors/', onClick: closeMobileNav },
	                      'Contributors'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/about/pricing/', onClick: closeMobileNav },
	                      'Pricing'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/about/updates/', onClick: closeMobileNav },
	                      'Updates'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dropdown', onMouseLeave: hideDropdownContent, onMouseEnter: showDropdownContent },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    title: 'FTBModules',
	                    className: path.indexOf('ftbModules') >= 0 ? 'menu-header header-selected emphasis' : activeDropdown === 'FTBModules' ? 'menu-header emphasis' : 'menu-header',
	                    onTouchStart: toggleDropdownContent
	                  },
	                  'FTB Modules',
	                  _react2.default.createElement('i', { className: "fa fa-angle-down " + (showMobileNav ? 'display-none' : '') })
	                ),
	                _react2.default.createElement('div', { className: path.indexOf('ftbModules') >= 0 ? 'menu-header-underbar' : 'menu-header-underbar display-none' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: activeDropdown === 'FTBModules' ? 'dropdown-content display-block' : 'dropdown-content display-none' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'sub-menu-container', role: 'navigation' },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/ftbModules/', onClick: closeMobileNav },
	                      'Overview'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/ftbModules/trade_lifecycle', onClick: closeMobileNav },
	                      'Trade Lifecycle'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/ftbModules/new_entity', onClick: closeMobileNav },
	                      'New Entity Setup'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dropdown', onMouseLeave: hideDropdownContent, onMouseEnter: showDropdownContent },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    title: 'Processes',
	                    className: path.indexOf('processes') >= 0 ? 'menu-header header-selected emphasis' : activeDropdown === 'Processes' ? 'menu-header emphasis' : 'menu-header',
	                    onTouchStart: toggleDropdownContent
	                  },
	                  'Processes',
	                  _react2.default.createElement('i', { className: "fa fa-angle-down " + (showMobileNav ? 'display-none' : '') })
	                ),
	                _react2.default.createElement('div', { className: path.indexOf('processes') >= 0 ? 'menu-header-underbar' : 'menu-header-underbar display-none' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: activeDropdown === 'Processes' ? 'dropdown-content display-block' : 'dropdown-content display-none' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'sub-menu-container', role: 'navigation' },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/processes/', onClick: closeMobileNav },
	                      'Overview'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/processes/frontoffice/', onClick: closeMobileNav },
	                      'Front Office'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/processes/operations/', onClick: closeMobileNav },
	                      'Operations'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/processes/finance/', onClick: closeMobileNav },
	                      'Finance'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/processes/credit_risk/', onClick: closeMobileNav },
	                      'Credit Risk'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/processes/market_risk/', onClick: closeMobileNav },
	                      'Market Risk'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'dropdown', onMouseLeave: hideDropdownContent, onMouseEnter: showDropdownContent },
	                _react2.default.createElement(
	                  'span',
	                  {
	                    title: 'Concepts',
	                    className: path.indexOf('concepts') >= 0 ? 'menu-header header-selected emphasis' : activeDropdown === 'Concepts' ? 'menu-header emphasis' : 'menu-header',
	                    onTouchStart: toggleDropdownContent
	                  },
	                  'Concepts',
	                  _react2.default.createElement('i', { className: "fa fa-angle-down " + (showMobileNav ? 'display-none' : '') })
	                ),
	                _react2.default.createElement('div', { className: path.indexOf('concepts') >= 0 ? 'menu-header-underbar' : 'menu-header-underbar display-none' }),
	                _react2.default.createElement(
	                  'div',
	                  { className: activeDropdown === 'Concepts' ? 'dropdown-content display-block' : 'dropdown-content display-none' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'sub-menu-container', role: 'navigation' },
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/concepts/', onClick: closeMobileNav },
	                      'Overview'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/concepts/trade_lifecycle_concepts/', onClick: closeMobileNav },
	                      'Trade Lifecycle'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/concepts/risk_management_concepts/', onClick: closeMobileNav },
	                      'Risk Management'
	                    ),
	                    _react2.default.createElement(
	                      _gatsbyLink2.default,
	                      { className: linkCx, to: '/concepts/banking_concepts/bank_concepts/risk_origination', onClick: closeMobileNav },
	                      'Banking'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	Nav.displayName = 'components/Nav';
	exports.default = (0, _NavContainer2.default)(Nav);
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkout = __webpack_require__(21);
	
	var _checkout2 = _interopRequireDefault(_checkout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PricingTable = function PricingTable(_ref) {
	  var toggleSignUpModal = _ref.toggleSignUpModal;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Pricing' },
	    _react2.default.createElement(
	      'div',
	      { className: 'Pricing__header' },
	      _react2.default.createElement(
	        'span',
	        { className: 'Pricing__title' },
	        'One Time Special'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'Pricing__price' },
	        '$25'
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'Pricing__features', style: {
	          paddingLeft: '0px'
	        } },
	      _react2.default.createElement(
	        'li',
	        { style: { listStyle: 'none' } },
	        'Once off charge'
	      ),
	      _react2.default.createElement(
	        'li',
	        { style: { listStyle: 'none' } },
	        'Access to all existing articles'
	      ),
	      _react2.default.createElement(
	        'li',
	        { style: { listStyle: 'none' } },
	        'Access to all new articles that will be introduce in 2019'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'Pricing__footer' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_checkout2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'Pricing__meta' },
	          'Prices in SGD'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'style',
	      { jsx: true },
	      '\n      .Pricing {\n        border-radius: 6px;\n        background-color: #ffffff;\n        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);\n        border: solid 1px rgba(11, 15, 21, 0.05);\n        padding: 25px 30px;\n        position: relative;\n        width: 370px;\n      }\n      @media screen and (max-width: 400px) {\n        .HiddenAtSm {\n          display: none;\n        }\n      }\n      @media screen and (min-width: 400px) {\n        .Pricing {\n          padding: 40px 50px;\n        }\n      }\n      .Pricing__header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n      }\n      .Pricing__title {\n        font-size: 24px;\n        color: #7a7f87;\n        vertical-align: middle;\n      }\n      .Pricing__price {\n        font-size: 48px;\n        font-weight: bold;\n        color: #0b0d11;\n        vertical-align: middle;\n      }\n      .Pricing__price-time {\n        font-size: 24px;\n        font-weight: normal;\n      }\n      .Pricing__features {\n        list-style: none;\n        font-size: 18px;\n        color: #0b0d11;\n        margin-top: 30px;\n      }\n      .Pricing__features li::before {\n        content: \'\\f00c\';\n        margin-right: 10px;\n        font-family: FontAwesome;\n        font-size: 14px;\n        color: #2c59c5;\n      }\n      .Pricing__features li + li {\n        margin-top: 16px;\n      }\n      .Pricing__footer {\n        margin-top: 40px;\n        text-align: center;\n      }\n      .Pricing__meta {\n        margin-top: 20px;\n        font-size: 14px;\n        color: #7a7f87;\n      }\n    '
	    )
	  );
	};
	
	exports.default = PricingTable;
	module.exports = exports['default'];

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkout = __webpack_require__(21);
	
	var _checkout2 = _interopRequireDefault(_checkout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PricingTable = function PricingTable(_ref) {
	  var toggleSignUpModal = _ref.toggleSignUpModal;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Pricing' },
	    _react2.default.createElement(
	      'div',
	      { className: 'Pricing__header' },
	      _react2.default.createElement(
	        'span',
	        { className: 'Pricing__title' },
	        'Subscribe Price'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'Pricing__price' },
	        '$50',
	        _react2.default.createElement(
	          'span',
	          { className: 'Pricing__price-time' },
	          '/mo'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'Pricing__features', style: {
	          paddingLeft: '0px'
	        } },
	      _react2.default.createElement(
	        'li',
	        { style: { listStyle: 'none' } },
	        'Access to all 50+ articles on Trade Lifecycle'
	      ),
	      _react2.default.createElement(
	        'li',
	        { style: { listStyle: 'none' } },
	        '12 months unlimited access to content on ftbcAcademy'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'Pricing__footer' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'Pricing__meta' },
	          'Pricing post launch period starting 1st Oct 2018. Prices in SGD'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'style',
	      { jsx: true },
	      '\n      .Pricing {\n        border-radius: 6px;\n        background-color: #ffffff;\n        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);\n        border: solid 1px rgba(11, 15, 21, 0.05);\n        padding: 25px 30px;\n        position: relative;\n        width: 400px;\n      }\n      @media screen and (max-width: 400px) {\n        .HiddenAtSm {\n          display: none;\n        }\n      }\n      @media screen and (min-width: 400px) {\n        .Pricing {\n          padding: 40px 50px;\n        }\n      }\n      .Pricing__header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n      }\n      .Pricing__title {\n        font-size: 24px;\n        color: #7a7f87;\n        vertical-align: middle;\n      }\n      .Pricing__price {\n        font-size: 48px;\n        font-weight: bold;\n        color: #0b0d11;\n        vertical-align: middle;\n      }\n      .Pricing__price-time {\n        font-size: 24px;\n        font-weight: normal;\n      }\n      .Pricing__features {\n        list-style: none;\n        font-size: 18px;\n        color: #0b0d11;\n        margin-top: 30px;\n      }\n      .Pricing__features li::before {\n        content: \'\\f00c\';\n        margin-right: 10px;\n        font-family: FontAwesome;\n        font-size: 14px;\n        color: #2c59c5;\n      }\n      .Pricing__features li + li {\n        margin-top: 16px;\n      }\n      .Pricing__footer {\n        margin-top: 40px;\n        text-align: center;\n      }\n      .Pricing__meta {\n        margin-top: 20px;\n        font-size: 14px;\n        color: #7a7f87;\n      }\n    '
	    )
	  );
	};
	
	exports.default = PricingTable;
	module.exports = exports['default'];

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StickySidebar = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StickySidebar = exports.StickySidebar = function (_React$Component) {
	  _inherits(StickySidebar, _React$Component);
	
	  function StickySidebar(props) {
	    _classCallCheck(this, StickySidebar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.scrollListener = _this.scrollListener.bind(_this);
	    return _this;
	  }
	
	  StickySidebar.prototype.componentDidMount = function componentDidMount() {
	    var setInitialHeights = function setInitialHeights(elements) {
	      [].forEach.call(elements, function (sticky) {
	        sticky.setAttribute('data-sticky-initial', sticky.getBoundingClientRect().top);
	      });
	    };
	
	    var stickies = document.querySelectorAll('[data-sticky]');
	    setInitialHeights(stickies);
	
	    document.addEventListener('scroll', this.scrollListener);
	  };
	
	  StickySidebar.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('scroll', this.scrollListener);
	  };
	
	  StickySidebar.prototype.scrollListener = function scrollListener() {
	    var _this2 = this;
	
	    var stickies = document.querySelectorAll('[data-sticky]');
	    var top = document.documentElement.scrollTop || document.body.scrollTop;
	    var bottom = document.documentElement.scrollHeight || document.body.scrollHeight;
	
	    [].forEach.call(stickies, function (sticky) {
	      var stickyInitial = parseInt(sticky.getAttribute('data-sticky-initial'), 10);
	      var stickyEnter = parseInt(sticky.getAttribute('data-sticky-enter'), 10) || stickyInitial;
	      var stickyExit = parseInt(sticky.getAttribute('data-sticky-exit'), 10) || bottom;
	
	      var stickySidebar = false;
	
	      if (document.getElementById('sticky-sidebar').clientHeight < document.getElementById('body-doc-container').clientHeight) {
	        stickySidebar = true;
	      }
	
	      if (stickySidebar) {
	        if (top >= stickyEnter && top <= stickyExit) {
	          sticky.classList.add('sticky-sidebar');
	          !_this2.props.sidebarFixed && _this2.props.toggleFixed(true);
	        } else {
	          sticky.classList.remove('sticky-sidebar');
	          _this2.props.sidebarFixed && _this2.props.toggleFixed(false);
	        }
	      } else if (sticky.classList.contains('sticky-sidebar')) {
	        sticky.classList.remove('sticky-sidebar');
	        _this2.props.sidebarFixed && _this2.props.toggleFixed(false);
	      }
	    });
	  };
	
	  StickySidebar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        enter = _props.enter,
	        exit = _props.exit,
	        children = _props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'Sticky ' + className,
	        id: 'sticky-sidebar',
	        'data-sticky': true,
	        'data-sticky-enter': enter,
	        'data-sticky-exit': exit
	      },
	      children
	    );
	  };
	
	  return StickySidebar;
	}(_react2.default.Component);
	
	StickySidebar.propTypes = {
	  className: _react2.default.PropTypes.string,
	  enter: _react2.default.PropTypes.string,
	  exit: _react2.default.PropTypes.string,
	  children: _react2.default.PropTypes.node
	};
	
	exports.default = StickySidebar;

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var auth = new _auth2.default();
	
	// hardcoded amount (in US cents) to charge users
	// you could set this variable dynamically to charge different amounts
	var amount = 2500;
	var cardStyles = {
	  display: "flex",
	  flexDirection: "column",
	  justifyContent: "space-around",
	  alignItems: "flex-start",
	  padding: "3rem",
	  boxShadow: "5px 5px 25px 0 rgba(46,61,73,.2)",
	  backgroundColor: "#fff",
	  borderRadius: "6px",
	  maxWidth: "400px"
	};
	// const buttonStyles = {
	//   fontSize: "13px",
	//   textAlign: "center",
	//   color: "#fff",
	//   outline: "none",
	//   padding: "12px 60px",
	//   boxShadow: "2px 5px 10px rgba(0,0,0,.1)",
	//   // backgroundColor: "#2196f3",
	//   borderRadius: "6px",
	//   letterSpacing: "1.5px",
	// };
	
	// Below is where the checkout component is defined.
	// It has several functions, and some default state variables.
	var Checkout = function (_React$Component) {
	  _inherits(Checkout, _React$Component);
	
	  function Checkout() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Checkout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      disabled: false,
	      buttonText: "SUBSCRIBE NOW",
	      paymentMessage: "",
	      backgroundColor: "#2196f3",
	      stages: ""
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Checkout.prototype.login = function login(email) {
	    //const type = {type: 'signup'};
	    var email2 = { email: email };
	    //console.log(email);
	    auth.login(email2);
	  };
	
	  Checkout.prototype.resetButton = function resetButton() {
	    this.setState({ disabled: false, backgroundColor: "#2196f3", buttonText: "SUBSCRIBE NOW" });
	  };
	
	  Checkout.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.stripeHandler = StripeCheckout.configure({
	      // You’ll need to add your own Stripe public key to the `checkout.js` file.
	      // key: 'pk_test_STRIPE_PUBLISHABLE_KEY',
	      //key: "pk_test_3fFW5HBGfB5gUSMdFtFUg1sK",
	      key: "pk_live_qJyqeuXML1bciXDdz0sPwQrd",
	      closed: function closed() {
	        // this.setState({stage: "",});
	        _this2.resetButton();
	      }
	    });
	
	    if (auth.isAuthenticated()) {
	      this.setState({ disabled: true, backgroundColor: "#4caf50", stage: "", buttonText: "PURCHASED" });
	    }
	  };
	
	  Checkout.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // console.log(prevProps);
	    // console.log(prevState);
	    if (prevState.stage != "AlreadySubscribed" && this.state.stage === "AlreadySubscribed") {
	      this.setState({ backgroundColor: "#f44336", stage: "AlreadySubscribed", disabled: true, buttonText: "Payment Failed. You are already subscribed" });
	    }
	    if (prevState.stage != "PaymentFailed" && this.state.stage === "PaymentFailed") {
	      this.setState({ backgroundColor: "#f44336", stage: "PaymentFailed", disabled: true, buttonText: "Payment Failed. Try Again" });
	    }
	    if (prevState.stage != "Error" && this.state.stage === "Error") {
	      this.setState({ backgroundColor: "#f44336", stage: "Error", disabled: true, buttonText: "Error, Try Again" });
	    }
	    if (this.state.stage === "Payment" && this.state.buttonText === "SUBSCRIBE NOW") {
	      this.setState({ disabled: true, backgroundColor: "#009688", buttonText: "WAITING..." });
	    }
	    if (this.state.buttonText != "SUBSCRIBE NOW" && !auth.isAuthenticated() && this.state.stage != "Payment" && this.state.stage != "AlreadySubscribed" && this.state.stage != "PaymentFailed" && this.state.stage != "Error") {
	      this.setState({ disabled: false, backgroundColor: "#2196f3", buttonText: "SUBSCRIBE NOW" });
	    }
	  };
	
	  Checkout.prototype.openStripeCheckout = function openStripeCheckout(event) {
	    var _this3 = this;
	
	    event.preventDefault();
	    this.setState({ disabled: true, stage: "Payment", buttonText: "WAITING..." });
	    this.stripeHandler.open({
	      name: "ftbcAcademy Special",
	      currency: 'sgd',
	      amount: amount,
	      description: "1 time charge for 2019 full access",
	      token: function token(_token) {
	        fetch("https://4u5encr06m.execute-api.us-east-1.amazonaws.com/dev/checkout", {
	          method: "POST",
	          body: JSON.stringify({
	            token: _token,
	            amount: amount
	          }),
	          headers: new Headers({
	            "Content-Type": "application/json"
	          })
	        }).then(function (res) {
	          // this.login().bind(this);
	          _this3.setState({ disabled: true, stage: "Payment", backgroundColor: "#00695f", buttonText: "Pls wait for signup screen..." });
	          return res.json();
	        }).then(function (result) {
	          console.log(result);
	          console.log(result.error);
	          if (!result.error) {
	            console.log("Transaction processed successfully");
	            //this.setState({ backgroundColor: "#4caf50", buttonText: "Payment Successful!" });
	            _this3.setState({ disabled: true, backgroundColor: "#00695f", buttonText: "Pls wait for signup screen..." });
	            _this3.login(result.email);
	          } else {
	            if (result.error = "Must provide source or customer.") {
	              console.log("You are already subscribed");
	              _this3.setState({ backgroundColor: "#f44336", stage: "AlreadySubscribed", disabled: true, buttonText: "Payment Failed. You are already subscribed" });
	            } else {
	              console.log("Payment Failed");
	              _this3.setState({ backgroundColor: "#f44336", stage: "PaymentFailed", buttonText: "Payment Failed. Try Again" });
	            }
	          }
	          // console.log(result.email)
	          //this.login(result.email);
	        }).catch(function (error) {
	          console.log(error);
	          _this3.setState({ backgroundColor: "#f44336", stage: "Error", buttonText: "Error, Try Again" });
	        });
	      }
	    });
	  };
	
	  Checkout.prototype.render = function render() {
	    var _this4 = this;
	
	    var buttonStyles = {
	      fontSize: "13px",
	      textAlign: "center",
	      color: "#fff",
	      outline: "none",
	      padding: "12px 60px",
	      boxShadow: "2px 5px 10px rgba(0,0,0,.1)",
	      backgroundColor: this.state.backgroundColor,
	      borderRadius: "6px",
	      letterSpacing: "1.5px"
	    };
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "button",
	        {
	          style: buttonStyles,
	          onClick: function onClick(event) {
	            return _this4.openStripeCheckout(event);
	          },
	          disabled: this.state.disabled
	        },
	        this.state.buttonText
	      ),
	      this.state.paymentMessage
	    );
	  };
	
	  return Checkout;
	}(_react2.default.Component);
	
	exports.default = Checkout;
	module.exports = exports["default"];

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ARIA = Object.freeze({
	  hide: {
	    'aria-hidden': true,
	    role: 'presentation',
	    tabIndex: -1
	  }
	});
	
	exports.default = ARIA;
	module.exports = exports['default'];

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DisclaimerContainer = function DisclaimerContainer(ComposedDisclaimer) {
	  var HOC = function (_React$Component) {
	    _inherits(HOC, _React$Component);
	
	    function HOC() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, HOC);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	        showModal: false
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    HOC.prototype.componentDidMount = function componentDidMount() {
	      if (this.props.validated == false) {
	        this.setState({
	          showModal: true
	        });
	      }
	    };
	
	    HOC.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.validated == true && nextProps.validated == false) {
	        this.setState({
	          showModal: true
	        });
	      } else if (this.props.validated == false && nextProps.validated == true) {
	        this.setState({
	          showModal: false
	        });
	      }
	    };
	
	    HOC.prototype._hideModal = function _hideModal() {
	      this.setState({
	        showModal: false
	      });
	    };
	
	    HOC.prototype.render = function render() {
	      return _react2.default.createElement(ComposedDisclaimer, _extends({}, this.props, this.state, {
	        hideModal: this._hideModal.bind(this)
	      }));
	    };
	
	    return HOC;
	  }(_react2.default.Component);
	
	  return HOC;
	};
	
	exports.default = DisclaimerContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function checkArray(arr, path) {
	  var activeHeader = [];
	  for (var i = 0; i < arr.length; i++) {
	    if (Array.isArray(arr[i].items)) {
	      var header = checkObject(arr[i], path)[0];
	      if (typeof header != 'undefined') {
	        activeHeader.push(header);
	      }
	    }
	    if (path === arr[i].link) {
	      return [true, activeHeader];
	    }
	  }
	  return [false, activeHeader];
	}
	
	function checkObject(obj, path) {
	  var activeHeaders = [];
	  var active = checkArray(obj.items, path);
	  var id = obj.id;
	  if (active[0] === true) {
	    activeHeaders.push(id);
	  }
	  if (active[1].length > 0) {
	    activeHeaders.push.apply(activeHeaders, active[1]);
	  }
	  if (path.indexOf(obj.link) >= 0) {
	    activeHeaders.push(id);
	  }
	  return activeHeaders;
	}
	
	var DocSidebarContainer = function DocSidebarContainer(ComposedDocSidebar) {
	  var HOC = function (_React$Component) {
	    _inherits(HOC, _React$Component);
	
	    function HOC() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, HOC);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	        activeHeader: [],
	        path: ' ',
	        showMobileSidebar: false
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    HOC.prototype.componentDidMount = function componentDidMount() {
	      var activeHeaders = this.state.activeHeader;
	      var yaml = this.props.yaml;
	      var returnedHeaders = [];
	      for (var i = 0; i < yaml.length; i++) {
	        returnedHeaders.push(checkObject(yaml[i], window.location.pathname));
	      }
	      for (var _i = 0; _i < returnedHeaders.length; _i++) {
	        returnedHeaders[_i].length > 0 && (activeHeaders = activeHeaders.concat(returnedHeaders[_i]));
	      }
	      this.setState({
	        activeHeader: activeHeaders,
	        path: window.location.pathname
	      });
	    };
	
	    HOC.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	      if (this.state.path !== window.location.pathname) {
	        this.setState({
	          path: window.location.pathname
	        });
	      }
	      if (this.props.isSticky !== nextProps.isSticky) {
	        this.props.toggleFixed(nextProps.isSticky);
	      }
	    };
	
	    HOC.prototype._toggleMobileSidebar = function _toggleMobileSidebar() {
	      this.setState({
	        showMobileSidebar: !this.state.showMobileSidebar
	      });
	    };
	
	    HOC.prototype._toggleSection = function _toggleSection(e) {
	      var activeHeader = this.state.activeHeader.slice();
	      var title = e.target.getAttribute('title');
	      if (activeHeader.indexOf(title) === -1) {
	        activeHeader.push(title);
	        this.setState({
	          activeHeader: activeHeader
	        });
	      } else {
	        this.setState({
	          activeHeader: activeHeader.filter(function (t) {
	            return t !== title;
	          })
	        });
	      }
	    };
	
	    HOC.prototype.render = function render() {
	      return _react2.default.createElement(ComposedDocSidebar, _extends({}, this.props, this.state, {
	        toggleMobileSidebar: this._toggleMobileSidebar.bind(this),
	        toggleSection: this._toggleSection.bind(this)
	      }));
	    };
	
	    return HOC;
	  }(_react2.default.Component);
	
	  return HOC;
	};
	
	exports.default = DocSidebarContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavContainer = function NavContainer(ComposedNav) {
	  var HOC = function (_React$Component) {
	    _inherits(HOC, _React$Component);
	
	    function HOC() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, HOC);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	        showMobileNav: false,
	        showModal: false,
	        activeDropdown: ' ',
	        path: ' ',
	        validated: false
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    HOC.prototype.componentDidMount = function componentDidMount() {
	      this.setState({
	        path: window.location.pathname,
	        showModal: true
	      });
	    };
	
	    HOC.prototype.componentWillUpdate = function componentWillUpdate() {
	      if (this.state.path !== window.location.pathname) {
	        this.setState({
	          path: window.location.pathname
	        });
	      }
	    };
	
	    HOC.prototype._toggleMobileNav = function _toggleMobileNav() {
	      this.setState({
	        showMobileNav: !this.state.showMobileNav
	      });
	    };
	
	    HOC.prototype._closeMobileNav = function _closeMobileNav() {
	      this.setState({
	        showMobileNav: false
	      });
	    };
	
	    HOC.prototype._toggleDropdownContent = function _toggleDropdownContent(e) {
	      var title = e.target.getAttribute('title');
	      if (this.state.activeDropdown != title) {
	        this.setState({
	          activeDropdown: title
	        });
	      } else {
	        this.setState({
	          activeDropdown: ' '
	        });
	      }
	    };
	
	    HOC.prototype._hideDropdownContent = function _hideDropdownContent() {
	      if (this.state.showMobileNav === false) {
	        this.setState({
	          activeDropdown: ' '
	        });
	      }
	    };
	
	    HOC.prototype._showDropdownContent = function _showDropdownContent(e) {
	      if (this.state.showMobileNav === false) {
	        var title = e.target.getAttribute('title');
	        this.setState({
	          activeDropdown: title
	        });
	      }
	    };
	
	    HOC.prototype._handleOpenModal = function _handleOpenModal() {
	      this.setState({
	        validated: false,
	        showModal: true
	      });
	    };
	
	    HOC.prototype._handleCloseModal = function _handleCloseModal() {
	      this.setState({
	        validated: true,
	        showModal: false
	      });
	    };
	
	    HOC.prototype.render = function render() {
	      return _react2.default.createElement(ComposedNav, _extends({}, this.props, this.state, {
	        toggleMobileNav: this._toggleMobileNav.bind(this),
	        closeMobileNav: this._closeMobileNav.bind(this),
	        toggleDropdownContent: this._toggleDropdownContent.bind(this),
	        hideDropdownContent: this._hideDropdownContent.bind(this),
	        showDropdownContent: this._showDropdownContent.bind(this),
	        handleOpenModal: this._handleOpenModal.bind(this),
	        handleCloseModal: this._handleCloseModal.bind(this)
	      }));
	    };
	
	    return HOC;
	  }(_react2.default.Component);
	
	  return HOC;
	};
	
	exports.default = NavContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDocumentTitle = __webpack_require__(56);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _docLinks = __webpack_require__(1607);
	
	var _docLinks2 = _interopRequireDefault(_docLinks);
	
	var _Nav = __webpack_require__(40);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Footer = __webpack_require__(38);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _DocSidebar = __webpack_require__(37);
	
	var _DocSidebar2 = _interopRequireDefault(_DocSidebar);
	
	var _reactStickyState = __webpack_require__(66);
	
	var _reactStickyState2 = _interopRequireDefault(_reactStickyState);
	
	var _StickySidebar = __webpack_require__(43);
	
	var _StickySidebar2 = _interopRequireDefault(_StickySidebar);
	
	var _Header = __webpack_require__(39);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _auth = __webpack_require__(5);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _BodyContent = __webpack_require__(75);
	
	var _BodyContent2 = _interopRequireDefault(_BodyContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var auth = new _auth2.default();
	
	_reactDocumentTitle2.default.displayName = 'Document Title';
	
	var hhsCx = 'pad-r-1 flex-box dir-column m-marg-t-2 m-marg-l-2 hhs';
	var hhsACx = 'clr-white relative hhs';
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout(props) {
	    _classCallCheck(this, Layout);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      sidebarFixed: false
	    };
	
	    _this.toggleSidebarFixed = _this.toggleSidebarFixed.bind(_this);
	    return _this;
	  }
	
	  Layout.prototype.toggleSidebarFixed = function toggleSidebarFixed(fixed) {
	    this.setState({
	      sidebarFixed: fixed
	    });
	  };
	
	  Layout.prototype.render = function render() {
	    var scrollClass = {
	      down: 'sticky-scroll-down',
	      up: 'sticky-scroll-up'
	    };
	
	    var hasSidebar = this.props.location.pathname.slice(0, 10) === '/concepts/';
	
	    return _react2.default.createElement(
	      _reactDocumentTitle2.default,
	      { title: 'ftbcAcademy', key: 'ftbcAcademy' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'header-main menu-shadow bg-primary-darker pad-t-1 pad-b-1' },
	          _react2.default.createElement(_Header2.default, null)
	        ),
	        _react2.default.createElement(
	          _reactStickyState2.default,
	          { scrollClass: scrollClass },
	          _react2.default.createElement(
	            'div',
	            { className: 'sticky', id: 'nav' },
	            _react2.default.createElement(_Nav2.default, { meta: this.props.meta })
	          )
	        ),
	        hasSidebar && _react2.default.createElement(
	          'div',
	          {
	            className: 'body-container body-doc-container',
	            id: 'body-doc-container'
	          },
	          _react2.default.createElement(
	            _StickySidebar2.default,
	            {
	              enter: '58',
	              sidebarFixed: this.state.sidebarFixed,
	              toggleFixed: this.toggleSidebarFixed
	            },
	            _react2.default.createElement(_DocSidebar2.default, { inline: true, yaml: _docLinks2.default })
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'doc-container ' + (this.state.sidebarFixed ? 'fixed-padding' : ''),
	              id: 'doc-container'
	            },
	            _react2.default.createElement(_BodyContent2.default, {
	              content: this.props.children(),
	              freeOrNot: this.props.location.pathname
	            })
	          )
	        ),
	        !hasSidebar && _react2.default.createElement(
	          'div',
	          { className: 'body-container' },
	          this.props.children()
	        ),
	        !hasSidebar && _react2.default.createElement(_Footer2.default, null)
	      )
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.displayName = 'Layout';
	exports.default = Layout;
	module.exports = exports['default'];

/***/ }),

/***/ 1607:
/***/ (function(module, exports) {

	module.exports = [{"title":"Trade Lifecycle Concepts","id":"trade_lifecycle_concepts","collapse":true,"items":[{"title":"Pricing","id":"pricing","collapse":true,"items":[{"title":"Electronic quote","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_pricing/tlc_concepts_pricing_electronic_quote"},{"title":"Voice quote","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_pricing/tlc_concepts_pricing_voice_quote"},{"title":"Type of prices","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_pricing/tlc_concepts_pricing_price_type"},{"title":"Response Mode","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_pricing/tlc_concepts_pricing_response_mode"}]},{"title":"Confirmation types","id":"confirmation_types","collapse":true,"items":[{"title":"SWIFT","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_confirmation_types/tlc_concepts_confirmation_types_SWIFT"},{"title":"PAPER","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_confirmation_types/tlc_concepts_confirmation_types_PAPER"}]},{"title":"Confirmation general","id":"confirmation_general","collapse":true,"items":[{"title":"Confirmable attributes","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_confirmation_general/tlc_concepts_confirmation_general_confirmable_attributes"}]},{"title":"Settlement modes","id":"settlement_modes","collapse":true,"items":[{"title":"Gross","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_settlement_mode/gross"},{"title":"Netting","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_settlement_mode/netting"}]},{"title":"Settlement general","id":"settlement_general","collapse":true,"items":[{"title":"SWIFT settlement","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_settlement_general/settlement_swift"}]},{"title":"Accounting 101","id":"accounting_101","collapse":true,"items":[{"title":"Trial balance and general ledger","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_accounting101/tb_gl"},{"title":"P&L, Revenue, General Expenses","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_accounting101/pl_revenue_expense"},{"title":"Double entries - credit/debit","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_accounting101/double_entries"}]},{"title":"Terminologies","link":"/concepts/trade_lifecycle_concepts/tlc_concepts_terminology"}]},{"title":"Risk Management Concepts","id":"risk_management_concepts","collapse":true,"items":[{"title":"Credit risk factors","id":"credit_risk_factors","collapse":true,"items":[{"title":"Credit risk factors overview","link":"/concepts/risk_management_concepts/credit_risk_factors"}]},{"title":"Market risk factors","id":"market_risk_factors","collapse":true,"items":[{"title":"Market risk factors overview","link":"/concepts/risk_management_concepts/market_risk_factors"}]}]},{"title":"Operating Model Concepts","id":"om","collapse":true,"items":[{"title":"Operating Model Overview","link":"/concepts/operating_model"},{"title":"Risk Management Model","id":"rmm","collapse":true,"items":[{"title":"Risk Management Model Overview","link":"/concepts/operating_model/risk_mgmt_model"},{"title":"Global Risk Management model","link":"/concepts/operating_model/risk_mgmt_model/global_risk_mgmt_model"}]},{"title":"Booking Model Overview","link":"/concepts/operating_model/booking_model"},{"title":"Operational Support Model Overview","link":"/concepts/operating_model/operational_support_model"}]},{"title":"Banking Concepts","id":"bank","collapse":true,"items":[{"title":"Bank Concepts","id":"bcc","collapse":true,"items":[{"title":"Risk origination","link":"/concepts/banking_concepts/bank_concepts/risk_origination"}]}]}]

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _auth0Js = __webpack_require__(32);
	
	var _auth0Js2 = _interopRequireDefault(_auth0Js);
	
	var _gatsbyLink = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AUTH0_DOMAIN_OLD = 'fronttobackculture.au.auth0.com';
	var AUTH0_DOMAIN = 'login.fronttobackculture.com';
	var AUTH0_CLIENT_ID = 'c9DvEEC3855tnCppiivu-9jw_J6KxKED';
	// const type = {type: 'login'};
	
	var Auth = function () {
	  Auth.prototype.login = function login(email) {
	    this.auth0.authorize(email);
	  };
	
	  function Auth() {
	    _classCallCheck(this, Auth);
	
	    this.auth0 = new _auth0Js2.default.WebAuth({
	      domain: AUTH0_DOMAIN,
	      clientID: AUTH0_CLIENT_ID,
	      redirectUri: 'https://www.ftbcacademy.fronttobackculture.com/callback/',
	      //redirectUri: 'http://local.fronttobackculture.com:8000/callback',
	      audience: 'https://' + AUTH0_DOMAIN_OLD + '/api/v2/',
	      responseType: 'token id_token',
	      scope: 'openid profile email',
	      connection: 'Username-Password-Authentication'
	      //  overrides: {
	      //    __tenant: 'fronttobackculture',
	      //    __token_issuer: 'login.fronttobackculture.com'
	      //  },
	    });
	
	    this.login = this.login.bind(this);
	    this.logout = this.logout.bind(this);
	    this.handleAuthentication = this.handleAuthentication.bind(this);
	    this.isAuthenticated = this.isAuthenticated.bind(this);
	  }
	
	  Auth.prototype.logout = function logout() {
	    localStorage.removeItem('access_token');
	    localStorage.removeItem('id_token');
	    localStorage.removeItem('expires_at');
	    localStorage.removeItem('user');
	  };
	
	  Auth.prototype.handleAuthentication = function handleAuthentication() {
	    var _this = this;
	
	    if (typeof window !== 'undefined') {
	      console.log('i am here');
	      console.log(typeof window);
	      this.auth0.parseHash(function (err, authResult) {
	        if (authResult && authResult.accessToken && authResult.idToken) {
	          _this.setSession(authResult);
	        } else if (err) {
	          console.log(err);
	        }
	
	        // Return to the homepage after authentication.
	        (0, _gatsbyLink.navigateTo)('/');
	      });
	    }
	  };
	
	  Auth.prototype.isAuthenticated = function isAuthenticated() {
	    var expiresAt = JSON.parse(localStorage.getItem('expires_at'));
	    return new Date().getTime() < expiresAt;
	  };
	
	  Auth.prototype.setSession = function setSession(authResult) {
	    console.log(authResult);
	    var expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
	    localStorage.setItem('access_token', authResult.accessToken);
	    localStorage.setItem('id_token', authResult.idToken);
	    localStorage.setItem('expires_at', expiresAt);
	
	    this.auth0.client.userInfo(authResult.accessToken, function (err, user) {
	      localStorage.setItem('user', JSON.stringify(user));
	    });
	  };
	
	  Auth.prototype.getUser = function getUser() {
	    if (localStorage.getItem('user')) {
	      return JSON.parse(localStorage.getItem('user'));
	    }
	  };
	
	  Auth.prototype.getUserName = function getUserName() {
	    if (this.getUser()) {
	      return this.getUser().name;
	    }
	  };
	
	  return Auth;
	}();
	
	exports.default = Auth;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-concepts-js-d2e10a1231d2aa51fc0e.js